import moment from 'moment';
import GoogleMapReact from 'google-map-react';
import { chunk, round } from 'lodash';

import {
  Listing,
  Listings,
  Coordinates,
  Bounds,
  TailoredRegionMarkers,
  ADR,
  OccupancyRate,
  Revenue,
  TempObject,
  DigestCardGraphData,
  Host,
  UtilityData,
  ListViewData,
  BookingsPerMonth,
  ActivityRate,
  Booking,
  PieChartData,
  AmenitiesAndResearch,
  PreviewTextObj,
  NearbyRecommendedMarket,
  Rate,
  MarketOverview,
  EstimatorRegions,
  ListingVal,
  Search,
  BarGraphData,
  ListingLegacy,
  ListingsLegacy,
  ListingValLegacy,
  RechartsDataFormat,
  Compsets,
  RateAndAvailChanges,
  ParsedGuest,
  MonthlyListingPerformance,
  PriceTiers,
  SubscriptionPlan,
} from '../interfaces/idashboard';
import { FilterVal, ListingsProp, SearchProp, VisibleListingsProp } from '../interfaces/iproptypes';
import {
  AIRBTICS_PRO_BANNER_LOCALSTORAGE_VARIABLE,
  amenitiesObject,
  COLOR_GREEN,
  COLOR_RED_LIGHT,
  COLOR_YELLOW,
  COMPETITOR_RATES_COLORS,
  DATA_VERIFICATION_ATTEMPT_TRACKER_LS_KEY,
  daysInMonth,
  exchangeRates,
  LIGHT_GREY,
  mapStyles,
  FREE_MARKET_SEARCH_LIMIT,
  sampleMarket,
  TOP_BANNER_PADDING,
  TOP_BANNER_PADDING_MOBILE,
  NAV_BAR_DYNAMIC_SVG_SIMPLE,
  OVERVIEW_DASHBOARD_FILTER_DEMO_DATA,
  countryListWithCode,
  US_CENTER,
  FIXED_CENTER_FOR_US_IN_MOBILE_VIEW,
  UK_CENTER,
  FIXED_CENTER_FOR_UK_IN_MOBILE_VIEW,
  DISCOVERY_API_CACHE_DURATION,
  AU_CENTER,
  FIXED_CENTER_FOR_AU_IN_MOBILE_VIEW,
  CA_CENTER,
  FIXED_CENTER_FOR_CA_IN_MOBILE_VIEW,
  AVAILABLE_COUNTRY,
  DUMMY_MARKET_AS_PER_SIGNUP_COUNTRY_CODE,
  shortMonthNames,
  mlaMonthsShort,
  MONTHLY_TOP_HOST_LIMIT,
  BEST_AIRBNB_MARKET_COUNTRY_CODE_MAP,
  ALL_COUNTRY,
  COUNTRY_ALIASES,
  BEST_MARKET_BLOGS_WITH_THE_PREFIX,
  RoutesMap,
  ProductIDOptions,
} from '../const';
import '../App/Dashboards/Dashboard.scss';

import * as d3 from 'd3';
// import * as CryptoJS from "crypto-js";
// import * as fernet from "fernet";
import { Loader } from '@googlemaps/js-api-loader';
import { User } from 'src/interfaces/iuser';
import { callApi } from 'src/core/callApi';
import { CachedMarketDataTypes } from 'src/interfaces/apiTypes';
import { US_POLYGON } from 'src/CountryPolygons/USPolygon';
import { UK_POLYGON } from 'src/CountryPolygons/UKPolygon';
import { AU_POLYGON } from 'src/CountryPolygons/AUPolygon';
import { CA_POLYGON } from 'src/CountryPolygons/CAPolygon';
import { number } from 'prop-types';
import { GOOGLE_MAPS_API_KEY } from 'src/keys';
import { useHistory } from 'react-router-dom';
import { timeZoneCCMap } from 'src/App/assets/timeZoneCCMap';
import { timeZoneCoordinatesMap } from 'src/App/assets/timeZoneCoordsMap';
import bbox from '@turf/bbox';
import * as turf from '@turf/helpers';
const classifyPoint = require('robust-point-in-polygon');

export function setMarkerParams(markerParam, bounds, marketBoundary = null) {
  markerParam['nwLat'] = bounds['nw']['lat'];
  markerParam['nwLng'] = bounds['nw']['lng'];
  markerParam['seLat'] = bounds['se']['lat'];
  markerParam['seLng'] = bounds['se']['lng'];
  if (marketBoundary) {
    markerParam['marketPolygon'] = marketBoundary;
  }
}

const processMultiPolygon = (multiPolygonRaw: string) => {
  multiPolygonRaw = multiPolygonRaw.replace('MULTIPOLYGON ', '');
  multiPolygonRaw = multiPolygonRaw.replace('((', '');
  multiPolygonRaw = multiPolygonRaw.replace('))', '');
  const processedMultiPolygonRaw = multiPolygonRaw.split('), ');

  let polygons = [] as Coordinates[][];
  processedMultiPolygonRaw.forEach((polygon, index) => {
    polygon = polygon.replace('(', '');
    polygon = polygon.replace(')', '');
    const processedPolygon = polygon.split(', ');

    let coordinates: Coordinates[] = [];

    processedPolygon.forEach((item, index) => {
      let x = item.split(' ');
      if (!isNaN(parseFloat(x[0])) && !isNaN(parseFloat(x[1])))
        coordinates.push({ lng: parseFloat(x[0]), lat: parseFloat(x[1]) });
    });

    polygons.push(coordinates);
  });

  const polygon = polygons[0];
  const firstCoordinate = polygon[0];
  const lastCoordinate = polygon[polygon.length - 1];
  if (!areCoordinatesSame(firstCoordinate, lastCoordinate)) {
    polygons[0].push(firstCoordinate);
  }
  return polygons;
};

export const isDateBeforeFourWeeks = dateString => {
  if (dateString) {
    const inputDate = new Date(dateString);
    const currentDate = new Date();
    if (inputDate > currentDate) {
      return true;
    }

    const oneWeeksAgo = new Date();
    oneWeeksAgo.setDate(currentDate.getDate() - 4 * 7); // 4 weeks = 4 * 7 days

    return inputDate < oneWeeksAgo;
  }
  return false;
};

export const areCoordinatesSame = (coord1, coord2) => {
  if (coord1.lat == coord2.lat && coord1.lon == coord2.lon) return true;
  return false;
};

export const processPolygon = (polygonRaw: string, multiPolygonRaw: string) => {
  if (!polygonRaw) {
    return processMultiPolygon(multiPolygonRaw);
  }
  polygonRaw = polygonRaw.replace('POLYGON', '').trim();
  polygonRaw = polygonRaw.replace('((', '').trim();
  polygonRaw = polygonRaw.replace('))', '').trim();

  const processedPolygonRaw = polygonRaw.split(',');
  let polygons = [] as Coordinates[][];
  let coordinates: Coordinates[] = [];

  processedPolygonRaw.forEach((item, index) => {
    let x = item.trim().split(' ');
    if (!isNaN(parseFloat(x[0])) && !isNaN(parseFloat(x[1])))
      coordinates.push({ lng: parseFloat(x[0]), lat: parseFloat(x[1]) });
  });
  polygons.push(coordinates);

  const polygon = polygons[0];
  const firstCoordinate = polygon[0];
  const lastCoordinate = polygon[polygon.length - 1];
  if (!areCoordinatesSame(firstCoordinate, lastCoordinate)) {
    polygons[0].push(firstCoordinate);
  }

  return polygons;
};

// export const processEncryptedKpis = (kpi: string | number, key: string, iv: any) => {
//   if(!isNaN(Number(kpi))){
//     return Number(kpi);
//   }

//   let decrypted = CryptoJS.AES.decrypt(kpi, key, { iv: iv, mode: CryptoJS.mode.CBC });
//   decrypted = decrypted.toString(CryptoJS.enc.Utf8);

//   return Number(decrypted);
// }

const processBatch = (batchListings, isUserAllowed) => {
  const retBatch = {};
  const defaultAmenities = {
    parking: false,
    hot_tub: false,
    gym: false,
    pets: false,
    dryer: false,
    washer: false,
    pool: false,
    kitchen: false,
    ac: false,
    wifi: false,
    heating: false,
    tv: false,
    bbq_grill: false,
    fireplace: false,
    breakfast: false,
    beachfront: false,
    amazing_views: false,
  };
  for (const listing of batchListings) {
    try {
      const [
        listingID,
        name,
        thumbnail_url,
        latitude,
        longitude,
        room_type,
        property_type,
        bedrooms,
        bathrooms,
        accommodates,
        host_name,
        minimum_nights,
        hostListingCount,
        cleaningFee,
        extraGuestFee,
        review_scores_rating,
        amenities,
        visible_review_count,
        last_seen,
        cancellation_policy,
        hostId,
        adrLTM,
        occupancyRateLTM,
        annualRevenueLTM,
        activeDaysCount,
        revenuePotential,
        hasLicense,
        numberOfBookingsLTM,
        added_on,
        bookingComURL,
        vrboURL,
      ] = listing;

      const revPAN = Math.round(annualRevenueLTM / activeDaysCount);
      const revenueFromCleaningFeeLTM = cleaningFee
        ? Math.round(cleaningFee * numberOfBookingsLTM)
        : 0;

      const retListing = {
        name,
        thumbnail_url: thumbnail_url.includes('sample_comp_listing')
          ? `https://default-market-data-cache.s3.us-east-2.amazonaws.com/${thumbnail_url}`
          : `https://a0.muscache.com/im/pictures/${thumbnail_url}`,
        latitude,
        longitude,
        room_type,
        property_type,
        bedrooms,
        bathrooms,
        accommodates,
        host_name,
        minimum_nights,
        hostListingCount,
        cleaningFee,
        extraGuestFee,
        review_scores_rating,
        amenities: { ...defaultAmenities, ...amenities },
        visible_review_count,
        last_seen,
        cancellation_policy,
        hostId,
        adrLTM,
        occupancyRateLTM: Math.min(occupancyRateLTM, 95),
        annualRevenueLTM,
        activeDaysCount: Math.min(activeDaysCount, 365),
        revenuePotential,
        hasLicense: hasLicense === 'f' ? false : true,
        numberOfBookingsLTM,
        revPAN,
        revenueFromCleaningFeeLTM,
        added_on,
        bookingComURL,
        vrboURL,
      };

      retBatch[listingID] = retListing;
    } catch (error) {
      console.log('Error while loading marker:', error);
    }
  }
  return retBatch;
};

export const processListing = (listings, isUserAllowed = undefined, batchSize = 50) => {
  const retVals = {};
  if (!listings || listings === 'Failed to fetch') {
    return retVals;
  }

  for (let i = 0; i < listings.length; i += batchSize) {
    const batchListings = listings.slice(i, i + batchSize);
    const processedBatch = processBatch(batchListings, isUserAllowed);
    Object.assign(retVals, processedBatch);
  }

  return retVals;
};

export const processHistoricalData = (rawHistoricalData: { [index: string]: number[] }) => {
  let historicalMonthlyPerformance = {} as { [index: string]: MonthlyListingPerformance | null };
  Object.keys(rawHistoricalData).forEach(month => {
    const rawVal = rawHistoricalData[month];
    if (!rawVal) {
      historicalMonthlyPerformance[month] = null;
    } else {
      const adr = rawVal[0];
      const activeDaysCount = rawVal[1];
      const bookedDaysCount = rawVal[2];
      const numberOfBookings = rawVal[3];
      historicalMonthlyPerformance[month] = {
        adr,
        activeDaysCount,
        bookedDaysCount,
        numberOfBookings,
      };
    }
  });
  return historicalMonthlyPerformance;
};

export const getHistoricalMarketPerformance = (listings: Listing[]) => {
  let monthlyGroupedPerformance = {};
  let monthlyMarketPerformance = {};

  const months = Object.keys(listings[0].historicalMonthlyPerformance);

  months.forEach(month => {
    monthlyGroupedPerformance[month] = {
      adrList: [],
      occupancyRateList: [],
      activeListingsCount: 0,
      revenueFromCleaningFeesList: [],
    };
  });

  listings.forEach(listing => {
    for (let month of months) {
      if (!listing.historicalMonthlyPerformance) continue;
      const performanceData = listing.historicalMonthlyPerformance[month];
      if (!performanceData) continue;
      const adr = performanceData.adr;
      const activeDaysCount = performanceData.activeDaysCount;
      const bookedDaysCount = performanceData.bookedDaysCount;
      const numberOfBookings = performanceData.numberOfBookings;

      if (activeDaysCount == 0) continue;

      const occupancyRate = Math.min(
        Math.round((bookedDaysCount / activeDaysCount) * 100 * 1.2),
        100
      );
      const revenuefromCleaningFees = listing.cleaningFee * numberOfBookings;

      if (adr) {
        monthlyGroupedPerformance[month].adrList.push(adr);
      }
      monthlyGroupedPerformance[month].occupancyRateList.push(occupancyRate);
      monthlyGroupedPerformance[month].activeListingsCount =
        monthlyGroupedPerformance[month].activeListingsCount + 1;
      monthlyGroupedPerformance[month].revenueFromCleaningFeesList.push(revenuefromCleaningFees);
    }
  });

  for (let month of months) {
    const adrList = monthlyGroupedPerformance[month]['adrList'];
    const occupancyList = monthlyGroupedPerformance[month]['occupancyRateList'];
    const activeListingsCount = monthlyGroupedPerformance[month]['activeListingsCount'];
    const revFromCleaningFee = monthlyGroupedPerformance[month]['revenueFromCleaningFeesList'];

    const quantiles = [0.25, 0.5, 0.75, 0.9];

    const calculatePercentiles = data => {
      if (data.length > 0) {
        return quantiles.map(q => d3.quantile(data.sort(d3.ascending), q));
      } else {
        // Return an array of zeros if the input array is empty
        return Array(quantiles.length).fill(0);
      }
    };

    const [dailyRate25, dailyRate50, dailyRate75, dailyRate90] = calculatePercentiles(adrList);
    const [
      occupancyRate25,
      occupancyRate50,
      occupancyRate75,
      occupancyRate90,
    ] = calculatePercentiles(occupancyList);
    const [
      revFromCleaningFee25,
      revFromCleaningFee50,
      revFromCleaningFee75,
      revFromCleaningFee90,
    ] = calculatePercentiles(revFromCleaningFee);

    const calculateRevenue = (dailyRate, occupancyRate, revFromCleaningFee) => {
      const totalDaysCount = 30.5;
      const revenue = dailyRate * (occupancyRate / 100) * totalDaysCount;
      return revenue + revFromCleaningFee;
    };

    const revenue25 = calculateRevenue(dailyRate25, occupancyRate25, revFromCleaningFee25);
    const revenue50 = calculateRevenue(dailyRate50, occupancyRate50, revFromCleaningFee50);
    const revenue75 = calculateRevenue(dailyRate75, occupancyRate75, revFromCleaningFee75);
    const revenue90 = calculateRevenue(dailyRate90, occupancyRate90, revFromCleaningFee90);

    monthlyMarketPerformance[month] = {
      active_listings_count: activeListingsCount,
      daily_rate25: Math.round(dailyRate25),
      daily_rate50: Math.round(dailyRate50),
      daily_rate75: Math.round(dailyRate75),
      daily_rate90: Math.round(dailyRate90),
      occupancy_rate25: Math.round(occupancyRate25),
      occupancy_rate50: Math.round(occupancyRate50),
      occupancy_rate75: Math.round(occupancyRate75),
      occupancy_rate90: Math.round(occupancyRate90),
      revenue25: Math.round(revenue25),
      revenue50: Math.round(revenue50),
      revenue75: Math.round(revenue75),
      revenue90: Math.round(revenue90),
    };
  }

  return monthlyMarketPerformance;
};

// export const processLegacyListing = (listings, dates: string[], historicalDates: string[]) => {
//   let retVals: ListingsLegacy = {};
//   if (!listings) {
//     return retVals;
//   }
//   for (const listing of listings) {
//     try {
//       const listingID = String(listing[1]);
//       // free data
//       let retListing = {} as ListingValLegacy;
//       retListing.markerType = listing[0];
//       retListing.name = listing[2];
//       retListing.thumbnail_url = listing[3].includes('sample_comp_listing')
//         ? `https://default-market-data-cache.s3.us-east-2.amazonaws.com/${listing[3]}`
//         : `https://a0.muscache.com/im/pictures/${listing[3]}?aki_policy=small`;
//       retListing.latitude = listing[4];
//       retListing.longitude = listing[5];
//       retListing.room_type = listing[6]; // [entire_home, private_room, shared_room, hotel_room]
//       retListing.property_type = listing[7]; // [Either -1 or condo
//       retListing.bedrooms = listing[8];
//       retListing.bathrooms = listing[9];
//       retListing.accommodates = listing[10];
//       retListing.host_name = listing[11];
//       retListing.minimum_nights = listing[12];
//       retListing.hostListingCount = listing[13];
//       retListing.cleaningFee = listing[14];
//       retListing.extraGuestFee = listing[15];
//       retListing.review_scores_rating = listing[16];
//       retListing.amenities = listing[17];
//       retListing.visible_review_count = listing[18];
//       retListing.cancellation_policy = listing[19];
//       retListing.pet_friendly = listing[20];
//       retListing.adr = [
//         { date: dates[0], adr: listing[21] },
//         { date: dates[1], adr: listing[22] },
//         { date: dates[2], adr: listing[23] },
//         { date: dates[3], adr: listing[24] },
//         { date: dates[4], adr: listing[25] },
//         { date: dates[5], adr: listing[26] },
//         { date: dates[6], adr: listing[27] },
//         { date: dates[7], adr: listing[28] },
//         { date: dates[8], adr: listing[29] },
//         { date: dates[9], adr: listing[30] },
//         { date: dates[10], adr: listing[31] },
//         { date: dates[11], adr: listing[32] },
//       ];
//       retListing.occupancy_ratePrevMonth = listing[33];
//       retListing.revenuePrevMonth = listing[34];
//       retListing.inactivePrevMonth = listing[35];
//       retListing.bookingsPerMonthPrevMonth = listing[36];
//       retListing.hostId = listing[37];
//       retListing.listing_url = `airbnb.com/rooms/${listingID}`;
//       retListing.bookings = [] as Booking[]; // assigning empty booking array by default to avoid type checking errors
//       if (listing.length === 39) {
//         retListing.revenuePercentileRating = listing[38];
//       }
//       // premium data
//       if (listing.length > 39) {
//         retListing.occupancy_rate = [
//           { date: dates[0], occupancy_rate: listing[38] },
//           { date: dates[1], occupancy_rate: listing[39] },
//           { date: dates[2], occupancy_rate: listing[40] },
//           { date: dates[3], occupancy_rate: listing[41] },
//           { date: dates[4], occupancy_rate: listing[42] },
//           { date: dates[5], occupancy_rate: listing[43] },
//           { date: dates[6], occupancy_rate: listing[44] },
//           { date: dates[7], occupancy_rate: listing[45] },
//           { date: dates[8], occupancy_rate: listing[46] },
//           { date: dates[9], occupancy_rate: listing[47] },
//           { date: dates[10], occupancy_rate: listing[48] },
//           { date: dates[11], occupancy_rate: listing[49] },
//         ];
//         retListing.revenue = [
//           { date: dates[0], revenue: listing[50] },
//           { date: dates[1], revenue: listing[51] },
//           { date: dates[2], revenue: listing[52] },
//           { date: dates[3], revenue: listing[53] },
//           { date: dates[4], revenue: listing[54] },
//           { date: dates[5], revenue: listing[55] },
//           { date: dates[6], revenue: listing[56] },
//           { date: dates[7], revenue: listing[57] },
//           { date: dates[8], revenue: listing[58] },
//           { date: dates[9], revenue: listing[59] },
//           { date: dates[10], revenue: listing[60] },
//           { date: dates[11], revenue: listing[61] },
//         ];
//         retListing.activeDaysCount = listing[62];
//         retListing.last_seen = listing[63];
//         retListing.inactivityStatus = [
//           { date: dates[0], inactive: listing[64] },
//           { date: dates[1], inactive: listing[65] },
//           { date: dates[2], inactive: listing[66] },
//           { date: dates[3], inactive: listing[67] },
//           { date: dates[4], inactive: listing[68] },
//           { date: dates[5], inactive: listing[69] },
//           { date: dates[6], inactive: listing[70] },
//           { date: dates[7], inactive: listing[71] },
//           { date: dates[8], inactive: listing[72] },
//           { date: dates[9], inactive: listing[73] },
//           { date: dates[10], inactive: listing[74] },
//           { date: dates[11], inactive: listing[75] },
//         ];
//         retListing.bookingsPerMonth = [
//           { date: dates[0], bookingsPerMonth: listing[76] },
//           { date: dates[1], bookingsPerMonth: listing[77] },
//           { date: dates[2], bookingsPerMonth: listing[78] },
//           { date: dates[3], bookingsPerMonth: listing[79] },
//           { date: dates[4], bookingsPerMonth: listing[80] },
//           { date: dates[5], bookingsPerMonth: listing[81] },
//           { date: dates[6], bookingsPerMonth: listing[82] },
//           { date: dates[7], bookingsPerMonth: listing[83] },
//           { date: dates[8], bookingsPerMonth: listing[84] },
//           { date: dates[9], bookingsPerMonth: listing[85] },
//           { date: dates[10], bookingsPerMonth: listing[86] },
//           { date: dates[11], bookingsPerMonth: listing[87] },
//         ];
//         if (typeof listing[88] === 'object') {
//           retListing.confidenceScoreRelatedData = listing[88];
//         }
//         retListing.revenuePotential = listing[89];
//         retListing.hasLicense = listing[90] === 'f' ? false : true;
//         retListing.occupancy_rateHistorical = [] as OccupancyRate[];
//         retListing.adrHistorical = [] as ADR[];
//         retListing.revenueHistorical = [] as Revenue[];
//         listing[91].forEach((_, index: number) => {
//           retListing.occupancy_rateHistorical.push({
//             date: historicalDates[index],
//             occupancy_rate: listing[91][index],
//           });
//         });
//         listing[92].forEach((_, index: number) => {
//           retListing.adrHistorical.push({ date: historicalDates[index], adr: listing[92][index] });
//         });
//         listing[93].forEach((_, index: number) => {
//           retListing.revenueHistorical.push({
//             date: historicalDates[index],
//             revenue: listing[93][index],
//           });
//         });
//         retListing.visible = true;
//         retListing.isLegacy = true;
//       }
//       retVals[listingID] = retListing;
//     } catch (error) {
//       console.log('error while loading marker', error);
//     }
//   }

//   return retVals;
// };

export const processTailoredRegionMarkers = listings => {
  let retVals: TailoredRegionMarkers[] = [];
  if (!listings) {
    return retVals;
  }
  for (const listing of listings) {
    let retListing = {} as TailoredRegionMarkers;
    retListing.listingID = listing[0];
    retListing.latitude = listing[1];
    retListing.longitude = listing[2];
    retListing.room_type = listing[3];
    retVals.push(retListing);
  }

  return retVals;
};

export const getBoundedListings = (listings: Listings, bounds: Bounds): string[] => {
  if (!bounds || !Object.keys(listings).length) return [];

  const swBound: Coordinates = bounds.southWest;
  const neBound: Coordinates = bounds.northEast;

  const polygon = [
    [swBound.lat, swBound.lng],
    [swBound.lat, neBound.lng],
    [neBound.lat, neBound.lng],
    [neBound.lat, swBound.lng],
  ];

  let boundedListings: string[] = [];
  const listingEntries = Object.entries(listings);
  const batchSize = 50;

  const processBatch = (batch: [string, ListingVal][]) => {
    batch.forEach(([listingID, listing]) => {
      const point = [listing.latitude, listing.longitude];
      if (classifyPoint(polygon, point) === -1 || classifyPoint(polygon, point) === 0) {
        boundedListings.push(listingID);
      }
    });
  };

  const batches = chunk(listingEntries, batchSize);
  batches.forEach(processBatch);

  return boundedListings;
};

export const updateListings = (currentListings: Listings, visibleListings: Set<String>) => {
  for (const listingID in currentListings) {
    if (currentListings.hasOwnProperty(listingID)) {
      currentListings[listingID].visible = visibleListings.has(listingID);
    }
  }

  return currentListings;
};

export const processBookingData = (rawBookings: number[][]) => {
  const bookings: Booking[] = [];
  for (const rawBooking of rawBookings) {
    bookings.push({
      numberNights: rawBooking[0],
      totalValue: rawBooking[1],
      bookingLead: rawBooking[2],
    });
  }

  return bookings;
};

export const bindBookingDataWithListings = (listings: Listings, bookingData: any) => {
  let bindedListings = listings;
  Object.keys(bindedListings).forEach(listingID => {
    if (bookingData[listingID]) {
      const bookings = processBookingData(bookingData[listingID]);
      bindedListings[listingID].bookings = bookings;
    }
  });
  return bindedListings;
};

export const checkHostType = (
  hostType: 'independent' | 'professional',
  hostListingCount: number
) => {
  if (hostType === 'independent') return hostListingCount < 5;
  else return hostListingCount >= 5;
};

export const applyRevenueFilter = (
  revenueRange: { [key: number]: 'visible' | 'hidden' },
  filteredListings: string[],
  listings: Listings,
  revenueFilterValue: number[]
) => {
  const filteredRevListings: string[] = [];

  const revenueRangeVisibleCount = Object.keys(revenueRange).filter(
    key => revenueRange[key] === 'visible'
  ).length;

  if (revenueRangeVisibleCount === 0) {
    return [];
  }

  if (revenueRangeVisibleCount === 4) {
    return filteredListings;
  }

  const revPotentialRangeArray: number[] = Object.keys(revenueRange)
    .map(Number)
    .sort((a, b) => a - b);

  let cntObj = {};
  const listingIDs = filteredListings;
  for (let listingID of listingIDs) {
    const listing = listings[listingID];
    const len = 4;

    for (let i = len; i >= 0; i--) {
      if (
        i !== 0 &&
        listing.revenuePotential <= revPotentialRangeArray[i] &&
        listing.revenuePotential > revPotentialRangeArray[i - 1] &&
        revenueRange[revPotentialRangeArray[i]] === 'visible'
      ) {
        // DEBUG
        // if (!cntObj[i]) cntObj[i] = 0;
        // cntObj[i] = cntObj[i] + 1;
        // listing.visible = true;
        filteredRevListings.push(listingID);
        break;
      }

      if (
        i === 0 &&
        listing.revenuePotential <= revPotentialRangeArray[i] &&
        revenueRange[revPotentialRangeArray[i]] === 'visible'
      ) {
        // DEBUG
        // if (!cntObj[i]) cntObj[i] = 0;
        // cntObj[i] = cntObj[i] + 1;
        // listing.visible = true;
        filteredRevListings.push(listingID);
        break;
      }
    }
  }
  return filteredRevListings;
};

export const applyPriceTierFilter = (
  filteredListings: string[],
  listings: Listings,
  priceTierFilterValue: number[][]
) => {
  const filteredPriceTierListings: string[] = [];

  if (priceTierFilterValue.length == 0) return filteredPriceTierListings;

  const highLowValue = arrayOfArrays => {
    const minValue = arrayOfArrays.reduce((min, arr) => Math.min(min, arr[0]), arrayOfArrays[0][0]);
    const maxValue = arrayOfArrays.reduce((max, arr) => Math.max(max, arr[1]), arrayOfArrays[0][1]);
    return [minValue, maxValue];
  };

  const [lowPrice, highPrice] = highLowValue(priceTierFilterValue);

  for (let listingID of filteredListings) {
    const listing = listings[listingID];
    if (listing.adrLTM && listing.adrLTM < highPrice && listing.adrLTM >= lowPrice) {
      filteredPriceTierListings.push(listingID);
    }
  }

  return filteredPriceTierListings;
};

export const getFilteredListings = (
  listings: Listings,
  filters: FilterVal,
  filterActive: boolean,
  revenueRange?: { [key: number]: 'visible' | 'hidden' },
  onlyConsiderRevenueFilter: boolean = false,
  filtersToConsider: string[] = []
) => {
  let filteredListings: string[] = [];

  const isFilterToConsider = (filter: string) => {
    if (filtersToConsider.length === 0) return true;

    if (filtersToConsider.includes(filter)) {
      return true;
    }
    return false;
  };

  if (!filterActive) {
    return Object.keys(listings);
  }

  let filteredListingsList: string[][] = [];

  let bathroom_values: number[] = [];
  let host_type_value: 'independent' | 'professional' | 'both' = 'both';
  let number_of_reviews: number | 'all' = 'all';
  let rating: [number, number] = [-1, -1];
  let sleeps: [number, number] = [-1, -1];
  let minimum_nights: [number, number] = [1, 30];

  const amenities: { [index: string]: boolean } = {};

  const showNoListings: boolean =
    !filters.roomType.includes('entire_home') &&
    !filters.roomType.includes('condo') &&
    !filters.roomType.includes('all') &&
    (!filters.bedrooms.includes(100) ||
      filters.bedrooms.length > 1 ||
      !filters.bathrooms.includes(100) ||
      filters.bathrooms.length > 1);

  if (showNoListings) {
    return [];
  }

  !onlyConsiderRevenueFilter &&
    Object.keys(filters).forEach(filter => {
      const value: string | string[] | Number | Number[] | { [index: string]: boolean } =
        filters[filter];
      let tempFilteredListings: string[] = [];

      if (filter === 'roomType') {
        if (
          (value as string[]).includes('all') ||
          (value as string[]).length === 0 ||
          !isFilterToConsider('roomType')
        ) {
          tempFilteredListings = Object.keys(listings);
        } else {
          if ((value as string[]).includes('entire_home')) {
            Object.keys(listings).forEach(listingID => {
              const listing = listings[listingID];
              if (
                listing.room_type &&
                listing.room_type === 'entire_home' &&
                listing.property_type &&
                listing.property_type !== 'condo'
              ) {
                tempFilteredListings.push(listingID);
              }
            });
          }

          if ((value as string[]).includes('condo')) {
            Object.keys(listings).forEach(listingID => {
              const listing = listings[listingID];
              if (listing.property_type && listing.property_type === 'condo') {
                tempFilteredListings.push(listingID);
              }
            });
          }

          Object.keys(listings).forEach(listingID => {
            const listing = listings[listingID];
            if ((value as string[]).includes(listing.room_type)) {
              tempFilteredListings.push(listingID);
            }
          });
        }
      }

      if (filter === 'bedrooms') {
        const bedroom_values: (number | string)[] = value as (number | string)[];

        if (
          bedroom_values.length === 0 ||
          bedroom_values.includes(100) ||
          !isFilterToConsider('bedrooms')
        ) {
          tempFilteredListings = Object.keys(listings);
        } else {
          Object.keys(listings).forEach(listingID => {
            const listing = listings[listingID];
            const roomType = listing.room_type;
            const bedrooms: number = listing.bedrooms === 'Studio' ? 0 : Number(listing.bedrooms);
            if (
              (listing.room_type && listing.room_type === 'entire_home') ||
              (listing.property_type && listing.property_type === 'condo')
            ) {
              if (bedroom_values.includes(bedrooms)) {
                tempFilteredListings.push(listingID);
              }
              //handling 6+ bedrooms
              if (bedroom_values.includes(6) && bedrooms > 6) {
                tempFilteredListings.push(listingID);
              }
            }

            ['private_room', 'hotel_room', 'shared_room'].forEach(type => {
              if (roomType === type && bedroom_values.includes(type)) {
                tempFilteredListings.push(listingID);
              }
            });
          });
        }
      }

      if (filter === 'bathrooms') {
        bathroom_values = value as number[];
      }

      if (filter === 'hostType') {
        host_type_value = value as 'independent' | 'professional' | 'both';
      }

      if (filter === 'accommodates') {
        const lowerVal = value[0] as number;
        const upperVal = value[1] as number;
        sleeps = [lowerVal, upperVal];
      }

      if (filter === 'minimum_nights') {
        const lowerVal = value[0] as number;
        const upperVal = value[1] as number;

        minimum_nights = [lowerVal, upperVal];
      }

      if (filter === 'number_of_reviews') {
        number_of_reviews = value as number | 'all';
      }

      if (filter === 'rating') {
        rating = value as [number, number];
      }

      if (filter === 'amenities') {
        for (const key in value as { [index: string]: boolean }) {
          if (value[key] != null) {
            amenities[key] = value[key];
          }
        }
      }

      filteredListingsList.push(tempFilteredListings);
    });

  const numberOfReviewsLowerBound = number_of_reviews !== 'all' ? number_of_reviews : 0;

  // Applying AND to the filtered results from roomType, and bedrooms and applying rest of the filters
  !onlyConsiderRevenueFilter &&
    filteredListingsList.reduce((filteredListings1, filteredListings2) => {
      filteredListings1.forEach(filteredListing => {
        if (filteredListings2.includes(filteredListing)) {
          // applying number of reviews filter
          if (numberOfReviewsLowerBound && isFilterToConsider('number_of_reviews')) {
            listings[filteredListing].visible_review_count > numberOfReviewsLowerBound &&
              filteredListings.push(filteredListing);
          } else {
            filteredListings.push(filteredListing);
          }
        }
      });

      // applying bathrooms filter
      filteredListings =
        bathroom_values.length === 0 ||
        bathroom_values.includes(100) ||
        !isFilterToConsider('bathrooms')
          ? filteredListings
          : filteredListings.filter(filteredListing => {
              const bathroom = listings[filteredListing].bathrooms;
              if (bathroom_values.includes(bathroom)) {
                return true;
              }
              if (bathroom_values.includes(6) && bathroom > 6) {
                return true;
              }
              return false;
            });

      // applying host type filter
      filteredListings =
        host_type_value === 'both' || !isFilterToConsider('hostType')
          ? filteredListings
          : filteredListings.filter(filteredListing => {
              const hostListingCount = listings[filteredListing].hostListingCount;
              const isHostTypeMatching = checkHostType(
                host_type_value as 'independent' | 'professional',
                hostListingCount
              );
              if (isHostTypeMatching) {
                return true;
              }
              return false;
            });

      // applying sleeps filter
      const sleepsLowerBound = sleeps[0];
      const sleepsUpperBound = sleeps[1];

      filteredListings =
        (sleepsLowerBound === -1 && sleepsUpperBound === -1) || !isFilterToConsider('accommodates')
          ? filteredListings
          : filteredListings.filter(filteredListing => {
              const accommodates = listings[filteredListing].accommodates;
              if (accommodates >= sleepsLowerBound && accommodates <= sleepsUpperBound) {
                return true;
              }
              if (sleepsUpperBound === 16 && accommodates > 16) {
                return true;
              }
              return false;
            });

      // applying minimum nights filter
      const minimumNightsLowerBound = minimum_nights[0];
      const minimumNightsUpperBound = minimum_nights[1];
      filteredListings =
        (minimumNightsLowerBound === 1 && minimumNightsUpperBound === 30) ||
        !isFilterToConsider('minimum_nights')
          ? filteredListings
          : filteredListings.filter(listing => {
              const minimumNightsForThisListings = listings[listing].minimum_nights;

              return (
                minimumNightsLowerBound <= minimumNightsForThisListings &&
                minimumNightsUpperBound > minimumNightsForThisListings
              );
            });

      // applying the rating filter
      let lowestRating = rating[0];
      const heighestRating = rating[1];
      if (lowestRating === 3.9) {
        lowestRating = 0;
      }
      filteredListings =
        (lowestRating === 0 && heighestRating === 5) || !isFilterToConsider('rating')
          ? filteredListings
          : filteredListings.filter(listing => {
              let ratingOfCurrentListing = listings[listing].review_scores_rating;
              ratingOfCurrentListing = ratingOfCurrentListing ? ratingOfCurrentListing : 0;
              return (
                lowestRating <= ratingOfCurrentListing && heighestRating >= ratingOfCurrentListing
              );
            });

      // applying amenities filter
      if (filters['amenities']) {
        filteredListings = !isFilterToConsider('amenities')
          ? filteredListings
          : filteredListings.filter(filteredListing => {
              return Object.entries(amenities).every(([amenity, amenityState]) => {
                // If amenityState is true, include listings that have this amenity
                // If amenityState is false, exclude listings that have this amenity
                return amenityState
                  ? listings[filteredListing].amenities[amenity]
                  : !listings[filteredListing].amenities[amenity];
              });
            });
      }

      return filteredListings;
    });

  // revenue potential filter
  if (revenueRange) {
    if (onlyConsiderRevenueFilter) {
      filteredListings = Object.keys(listings);
    }

    const revenueFilterValue: (number | 'all')[] = filters.revenueFilter;

    filteredListings =
      revenueFilterValue.includes('all') || revenueFilterValue.length === 4
        ? filteredListings
        : applyRevenueFilter(
            revenueRange,
            filteredListings,
            listings,
            revenueFilterValue as number[]
          );
  }

  const priceTierFilterValue: (number[] | 'all')[] = filters.priceTierFilter;
  filteredListings =
    priceTierFilterValue.includes('all') || priceTierFilterValue.length === 5
      ? filteredListings
      : applyPriceTierFilter(filteredListings, listings, priceTierFilterValue as number[][]);

  return filteredListings;
};

export const safeMarkersLoad = (
  listings: Listing[],
  isUserAllowed: boolean,
  ignoreSafeLimit: boolean = false
) => {
  const totalAirbnbSafeLimit = 22;
  let listingsToLoad: Listing[] = [];
  let listingsNotLoaded: Listing[] = [];

  // Priority marker load
  if (isUserAllowed) {
    for (const listing of listings) {
      try {
        if (listing.adrLTM && listing.occupancyRateLTM && listing.annualRevenueLTM) {
          listingsToLoad.push(listing);
        }
      } catch (error) {
        // console.log('Ignored Error while loading safe marker ', error);
        continue;
      }

      if (!ignoreSafeLimit && listingsToLoad.length >= totalAirbnbSafeLimit) {
        break;
      }
    }
  }

  if (listingsToLoad.length < totalAirbnbSafeLimit) {
    listingsNotLoaded = listings.filter(listing => !listingsToLoad.includes(listing));
    if (listingsNotLoaded.length === 0) return listingsToLoad;
    for (const listing of listingsNotLoaded) {
      listingsToLoad.push(listing);
      if (!ignoreSafeLimit && listingsToLoad.length > totalAirbnbSafeLimit) {
        break;
      }
    }
  }
  return listingsToLoad;
};

// export const safeLegacyMarkersLoad = (listings, isUserAllowed: boolean) => {
//   const totalAirbnbSafeLimit = 260;
//   let listingsToLoad: any[] = [];
//   let listingsNotLoaded: any[] = [];

//   // Priority marker load
//   if (isUserAllowed) {
//     for (const listing of listings) {
//       try {
//         if (
//           listing.adr[11].adr != 'missing' &&
//           listing.adr[11].adr != 'inactive' &&
//           listing.occupancy_rate[11].occupancy_rate != 'missing' &&
//           listing.occupancy_rate[11].occupancy_rate != 'inactive' &&
//           listing.revenue[11].revenue != 'missing' &&
//           listing.revenue[11].revenue != 'inactive'
//         ) {
//           listingsToLoad.push(listing);
//         }
//       } catch (error) {
//         // console.log('Ignored Error while loading safe marker ', error);
//         continue;
//       }

//       if (listingsToLoad.length > totalAirbnbSafeLimit) {
//         break;
//       }
//     }
//   }

//   if (listingsToLoad.length < totalAirbnbSafeLimit) {
//     listingsNotLoaded = listings.filter(listing => !listingsToLoad.includes(listing));
//     if (listingsNotLoaded.length === 0) return listingsToLoad;
//     for (const listing of listingsNotLoaded) {
//       listingsToLoad.push(listing);
//       if (listingsToLoad.length > totalAirbnbSafeLimit) {
//         break;
//       }
//     }
//   }
//   return listingsToLoad;
// };

export const jsonArrayToCSV = (
  data: {
    [key: string]: number | string;
  }[],
  addHeader = true
) => {
  let csv = data.map(row => Object.values(row));
  addHeader === true && csv.unshift(Object.keys(data[0]));
  return `"${csv.join('"\n"').replace(/,/g, '","')}"`;
};

export const calculateInvestmentReturns = (values: { [index: string]: number }) => {
  const valuesLen = Object.keys(values).length;
  if (valuesLen < 4) {
    return false;
  }

  for (let key in values) {
    values[key] = Number(values[key]);
  }

  const propertyPrice = values.propertyPrice;
  const downPayment = values.downPayment;
  const annualGrossIncome = values.annualRevenue;
  const annualExpenses = values.annualExpenses;

  const grossRentalYield = (annualGrossIncome / propertyPrice) * 100;

  const totalInvestment = downPayment + values.startupCosts;
  const annualCashFlow = annualGrossIncome - annualExpenses;
  const netProfitBeforeTax = annualCashFlow;
  const netRentalYield = (annualCashFlow / propertyPrice) * 100;
  const cashOnCashReturn = downPayment > 0 ? (annualCashFlow / totalInvestment) * 100 : NaN;

  const returnObj = {
    grossRentalYield: Math.round(grossRentalYield),
    netProfitBeforeTax: Math.round(netProfitBeforeTax),
    netRentalYield: Math.round(netRentalYield),
    cashOnCashReturn: Math.round(cashOnCashReturn),
  };
  return returnObj;
};

export const titleCase = (str: string | undefined) => {
  if (!str) {
    return '';
  }
  try {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(' ');
  } catch (e) {
    console.log('Error in titleCase function', e);
    return str;
  }
};

export const processAirbnbAuthResponse = response => {
  let error = '';
  if (
    response.action === 'wrong_credentials' ||
    response.action === 'wrong_code' ||
    response.action === 'support' ||
    response.action === 'failed'
  ) {
    error = response.action;
  }
  return {
    action: response.action,
    captcha_url: response.hasOwnProperty('airlock_url') ? response.airlock_url : '',
    airlock_id: response.hasOwnProperty('airlock_id') ? response.airlock_id : '',
    user_id: response.hasOwnProperty('userID') ? response.userID : '',
    error: error,
  };
};

export const getMonthlyKeyMetrics = (
  keyMetricsName: string,
  listings: any[],
  singleListing = false,
  noAvg = false,
  percentile = 0.5,
  useHistory = false
) => {
  let monthlyKeyMetrics: ADR[] | OccupancyRate[] | Revenue[] | BookingsPerMonth[] = [];
  let values = [] as number[][];

  if (listings.length === 0) return monthlyKeyMetrics;

  if (singleListing) {
    const listing = listings[0];
    if (!listing[`${keyMetricsName}`] || !Array.isArray(listing[`${keyMetricsName}`])) {
      return monthlyKeyMetrics;
    }
    monthlyKeyMetrics =
      // useHistory && listing.hasOwnProperty(`${keyMetricsName}Historical`)
      //   ? listing[`${keyMetricsName}Historical`].concat(listing[`${keyMetricsName}`])
      //   :
      listing[`${keyMetricsName}`];
    return monthlyKeyMetrics;
  }

  // creating object for each month

  const sampleListing = listings.length > 3 ? listings[3] : listings[0];
  const sampleMonthlyRawData =
    // useHistory && sampleListing.hasOwnProperty(`${keyMetricsName}Historical`)
    //   ? sampleListing[`${keyMetricsName}Historical`].concat(sampleListing[`${keyMetricsName}`])
    //   :
    sampleListing[`${keyMetricsName}`];

  sampleMonthlyRawData.map(
    (obj: ADR | OccupancyRate | Revenue | BookingsPerMonth, index: number) => {
      monthlyKeyMetrics[index] = {} as ADR | OccupancyRate | Revenue | BookingsPerMonth;
      monthlyKeyMetrics[index].date = obj.date;
      monthlyKeyMetrics[index][`${keyMetricsName}`] = 'missing';
      values[index] = [];
    }
  );

  // pushing values to values list by iterating through listings
  listings.map((listing: ListingLegacy) => {
    const monthlyRawData =
      // useHistory && sampleListing.hasOwnProperty(`${keyMetricsName}Historical`)
      //   ? listing[`${keyMetricsName}Historical`].concat(listing[`${keyMetricsName}`])
      //   :
      listing[`${keyMetricsName}`];

    monthlyRawData.map((obj: ADR | OccupancyRate | Revenue | BookingsPerMonth, index: number) => {
      if (obj[`${keyMetricsName}`] !== 'missing' && obj[`${keyMetricsName}`] !== 'inactive') {
        values[index].push(obj[`${keyMetricsName}`]);
      }
    });
  });

  // calculating percentile for each month

  monthlyKeyMetrics.map((keyMetricObj, index) => {
    if (values[index].length > 0) {
      if (!noAvg) {
        values[index].sort((a, b) => a - b);
        keyMetricObj[`${keyMetricsName}`] = Math.round(d3.quantile(values[index], percentile));
        keyMetricObj[`${keyMetricsName}0.25`] = Math.round(d3.quantile(values[index], 0.25));
        keyMetricObj[`${keyMetricsName}0.5`] = Math.round(d3.quantile(values[index], 0.5));
        keyMetricObj[`${keyMetricsName}0.75`] = Math.round(d3.quantile(values[index], 0.75));
        keyMetricObj[`${keyMetricsName}0.9`] = Math.round(d3.quantile(values[index], 0.9));
      } else {
        keyMetricObj[`${keyMetricsName}`] = values[index].reduce((acc, val) => acc + val, 0);
      }
    }
  });
  return monthlyKeyMetrics;
};

export const processLastMonthData = (
  listings: Listing[] | ListingLegacy[],
  metricsKey: 'occupancy_rate' | 'revenue',
  percentile = 0.5
) => {
  let lastMonthData: 'missing' | string = 'missing';
  let values = [] as number[];

  listings.forEach((listing: Listing | ListingLegacy) => {
    if (
      listing[`${metricsKey}PrevMonth`] &&
      listing[`${metricsKey}PrevMonth`] !== 'missing' &&
      listing[`${metricsKey}PrevMonth`] !== 'inactive'
    ) {
      values.push(listing[`${metricsKey}PrevMonth`] as number);
    }
  });

  if (values.length > 0) {
    values.sort((a, b) => a - b);
    lastMonthData = Math.round(d3.quantile(values, percentile)).toString();
  }

  return lastMonthData;
};

export const findMaxDay = (daysObj: { [key: string]: number }): string => {
  let maxDay = '';
  let maxCount = -Infinity;

  Object.entries(daysObj).forEach(([day, count]) => {
    if (count > maxCount) {
      maxDay = day;
      maxCount = count;
    }
  });

  return maxDay;
};

export const getDayFromDate = (date: Date): string => {
  const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const dayIndex = date.getDay();
  return daysOfWeek[dayIndex];
};

export const getDynamicExtraFees = (
  listings: Listing[],
  currency: string,
  cachedData: { [key: string]: number } | null = null
) => {
  let dynamicExtraFees: BarGraphData[] = [];
  let cleaningFee = 0;
  let cleaningFeeCount = 0;
  let additionalPersonFee = 0;
  let additionalPersonFeeCount = 0;

  if (cachedData) {
    dynamicExtraFees.push({
      keyLong: 'Cleaning Fee',
      value: convertCurrency(currency, cachedData['cleaning_fee']),
    });
    dynamicExtraFees.push({
      keyLong: 'Extra Guest Fee',
      value: convertCurrency(currency, cachedData['extra_guest_fee']),
    });

    return dynamicExtraFees;
  }

  if (listings.length > 0) {
    listings.map((listing: Listing) => {
      if (listing.activeDaysCount >= 90) {
        if (listing.cleaningFee) {
          cleaningFee += listing.cleaningFee;
          cleaningFeeCount += 1;
        }
        if (listing.extraGuestFee) {
          additionalPersonFee += listing.extraGuestFee;
          additionalPersonFeeCount += 1;
        }
      }
    });

    if (cleaningFeeCount != 0) {
      dynamicExtraFees.push({
        keyLong: 'Cleaning Fee',
        value: convertCurrency(currency, Math.round(cleaningFee / cleaningFeeCount), true),
      });
    }
    if (additionalPersonFeeCount != 0) {
      dynamicExtraFees.push({
        keyLong: 'Extra Guest Fee',
        value: convertCurrency(
          currency,
          Math.round(additionalPersonFee / additionalPersonFeeCount),
          true
        ),
      });
    }
  }

  return dynamicExtraFees;
};

export const returnLoadingText = (emptySearchBar: boolean) => {
  if (emptySearchBar) {
    return '';
  } else {
    return 'loading...';
  }
};

export const getListViewData = (
  listings: Listing[] | ListingLegacy[],
  noAvg = false,
  idPrefix: number = 0,
  isDisabled = true
) => {
  let listViewData: ListViewData[] = [];
  listViewData = listings.map((listing: Listing | ListingLegacy, index: number) => {
    const listingType = listing.markerType;
    let avgNightlyRate = -1;
    let avgOccupancyRate = -1;
    let revenuePotential = -1;
    let activeDays = -1;

    avgNightlyRate = isListingLegacy(listing) ? getLTMData('adr', listing.adr) : listing.adrLTM;

    if (!isDisabled || listingType === 'full') {
      avgOccupancyRate = isListingLegacy(listing)
        ? getLTMData('occupancy_rate', listing.occupancy_rate)
        : listing.occupancyRateLTM;
      revenuePotential = listing.revenuePotential;
      activeDays = listing.activeDaysCount;
    }

    return {
      listingID: listing.listingID,
      thumbnail_url: listing.thumbnail_url,
      id: idPrefix + index + 1,
      avgNightlyRate: avgNightlyRate,
      avgOccupancyRate: avgOccupancyRate,
      avgRevenue: revenuePotential,
      activeDays: activeDays,
    };
  });

  const sortedListViewData = listViewData.sort((a, b) => {
    if (a.avgRevenue > b.avgRevenue) {
      return -1;
    }
    if (a.avgRevenue < b.avgRevenue) {
      return 1;
    }
    return 0;
  });

  return sortedListViewData;
};

export const convertToUSD = (currency: string, amountInCurrency: number, round = false) => {
  if (exchangeRates[currency]) {
    const usdAmount = amountInCurrency / exchangeRates[currency].rate;
    return round ? Math.round(usdAmount * 100) / 100 : usdAmount;
  } else {
    throw new Error(`Exchange rate for ${currency} not found.`);
  }
};

export const convertCurrency = (
  currency: string,
  dollarAmt: number,
  round = false,
  rawValue = false
) => {
  if (rawValue) {
    return dollarAmt * exchangeRates[currency].rate;
  }
  if (round) {
    return Math.round(dollarAmt * exchangeRates[currency].rate * 100) / 100;
  } else {
    return Math.round(dollarAmt * exchangeRates[currency].rate);
  }
};

export const roundNumber = (amount: number) => {
  return Math.round(amount);
};

export const formatCurrency = (curString: string) => {
  const p = curString.indexOf('.');
  return curString.replace(/\d(?=(?:\d{3})+(?:\.|$))/g, (m, i) => (p < 0 || i < p ? `${m},` : m));
};

export const formatCurrencyBasedOnCountryCode = (value: number, currency: string) => {
  if (value == null || value === undefined) return '';
  if (currency == 'INR') {
    return value.toLocaleString('en-IN');
  }
  return value.toLocaleString('en-US');
};

export const isEqualObject = (obj1: any, obj2: any) => {
  const obj1Length = Object.keys(obj1).length;
  const obj2Length = Object.keys(obj2).length;

  if (obj1Length === obj2Length) {
    return Object.keys(obj1).every(key => obj2.hasOwnProperty(key) && obj2[key] === obj1[key]);
  }
  return false;
};

export const isEmpty = obj => {
  if (Object.keys(obj).length === 0) {
    return true;
  } else if (obj.ltm_performance) {
    const ltm = obj.ltm_performance;
    if (
      ltm.revenue === null &&
      ltm.cleaning_fee === 0 &&
      ltm.booking === 0 &&
      ltm.occupancy_rate === null &&
      ltm.adr === null &&
      ltm.supply === 0
    ) {
      return true;
    }
  }
  return false;
};

export const isNoDataInMarket = obj => {
  if (Object.keys(obj).length === 0) {
    return true;
  } else if (obj.ltm_performance) {
    const ltm = obj.ltm_performance;
    if (
      ltm.revenue === null &&
      ltm.cleaning_fee === 0 &&
      ltm.booking === 0 &&
      ltm.occupancy_rate === null &&
      ltm.adr === null &&
      ltm.supply === 0
    ) {
      return true;
    }
  }
  return false;
};

export const isDefaultFilter = (): boolean => {
  const _get = (x: string) => localStorage.getItem(x);
  const isFilterApplied =
    _get('room_type') ||
    _get('bedroom_number') ||
    _get('bathroom_number') ||
    _get('minimum_nights') ||
    _get('maximum_nights') ||
    _get('no_of_people') ||
    _get('host_type') ||
    _get('amenities');

  return isFilterApplied ? true : false;
};

const toRad = (value: number): number => {
  return (value * Math.PI) / 180;
};

const toDegrees = (radians: number) => {
  return radians * (180 / Math.PI);
};

export const coordDistance = (lat1: number, lng1: number, lat2: number, lng2: number): number => {
  const R = 6371; // km
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lng2 - lng1);
  lat1 = toRad(lat1);
  lat2 = toRad(lat2);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

export const getVRMs = (listings: Listing[], sortBy = 'revenue', isDisabled = false) => {
  const top10Managers: Host = {} as Host;

  /*
  @ function to add new entry if it is not present in the map
  */
  const addNewEntry = (listing: Listing, hostId: number) => {
    const newEntry = {
      hostId: hostId,
      name: listing.host_name?.replace(/"/g, ''),
      totalNumberOfListings: 1,
      revenue: 0,
      listingImage: listing.thumbnail_url,
      ratings: [] as number[],
    };

    if (!isDisabled) {
      const _revenue: any = listing.annualRevenueLTM;
      if (_revenue && _revenue !== 'N/A') {
        newEntry.revenue = _revenue;
      }
    }

    //rating of this listing
    const rating = listing.review_scores_rating ? listing.review_scores_rating : 0;
    if (rating) newEntry.ratings = [rating];

    top10Managers[hostId] = newEntry;
  };

  /*
  @ function to update the entry if it is present in the map
  */

  const updateEntry = (listing: Listing, hostId: number) => {
    //increasing no of listings by 1
    top10Managers[hostId].totalNumberOfListings = 1 + top10Managers[hostId].totalNumberOfListings;

    if (!isDisabled) {
      const _revenue: any = listing.annualRevenueLTM;
      if (_revenue && _revenue !== 'N/A') {
        top10Managers[hostId].revenue = top10Managers[hostId].revenue + _revenue;
      }
    }

    //rating of this listing
    const rating = listing.review_scores_rating ? listing.review_scores_rating : 0;
    if (rating) top10Managers[hostId].ratings.push(rating);
  };

  /*
  @ ------------------------------------------
  */

  listings.forEach(listing => {
    const hostId = listing.hostId;
    if (hostId !== -1) {
      //if present in the map
      if (hostId in top10Managers) {
        updateEntry(listing, hostId);
      }
      //if not present in the map
      else {
        addNewEntry(listing, hostId);
      }
    }
  });

  let top10ManagerArray: Host[] = [];
  //pushing the value of the keys to an array
  for (const manager in top10Managers) {
    top10ManagerArray.push(top10Managers[manager]);
  }

  top10ManagerArray = top10ManagerArray.map(host => ({
    ...host,
    avgRating: host.ratings.length > 0 ? Number(d3.mean(host.ratings).toFixed(2)) : null,
  }));

  //sorting them according to the total revenue
  top10ManagerArray.sort((a, b) => b[sortBy] - a[sortBy]);
  //all values
  const allManagers = [...top10ManagerArray];
  //only taking the  hosts who has more than 5 listings
  top10ManagerArray = top10ManagerArray.filter(arr => arr.totalNumberOfListings > 5);
  //taking top 10 out of them
  top10ManagerArray = top10ManagerArray.slice(0, 10);

  return { top10ManagerArray, allManagers };
};

export const processManagerWithId = (listings, host_id: number) => {
  const currentUserListings = listings.filter(arr => arr.hostId === host_id);
  return currentUserListings;
};

export const getUserFriendlyChannelName = (channel: string) => {
  if (channel === 'airbnb') {
    return 'Airbnb';
  } else if (channel === 'booking_com') {
    return 'Booking.com';
  } else if (channel === 'vrbo') {
    return 'VRBO';
  } else if (channel === 'tripadvisor') {
    return 'TripAdvisor';
  }
  return channel;
};

export const getPropertyTypeFreq = (listings: Listing[], bookingValsFlag = false) => {
  let propertyTypeFreq = {
    entire_home: 0,
    condo: 0,
    private_room: 0,
    hotel_room: 0,
    shared_room: 0,
  };
  let propertyTypeBookingVals = {
    entire_home: 0,
    condo: 0,
    private_room: 0,
    hotel_room: 0,
    shared_room: 0,
  };

  listings.forEach((listing: Listing) => {
    if (listing.room_type === 'entire_home' && listing.property_type === 'condo') {
      propertyTypeFreq.condo = propertyTypeFreq.condo + 1;
      if (bookingValsFlag) {
        listing.bookings.forEach(booking => {
          propertyTypeBookingVals.condo = propertyTypeBookingVals.condo + booking.totalValue;
        });
      }
    } else {
      propertyTypeFreq[listing.room_type] = propertyTypeFreq[listing.room_type] + 1;
      if (bookingValsFlag) {
        listing.bookings.forEach(booking => {
          propertyTypeBookingVals[listing.room_type] =
            propertyTypeBookingVals[listing.room_type] + booking.totalValue;
        });
      }
    }
  });

  if (bookingValsFlag) {
    Object.keys(propertyTypeBookingVals).forEach((propertyType: string) => {
      propertyTypeBookingVals[propertyType] = Math.round(
        propertyTypeBookingVals[propertyType] /
          (propertyTypeFreq[propertyType] > 0 ? propertyTypeFreq[propertyType] : 1)
      );
    });

    return propertyTypeBookingVals;
  }

  return propertyTypeFreq;
};

export const getSupplyByPropertyType = (
  listings: Listing[],
  cachedData: { [key: string]: number } | null = null
) => {
  let propertyTypeFreq: { [key: string]: number } = {};
  let supplyByPropertyType: PieChartData[] = [];
  let totalSupply = 0;

  if (!cachedData) {
    propertyTypeFreq = getPropertyTypeFreq(listings);

    totalSupply = Object.values(propertyTypeFreq).reduce((a, b) => a + b, 0);

    if (totalSupply === 0) {
      return supplyByPropertyType;
    }

    supplyByPropertyType = Object.keys(propertyTypeFreq).map((propertyType: string) => {
      return {
        name: getUserFriendlyPropertyTypeName(propertyType),
        value: propertyTypeFreq[propertyType],
        percentage: Math.round((propertyTypeFreq[propertyType] / totalSupply) * 100),
        legend: getUserFriendlyPropertyTypeName(propertyType)[0],
      };
    });
  } else {
    totalSupply = Object.values(cachedData).reduce((acc, cur) => acc + cur, 0);
    supplyByPropertyType = Object.keys(cachedData).map((propertyType: string) => {
      return {
        name: getUserFriendlyPropertyTypeName(propertyType),
        value: cachedData[propertyType],
        percentage: Math.round((cachedData[propertyType] / totalSupply) * 100),
        legend: getUserFriendlyPropertyTypeName(propertyType)[0],
      };
    });
  }

  return supplyByPropertyType;
};

export const getDemandByPropertyType = (listings: Listing[]) => {
  const propertyTypeBookingVals = getPropertyTypeFreq(listings, true);
  const totalDemand = Object.values(propertyTypeBookingVals).reduce((a, b) => a + b, 0);

  let demandByPropertyType: PieChartData[] = [];

  if (totalDemand === 0) {
    return demandByPropertyType;
  }

  demandByPropertyType = Object.keys(propertyTypeBookingVals).map((propertyType: string) => {
    return {
      name: getUserFriendlyPropertyTypeName(propertyType),
      value: Math.round((propertyTypeBookingVals[propertyType] / totalDemand) * 100),
      percentage: Math.round((propertyTypeBookingVals[propertyType] / totalDemand) * 100),
      legend: getUserFriendlyPropertyTypeName(propertyType)[0],
    };
  });

  return demandByPropertyType;
};

export const getPropertySizeFreq = (listings: Listing[], bookingValsFlag = false) => {
  let propertySizeFreq = {
    '0': 0,
    '1': 0,
    '2': 0,
    '3': 0,
    '4': 0,
    '5': 0,
    '6': 0,
    rooms: 0,
  };
  let propertySizeBookingVals = {
    '0': 0,
    '1': 0,
    '2': 0,
    '3': 0,
    '4': 0,
    '5': 0,
    '6': 0,
    rooms: 0,
  };

  listings.forEach((listing: Listing) => {
    // console.log('listing: ', listing);
    if (
      ((listing.room_type && listing.room_type === 'entire_home') ||
        (listing.property_type && listing.property_type === 'condo')) &&
      (listing.bedrooms == 'Studio' || !isNaN(Number(listing.bedrooms)))
    ) {
      if (listing.bedrooms == 'Studio') {
        propertySizeFreq['0'] = propertySizeFreq['0'] + 1;
        if (bookingValsFlag) {
          listing.bookings.forEach(bookingData => {
            propertySizeBookingVals['0'] = propertySizeBookingVals['0'] + bookingData.totalValue;
          });
        }
      } else if (Number(listing.bedrooms) >= 6) {
        propertySizeFreq['6'] = propertySizeFreq['6'] + 1;
        if (bookingValsFlag) {
          listing.bookings.forEach(bookingData => {
            propertySizeBookingVals['6'] = propertySizeBookingVals['6'] + bookingData.totalValue;
          });
        }
      } else {
        propertySizeFreq[listing.bedrooms] = propertySizeFreq[listing.bedrooms] + 1;
        if (bookingValsFlag) {
          listing.bookings.forEach(bookingData => {
            propertySizeBookingVals[listing.bedrooms] =
              propertySizeBookingVals[listing.bedrooms] + bookingData.totalValue;
          });
        }
      }
    } else if (
      listing.room_type &&
      (listing.room_type === 'private_room' ||
        listing.room_type === 'hotel_room' ||
        listing.room_type === 'shared_room')
    ) {
      propertySizeFreq['rooms'] = propertySizeFreq['rooms'] + 1;
      if (bookingValsFlag) {
        listing.bookings.forEach(bookingData => {
          propertySizeBookingVals['rooms'] =
            propertySizeBookingVals['rooms'] + bookingData.totalValue;
        });
      }
    }
  });

  if (bookingValsFlag) {
    // Taking avg of booking values for each property size
    Object.keys(propertySizeBookingVals).forEach(bed => {
      propertySizeBookingVals[bed] =
        propertySizeFreq[bed] > 0
          ? Math.round(propertySizeBookingVals[bed] / propertySizeFreq[bed])
          : 0;
    });
  }

  return bookingValsFlag ? propertySizeBookingVals : propertySizeFreq;
};

export const getSupplyByPropertySize = (
  listings: Listing[],
  cachedData: { [key: string]: number } | null = null
) => {
  let propertySizeFreq: { [key: string]: number } = {};
  if (cachedData) {
    propertySizeFreq = cachedData;
  } else {
    propertySizeFreq = getPropertySizeFreq(listings);
  }
  let supplyByPropertySize: BarGraphData[] = [];
  supplyByPropertySize = Object.keys(propertySizeFreq).map((bed: string) => {
    return {
      keyShort: getUserFriendlyPropertySizeName(bed, true),
      keyLong: getUserFriendlyPropertySizeName(bed),
      value: propertySizeFreq[bed],
    };
  });
  return supplyByPropertySize;
};

export const getUserFriendlyPropertySizeName = (bed: string, isShort = false) => {
  if (bed === '0') {
    return 'Studio';
  } else if (bed === '1') {
    return isShort ? '1' : '1 bedroom';
  } else if (bed === '6') {
    return isShort ? '6+' : '6+ bedrooms';
  } else if (bed === 'rooms') {
    return isShort ? 'rooms' : 'private/hotel/shared rooms';
  } else {
    return isShort ? bed : bed + ' bedrooms';
  }
};

export const getDemandByPropertySize = (listings: Listing[]) => {
  const propertySizeBookingVals = getPropertySizeFreq(listings, true);
  let demandByPropertySize: BarGraphData[] = [];

  const totalPropertySizeBookingVals = Object.values(propertySizeBookingVals).reduce(
    (a, b) => a + b,
    0
  );

  if (totalPropertySizeBookingVals === 0) {
    return demandByPropertySize;
  }

  demandByPropertySize = Object.keys(propertySizeBookingVals).map((bed: string) => {
    return {
      keyShort: getUserFriendlyPropertySizeName(bed, true),
      keyLong: getUserFriendlyPropertySizeName(bed),
      value: Math.round((propertySizeBookingVals[bed] / totalPropertySizeBookingVals) * 100),
    };
  });

  return demandByPropertySize;
};

export const getBookingTypeAndLeadFreq = (listings: Listing[] | ListingLegacy[]) => {
  let bookingTypesFreq = {
    'Single Night': 0, //1 night
    'Multiple Nights': 0, //2 - 6 nights
    Weekly: 0, // 7 - 15 nights
    'Mid-term': 0, // 15+ nights
  };

  let bookingLeadsFreq = {
    'Last-minute': 0, // <= 7
    Normal: 0, // 8 - 30
    Advanced: 0, // 30+
  };

  listings.forEach(listing => {
    listing.bookings.forEach(booking => {
      const bookingType = booking.numberNights;
      if (bookingType > 0) {
        if (bookingType === 1) {
          bookingTypesFreq['Single Night'] = bookingTypesFreq['Single Night'] + 1;
        } else if (bookingType > 1 && bookingType <= 6) {
          bookingTypesFreq['Multiple Nights'] = bookingTypesFreq['Multiple Nights'] + 1;
        } else if (bookingType > 6 && bookingType <= 15) {
          bookingTypesFreq['Weekly'] = bookingTypesFreq['Weekly'] + 1;
        } else {
          bookingTypesFreq['Mid-term'] = bookingTypesFreq['Mid-term'] + 1;
        }
      }

      const bookingLead = booking.bookingLead;
      if (bookingLead > 0) {
        if (bookingLead <= 7) {
          bookingLeadsFreq['Last-minute'] = bookingLeadsFreq['Last-minute'] + 1;
        } else if (bookingLead > 7 && bookingLead <= 30) {
          bookingLeadsFreq['Normal'] = bookingLeadsFreq['Normal'] + 1;
        } else {
          bookingLeadsFreq['Advanced'] = bookingLeadsFreq['Advanced'] + 1;
        }
      }
    });
  });

  return [bookingTypesFreq, bookingLeadsFreq];
};

export const getDemandByBookingTypeAndLead = (listings: any[]) => {
  const [bookingTypesFreq, bookingLeadsFreq] = getBookingTypeAndLeadFreq(listings);

  let demandByBookingType: BarGraphData[] = [];
  let demandByBookingLead: BarGraphData[] = [];

  const totalBookingTypes = Object.values(bookingTypesFreq).reduce((a, b) => a + b, 0);
  const totalBookingLeads = Object.values(bookingLeadsFreq).reduce((a, b) => a + b, 0);

  if (totalBookingTypes > 0) {
    demandByBookingType = Object.keys(bookingTypesFreq)
      .map((bookingType: string) => {
        return {
          keyLong: bookingType,
          value: Math.round((bookingTypesFreq[bookingType] / totalBookingTypes) * 100),
        };
      })
      .sort((a, b) => b.value - a.value);
  }

  if (totalBookingLeads > 0) {
    demandByBookingLead = Object.keys(bookingLeadsFreq)
      .map((bookingLead: string) => {
        return {
          keyLong: bookingLead,
          value: Math.round((bookingLeadsFreq[bookingLead] / totalBookingLeads) * 100),
        };
      })
      .sort((a, b) => b.value - a.value);
  }

  return [demandByBookingType, demandByBookingLead];
};

export const getAmenityDistribution = (
  listings: Listing[],
  cachedData: { [key: string]: number } | null = null
) => {
  let amenityFreq: { [key: string]: number } = {};
  Object.values(amenitiesObject).forEach(key => {
    amenityFreq[key] = 0;
  });
  let amenityDistribution: BarGraphData[] = [];
  let totalNumberOfListings = 0;

  if (!cachedData) {
    totalNumberOfListings = listings.length;
    if (totalNumberOfListings === 0) {
      return amenityDistribution;
    }

    listings.forEach((listing: Listing) => {
      Object.keys(amenitiesObject).forEach(amenity => {
        if (listing.amenities[amenity]) {
          amenityFreq[amenitiesObject[amenity]] = amenityFreq[amenitiesObject[amenity]] + 1;
        }
      });
    });

    amenityDistribution = Object.keys(amenityFreq)
      .map(amenity => {
        return {
          keyLong: amenity,
          value: Math.round((amenityFreq[amenity] / totalNumberOfListings) * 100),
        };
      })
      .sort((a, b) => b.value - a.value);
  } else {
    amenityDistribution = Object.keys(cachedData)
      .map(amenity => ({
        keyLong: amenitiesObject[amenity],
        value: cachedData[amenity],
      }))
      .sort((a, b) => b.value - a.value);
  }

  return amenityDistribution;
};

export const getCancellationPolicyDistribution = (
  listings: Listing[],
  cachedData: { [key: string]: number } | null = null
) => {
  let cancellationPolicyFreq = {
    'Flexible Cancellation Policy': 0,
    'Moderate Cancellation Policy': 0,
    'Strict Cancellation Policy': 0,
  };
  let cancellationPolicyDistribution: PieChartData[] = [];

  let totalNumberOfListings = listings.length;
  if (!cachedData && totalNumberOfListings === 0) {
    return cancellationPolicyDistribution;
  }

  if (!cachedData) {
    listings.forEach((listing: Listing) => {
      if (listing.cancellation_policy == 'f') {
        cancellationPolicyFreq['Flexible Cancellation Policy'] =
          cancellationPolicyFreq['Flexible Cancellation Policy'] + 1;
      }
      if (listing.cancellation_policy == 'm') {
        cancellationPolicyFreq['Moderate Cancellation Policy'] =
          cancellationPolicyFreq['Moderate Cancellation Policy'] + 1;
      }
      if (listing.cancellation_policy == 't') {
        cancellationPolicyFreq['Strict Cancellation Policy'] =
          cancellationPolicyFreq['Strict Cancellation Policy'] + 1;
      }
      if (listing.cancellation_policy == 's') {
        cancellationPolicyFreq['Strict Cancellation Policy'] =
          cancellationPolicyFreq['Strict Cancellation Policy'] + 1;
      }
    });

    cancellationPolicyDistribution = Object.keys(cancellationPolicyFreq)
      .map(cancellationPolicy => {
        return {
          name: cancellationPolicy,
          value: Math.round(
            (cancellationPolicyFreq[cancellationPolicy] / totalNumberOfListings) * 100
          ),
          percentage: Math.round(
            (cancellationPolicyFreq[cancellationPolicy] / totalNumberOfListings) * 100
          ),
          legend: cancellationPolicy[0],
        };
      })
      .sort((a, b) => b.value - a.value);
  } else {
    cancellationPolicyDistribution = Object.keys(cancellationPolicyFreq)
      .map(cancellationPolicy => ({
        name: cancellationPolicy,
        value: cachedData[cancellationPolicy.toLowerCase()[0]],
        percentage: cachedData[cancellationPolicy.toLowerCase()[0]],
        legend: cancellationPolicy[0],
      }))
      .sort((a, b) => b.value - a.value);
  }

  return cancellationPolicyDistribution;
};

export const getUserFriendlyPropertyTypeName = (
  propertyType: string,
  listingObject: Listing | ListingLegacy = {} as Listing | ListingLegacy
) => {
  if (
    !isEmpty(listingObject) &&
    listingObject.room_type === 'entire_home' &&
    listingObject.property_type === 'condo'
  ) {
    return 'Condo';
  } else if (propertyType === 'entire_home') {
    return 'Entire Home';
  } else if (propertyType === 'condo') {
    return 'Condo';
  } else if (propertyType === 'private_room') {
    return 'Private Room';
  } else if (propertyType === 'shared_room') {
    return 'Shared Room';
  } else if (propertyType === 'hotel_room') {
    return 'Hotel Room';
  } else return propertyType;
};

export const setValueListingObject = (
  listingObject: ListingLegacy,
  key: string,
  name: string,
  currency: string,
  resultObject
) => {
  listingObject[key].forEach((keyObject: ADR | OccupancyRate | Revenue) => {
    resultObject[`${name} (${keyObject.date})`] =
      keyObject[key] != 'missing' && keyObject[key] != 'inactive'
        ? convertCurrency(currency, keyObject[key])
        : keyObject[key];
  });
};

export const getListingCSVDataAsArray = (
  listings: Listing[] | ListingLegacy[],
  currency: string
) => {
  let data: {
    [key: string]: number | string;
  }[] = [];
  listings.forEach((listingObject: Listing | ListingLegacy) => {
    let propertyType: string = listingObject.room_type;
    let generatedPropertyType: string = getUserFriendlyPropertyTypeName(
      propertyType,
      listingObject
    );

    let exportedListingObject = {
      'Listing URL': `http://airbnb.com/rooms/${listingObject.listingID}`,
      'Property Type': generatedPropertyType,
      Latitude: listingObject.latitude,
      Longitude: listingObject.longitude,
      'Star Rating': listingObject.review_scores_rating,
      'Number of Active Days': isNaN(listingObject.activeDaysCount)
        ? 'Recently Added'
        : listingObject.activeDaysCount,
      Bedrooms: listingObject.bedrooms,
      'Has pool': listingObject.amenities.pool ? 't' : 'f',
      'Cleaning Fee': convertCurrency(currency, listingObject.cleaningFee),
      'Extra Guest Fee': convertCurrency(currency, listingObject.extraGuestFee),
    };

    let revenue = listingObject['revenue'];
    let occupancy = listingObject['occupancy'];
    let adr = listingObject['adr'];

    if (revenue) {
      for (let monthlyRev of revenue) {
        exportedListingObject[`Revenue (${monthlyRev.date})`] =
          monthlyRev.revenue == 'missing' || monthlyRev.revenue == 'inactive'
            ? getSuitableTextForMissingAndInactiveData(monthlyRev.revenue)
            : convertCurrency(currency, monthlyRev.revenue);
      }
    } else {
      exportedListingObject[`Revenue LTM`] = isNaN(listingObject['annualRevenueLTM'])
        ? 'Recently Added'
        : convertCurrency(currency, listingObject['annualRevenueLTM']);
    }

    if (occupancy) {
      for (let monthlyOcc of occupancy) {
        exportedListingObject[`Occupancy (${monthlyOcc.date})`] =
          monthlyOcc.occupancy == 'missing' || monthlyOcc.occupancy == 'inactive'
            ? getSuitableTextForMissingAndInactiveData(monthlyOcc.occupancy)
            : monthlyOcc.occupancy;
      }
    } else {
      exportedListingObject[`Occupancy LTM`] = isNaN(listingObject['occupancyRateLTM'])
        ? 'Recently Added'
        : listingObject['occupancyRateLTM'];
    }

    if (adr) {
      for (let monthlyAdr of adr) {
        exportedListingObject[`Daily Rate (${monthlyAdr.date})`] =
          monthlyAdr.adr == 'missing' || monthlyAdr.adr == 'inactive'
            ? getSuitableTextForMissingAndInactiveData(monthlyAdr.adr)
            : convertCurrency(currency, monthlyAdr.adr);
      }
    } else {
      exportedListingObject[`Adr LTM`] = isNaN(listingObject['adrLTM'])
        ? 'Recently Added'
        : convertCurrency(currency, listingObject['adrLTM']);
    }

    data.push(exportedListingObject);
  });
  return data;
};

const getSuitableTextForMissingAndInactiveData = val => {
  if (val === 'missing') {
    return 'N/A';
  } else {
    return 'Inactive';
  }
};

export const getLTMData = (
  metrics: string,
  data: ADR[] | OccupancyRate[] | Revenue[] | BookingsPerMonth[],
  isAnnual = false
) => {
  let totalVal: number = 0;
  let count: number = 0;
  data.forEach((dataObj: ADR | OccupancyRate | Revenue | BookingsPerMonth) => {
    if (dataObj[`${metrics}`] !== 'missing' && dataObj[`${metrics}`] !== 'inactive') {
      totalVal += dataObj[`${metrics}`];
      count++;
    }
  });

  if (count === 0) {
    return -1;
  }

  if (isAnnual) {
    return totalVal;
  }

  const ltmData = Math.round(totalVal / count);
  return ltmData;
};

export const makeDownloadableBlob = (data, name: string, addHeader = true, isDataCsv = false) => {
  const csvData: string = isDataCsv ? data : jsonArrayToCSV(data, addHeader);
  const blob: Blob = new Blob([csvData], {
    type: 'text/csv',
  });
  const url: string = window.URL.createObjectURL(blob);
  const link: HTMLAnchorElement = document.createElement('a');
  link.href = url;
  link.setAttribute('download', name + '.csv');
  document.body.appendChild(link);
  link.click();
  if (link && link.nodeType && link.nodeType === Node.ELEMENT_NODE) {
    document.body.removeChild(link);
  }
};

export const getSeasonalityBarColor = (
  seaosnality: number | null,
  returnLabel: boolean = false
) => {
  if (!seaosnality) return '';
  if (seaosnality <= 50) return returnLabel ? 'High' : COLOR_GREEN;
  else if (seaosnality <= 75) return returnLabel ? 'Mid' : COLOR_YELLOW;
  else return returnLabel ? 'Low' : COLOR_RED_LIGHT;
};

export const getSeasonality = (graphData, renderIn = '', selectedPercentile = '50') => {
  let seasonalityData = {} as {
    highestRevenue: Revenue;
    lowestRevenue: Revenue;
    seasonality: number;
  };

  let revenues: Revenue[] = [];

  if (renderIn === 'overview') {
    revenues = graphData.map(data => {
      return {
        date: data.monthYear,
        revenue: data.LTMData[`revenue${selectedPercentile}`] as number | 'missing' | 'inactive',
      };
    });
  } else if (renderIn === 'estimator') {
    revenues = graphData.map(data => {
      return {
        date: data.timePeriod,
        revenue: data[selectedPercentile] as number | 'missing' | 'inactive',
      };
    });
  } else {
    revenues = graphData.map(data => {
      return { date: data.timePeriod, revenue: data.Revenue as number | 'missing' | 'inactive' };
    });
  }

  const filteredRevenues = revenues.filter(
    revenue =>
      revenue.revenue !== 'missing' &&
      revenue.revenue !== 'inactive' &&
      !Number.isNaN(revenue.revenue)
  );

  const sortedRevenues = [...filteredRevenues].sort((a, b) => {
    return (a.revenue as number) - (b.revenue as number);
  });

  seasonalityData.highestRevenue = sortedRevenues[sortedRevenues.length - 1];
  seasonalityData.lowestRevenue = sortedRevenues[0];

  if (sortedRevenues.length > 0) {
    if (sortedRevenues.length >= 6) {
      const highRevenues: number[] = [
        sortedRevenues[sortedRevenues.length - 1]?.revenue as number,
        sortedRevenues[sortedRevenues.length - 2]?.revenue as number,
        sortedRevenues[sortedRevenues.length - 3]?.revenue as number,
      ];

      const lowRevenues: number[] = [
        sortedRevenues[0]?.revenue as number,
        sortedRevenues[1]?.revenue as number,
        sortedRevenues[2]?.revenue as number,
      ];

      const avgHigh =
        highRevenues.reduce((partial_sum: number, revenue: number) => partial_sum + revenue, 0) /
        highRevenues.length;

      const avgLow =
        lowRevenues.reduce((partial_sum: number, revenue: number) => partial_sum + revenue, 0) /
        lowRevenues.length;

      seasonalityData.seasonality = Math.round(((avgHigh - avgLow) / avgHigh) * 100);
    } else {
      const highestRevenue = sortedRevenues[sortedRevenues.length - 1]?.revenue as number;
      const lowestRevenue = sortedRevenues[0]?.revenue as number;
      seasonalityData.seasonality = Math.round(
        ((highestRevenue - lowestRevenue) / highestRevenue) * 100
      );
    }
  } else {
    // when no value is present
    seasonalityData.seasonality = 0;
  }

  return seasonalityData;
};

export const parseGraphVal = (
  data: ADR[] | OccupancyRate[] | Revenue[],
  yAxis: string,
  currency: string
) => {
  let returnVal: DigestCardGraphData[] = [];

  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  data.forEach((dataObj: ADR | OccupancyRate | Revenue) => {
    const key = Object.keys(dataObj)[1];
    const date = dataObj['date'];
    const monthName = monthNames[parseInt(date.split('-')[1]) - 1];
    const year = date.split('-')[0];
    returnVal.push({
      timePeriod: monthName + ', ' + year,
      [yAxis]:
        dataObj[`${key}`] != 'missing' && dataObj[`${key}`] != 'inactive' && key !== 'occupancy'
          ? convertCurrency(currency, dataObj[`${key}`])
          : dataObj[`${key}`],
      '0.25':
        key !== 'occupancy'
          ? convertCurrency(currency, dataObj[`${key}0.25`])
          : dataObj[`${key}0.25`],
      '0.5':
        key !== 'occupancy'
          ? convertCurrency(currency, dataObj[`${key}0.5`])
          : dataObj[`${key}0.5`],
      '0.75':
        key !== 'occupancy'
          ? convertCurrency(currency, dataObj[`${key}0.75`])
          : dataObj[`${key}0.75`],
      '0.9':
        key !== 'occupancy'
          ? convertCurrency(currency, dataObj[`${key}0.9`])
          : dataObj[`${key}0.9`],
    });
  });

  return returnVal;
};

export const processMarketHistoricalData = (
  historicalMarketLevelData,
  yAxisName,
  currency,
  timePeriod
) => {
  let returnVal: any[] = [];
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const dates = Object.keys(historicalMarketLevelData);
  dates.forEach(date => {
    const dateObj = historicalMarketLevelData[date];
    const key = getKeyForMarketHistoricalLevelData(yAxisName);
    const monthName = monthNames[parseInt(date.split('-')[1]) - 1];
    const year = date.split('-')[0];
    returnVal.push({
      timePeriod: monthName + ', ' + year,
      date: date,
      [yAxisName]:
        dateObj[`${key}`][`${key}_50`] != 'missing' &&
        dateObj[`${key}`][`${key}_50`] != 'inactive' &&
        key !== 'occupancy'
          ? convertCurrency(currency, dateObj[`${key}`][`${key}_50`])
          : dateObj[`${key}`][`${key}_50`],
      '0.25':
        key !== 'occupancy'
          ? convertCurrency(currency, dateObj[`${key}`][`${key}_25`])
          : dateObj[`${key}`][`${key}_25`],
      '0.5':
        key !== 'occupancy'
          ? convertCurrency(currency, dateObj[`${key}`][`${key}_50`])
          : dateObj[`${key}`][`${key}_50`],
      '0.75':
        key !== 'occupancy'
          ? convertCurrency(currency, dateObj[`${key}`][`${key}_75`])
          : dateObj[`${key}`][`${key}_75`],
      '0.9':
        key !== 'occupancy'
          ? convertCurrency(currency, dateObj[`${key}`][`${key}_90`])
          : dateObj[`${key}`][`${key}_90`],
    });
  });
  let data_as_per_time_period = returnVal.slice(-timePeriod);
  return data_as_per_time_period;
};

const getKeyForMarketHistoricalLevelData = yAxisName => {
  if (yAxisName === 'Revenue') {
    return 'revenue';
  } else if (yAxisName === 'Occupancy Rate') {
    return 'occupancy';
  } else {
    return 'adr';
  }
};

export const getKeyAsPerPercentileAndTitle = (metricsKey, percentile) => {
  if (percentile === 0.5) {
    if (metricsKey.includes('Revenue')) {
      return ['revenue', 'revenue_50'];
    } else if (metricsKey.includes('Occupancy')) {
      return ['occupancy', 'occupancy_50'];
    } else {
      return ['adr', 'adr_50'];
    }
  } else if (percentile === 0.25) {
    if (metricsKey.includes('Revenue')) {
      return ['revenue', 'revenue_50'];
    } else if (metricsKey.includes('Occupancy')) {
      return ['occupancy', 'occupancy_50'];
    } else {
      return ['adr', 'adr_50'];
    }
  } else if (percentile === 0.75) {
    if (metricsKey.includes('Revenue')) {
      return ['revenue', 'revenue_50'];
    } else if (metricsKey.includes('Occupancy')) {
      return ['occupancy', 'occupancy_50'];
    } else {
      return ['adr', 'adr_50'];
    }
  } else {
    if (metricsKey.includes('Revenue')) {
      return ['revenue', 'revenue_50'];
    } else if (metricsKey.includes('Occupancy')) {
      return ['occupancy', 'occupancy_50'];
    } else {
      return ['adr', 'adr_50'];
    }
  }
};

export const getHeadingStyle = (color: string) => {
  return {
    color: color,
    fontWeight: 'bold',
    marginBottom: '5px',
  };
};

export const getPropertySizePreviewTextObj = (
  parentCard: 'demand' | 'supply',
  filters: FilterVal,
  listings: Listing[]
) => {
  const variantKey =
    filters.bedrooms.length > 0 && filters.bedrooms[0] !== 100
      ? filters.bedrooms[0].toString()
      : '1';

  const propertySizeData =
    parentCard === 'supply' ? getPropertySizeFreq(listings) : getPropertySizeFreq(listings, true);
  const totalVal = Object.values(propertySizeData).reduce((a, b) => a + b);
  return {
    userFriendlyDataName: getUserFriendlyPropertySizeName(variantKey),
    previewVal: `${Math.round((propertySizeData[variantKey] / totalVal) * 100)}%`,
  };
};

export const getPropertyTypePreviewTextObj = (
  parentCard: 'demand' | 'supply',
  filters: FilterVal,
  listings: Listing[]
) => {
  const variantKey =
    filters.roomType.length > 0 && filters.roomType[0] !== 'all'
      ? filters.roomType[0]
      : 'entire_home';

  const propertyTypeData =
    parentCard === 'supply' ? getPropertyTypeFreq(listings) : getPropertyTypeFreq(listings, true);
  const totalVal = Object.values(propertyTypeData).reduce((a, b) => a + b);
  return {
    userFriendlyDataName: getUserFriendlyPropertyTypeName(variantKey),
    previewVal: `${Math.round((propertyTypeData[variantKey] / totalVal) * 100)}%`,
  };
};

export const getBookingTypeAndLeadPreviewTextObj = (
  variant: 'bookingType' | 'bookingLead',
  listings: Listing[]
) => {
  const [bookingTypesFreq, bookingLeadsFreq] = getBookingTypeAndLeadFreq(listings);
  const dataToUse = variant === 'bookingType' ? bookingTypesFreq : bookingLeadsFreq;
  const variantKey = Object.keys(dataToUse).reduce((a, b) => (dataToUse[a] > dataToUse[b] ? a : b));
  const totalVal = Object.values(dataToUse).reduce((a, b) => a + b);
  return {
    userFriendlyDataName: variantKey,
    previewVal: `${Math.round((dataToUse[variantKey] / totalVal) * 100)}%`,
  };
};

export const getPreviewTextObj = (
  parentCard: 'demand' | 'supply',
  variant: 'propertySize' | 'propertyType' | 'bookingType' | 'bookingLead',
  filters: FilterVal,
  listings: Listing[],
  annualNumberOfBookings: number = 0
) => {
  let previewTexObj: PreviewTextObj = {
    userFriendlyDataName: '',
    previewVal: '',
  };

  if (variant === 'propertySize') {
    previewTexObj = getPropertySizePreviewTextObj(parentCard, filters, listings);
  } else if (variant === 'propertyType') {
    previewTexObj = getPropertyTypePreviewTextObj(parentCard, filters, listings);
  } else {
    previewTexObj = getBookingTypeAndLeadPreviewTextObj(variant, listings);
  }

  return previewTexObj;
};

export const validateEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const intersect = (a: any[], b: any[]) => {
  const setB = new Set(b);
  const result: any[] = [];
  for (const item of a) {
    if (setB.has(item)) {
      result.push(item);
    }
  }
  return result;
};

export const getVisibleListings = (
  listings: ListingsProp,
  bounds: Bounds,
  filterActive: boolean,
  filteredListings: string[],
  onlyIDs = false
) => {
  let visibleListings: Listing[] = [];

  if (listings.loading || !listings.data) {
    return visibleListings;
  }

  const boundedListings = getBoundedListings(listings.data, bounds);
  if (boundedListings.length === 0) {
    return visibleListings;
  }

  const visibleListingIDs = filterActive
    ? new Set(intersect(boundedListings, filteredListings))
    : new Set(boundedListings);

  visibleListings = Object.keys(listings.data)
    .filter(listingID => visibleListingIDs.has(`${listingID}`))
    .map(listingID => ({
      listingID,
      ...listings.data[listingID],
    }));

  return onlyIDs ? (Array.from(visibleListingIDs) as string[]) : visibleListings;
};

export const getBoundedClusters = (clusters, bounds) => {
  if (!bounds || !Object.keys(clusters).length) return [];

  try {
    const swBound: Coordinates = bounds.southWest;
    const neBound: Coordinates = bounds.northEast;

    const polygon = [
      [swBound.lat, swBound.lng],
      [swBound.lat, neBound.lng],
      [neBound.lat, neBound.lng],
      [neBound.lat, swBound.lng],
    ];

    let boundedClusters: any[] = [];
    const batchSize = 50;

    const processBatch = batch => {
      batch.forEach(cluster => {
        const point = [cluster.centroid.latitude, cluster.centroid.longitude];
        if (classifyPoint(polygon, point) === -1 || classifyPoint(polygon, point) === 0) {
          boundedClusters.push(cluster);
        }
      });
    };

    const batches = chunk(clusters, batchSize);
    batches.forEach(processBatch);

    return boundedClusters;
  } catch (error) {
    console.log('error in getBoundedClusters', error);
    return [];
  }
};

export const calculateRollingYoYChange = (
  data: ADR[] | OccupancyRate[] | Revenue[] | TempObject[] | RechartsDataFormat[],
  metricsKey: string
) => {
  let rollingYoYChange: null | number = null;

  if (data.length < 24) return rollingYoYChange;

  let ltmData: number[] = [];
  let prevLTMData: number[] = [];
  let counter = 1;

  for (let i = data.length - 1; i > data.length - 1 - 24; i--) {
    const dataObj = data[i];
    if (counter > 24) break;
    if (counter <= 12 && dataObj[metricsKey] !== 'missing' && dataObj[metricsKey] !== 'inactive') {
      ltmData.push(dataObj[metricsKey]);
    }
    if (counter > 12 && dataObj[metricsKey] !== 'missing' && dataObj[metricsKey] !== 'inactive') {
      prevLTMData.push(dataObj[metricsKey]);
    }
    counter = counter + 1;
  }

  if (prevLTMData.length > 0) {
    rollingYoYChange = ((d3.mean(ltmData) - d3.mean(prevLTMData)) / d3.mean(prevLTMData)) * 100;
    rollingYoYChange = Math.round(rollingYoYChange * 100) / 100;
  }
  return rollingYoYChange;
};

export const formatGoogleMapsBounds = (mapBounds: GoogleMapReact.Bounds) => {
  const boundsObj: Bounds = {
    northEast: mapBounds.ne,
    southWest: mapBounds.sw,
  };
  return boundsObj;
};

export const convertBoundsArrayToObj = (boundsArray: number[]) => {
  return {
    northEast: {
      lat: boundsArray[3],
      lng: boundsArray[2],
    },
    southWest: {
      lat: boundsArray[1],
      lng: boundsArray[0],
    },
  } as Bounds;
};

export const convertBoundsObjToArray = (boundsObj: Bounds) => {
  if (!boundsObj) {
    return [] as number[];
  }
  const northEast = boundsObj.northEast;
  const southWest = boundsObj.southWest;
  return [southWest.lng, southWest.lat, northEast.lng, northEast.lat] as number[];
};

export const applySmartBounds = (
  map: any,
  maps: any,
  bounds: Bounds = {} as Bounds,
  polygons: any[] = [],
  zoom: number = 0,
  center: { lat: number; lng: number } = { lat: 0, lng: 0 }
) => {
  let enclosingBounds = new maps.LatLngBounds();
  if (bounds.northEast && bounds.southWest) {
    enclosingBounds = new maps.LatLngBounds(bounds.southWest, bounds.northEast);
  }

  if (polygons.length > 0) {
    polygons.forEach(polygon => {
      polygon
        .getPath()
        .getArray()
        .forEach((latLng: any) => {
          enclosingBounds.extend(latLng);
        });
    });
  }
  map.fitBounds(enclosingBounds);
  if (zoom > 12) map.setZoom(12);
  if (center.lat !== 0 && center.lng !== 0) map.setCenter(center);
};

export const applySmartBoundsForCoords = (map: any, maps: any, coordinates: number[][] = []) => {
  // Create a new LatLngBounds object
  const bounds = new maps.LatLngBounds();

  // Convert each coordinate pair to a LatLng object and extend the bounds
  coordinates.forEach(coord => {
    const latLng = new maps.LatLng(coord[1], coord[0]);
    bounds.extend(latLng);
  });

  // Fit the map to the computed bounds
  map.fitBounds(bounds);
};

export const handleMarketRecommendationClick = (
  nearbyRecommendedMarket: NearbyRecommendedMarket
) => {
  // open link to market in new tab
  const district = nearbyRecommendedMarket.district;
  const city = nearbyRecommendedMarket.city ? nearbyRecommendedMarket.city : '0';
  const countryName = nearbyRecommendedMarket.country
    ? nearbyRecommendedMarket.country.replaceAll(' ', '-')
    : '0';
  const marketLink = `${window.location.origin}/airbnb-data/${countryName}/${city}/${district}`;
  window.open(marketLink, '_blank');
};

export const makeLowerCase = (str: any) => {
  if (typeof str === 'object') {
    return '';
  }

  return str.toString().toLowerCase();
};

export const isObject = (obj: any) => {
  return obj !== null && typeof obj === 'object';
};

export const getGoogleLoader = () => {
  const loader = new Loader({
    apiKey: GOOGLE_MAPS_API_KEY,
    id: '__googleMapsScriptId',
    version: 'weekly',
    libraries: ['drawing', 'places', 'visualization'],
  });
  return loader;
};

export const geocodeAddress = async (address: string, noLoader: boolean = false) => {
  let lat = 0;
  let lng = 0;
  if (noLoader && (!window.google || !window.google.maps)) {
    // Wait for half a second for google maps to load
    await new Promise(r => setTimeout(r, 500));
  }
  try {
    const google = noLoader
      ? (window as any).google
      : (window as any).google && (window as any).google.maps
      ? (window as any).google
      : await getGoogleLoader().load();
    const geocoder = new google.maps.Geocoder();

    await geocoder.geocode({ address: `${address}` }, (results, status) => {
      if (status === 'OK' && results) {
        lat = results[0].geometry.location.lat();
        lng = results[0].geometry.location.lng();
      }
    });
  } catch (error) {
    console.log('error in estimator geocode ', error);
  }
  return [lat, lng];
};

export const calculateSmartDistance = (
  coordinate1: { lat: number; lng: number },
  coordinate2: { lat: number; lng: number }
) => {
  const R = 6371 * 1000; // metres
  const latRad = (coordinate1.lat * Math.PI) / 180;
  const lngRad = (coordinate2.lat * Math.PI) / 180;
  const latDefRad = ((coordinate2.lat - coordinate1.lat) * Math.PI) / 180;
  const lngDefRad = ((coordinate2.lng - coordinate1.lng) * Math.PI) / 180;

  const a =
    Math.sin(latDefRad / 2) * Math.sin(latDefRad / 2) +
    Math.cos(latRad) * Math.cos(lngRad) * Math.sin(lngDefRad / 2) * Math.sin(lngDefRad / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  let d = R * c; // in metres
  let unit = 'm';
  if (d >= 1000) {
    d = d / 1000;
    d = Math.round(d * 100) / 100;
    unit = 'km';
  } else {
    d = Math.round(d);
  }
  return `${d} ${unit}`;
};

export const formatCalendarDayName = (date: Date, matches: boolean): string => {
  const dateString = new Date(date);
  if (!matches) {
    return dateString.toLocaleDateString('en', { weekday: 'long' });
  } else {
    return dateString.toLocaleDateString('en', { weekday: 'short' });
  }
};

export const getFuture30DaysKeyMetrics = (rates: { [date: string]: Rate }) => {
  const next30DaysRates = Object.values(rates).slice(0, 30);
  const avgDailyRateNext30Days = Math.round(
    next30DaysRates.reduce((cur, rate) => cur + rate.rate, 0) / 30
  );
  const next30DaysBookedDaysCount = next30DaysRates.reduce(
    (cur, rate) => (rate.status === 'booked' || rate.status === 'recentlyBooked' ? cur + 1 : cur),
    0
  );
  const next30DaysAvailableDaysCount = next30DaysRates.reduce(
    (cur, rate) => (rate.status === 'available' ? cur + 1 : cur),
    0
  );
  const occupancyRateNext30Days = Math.round((next30DaysBookedDaysCount / 30) * 100);

  const avgAvailableDailyRateNext30Days =
    next30DaysAvailableDaysCount !== 0
      ? Math.round(
          next30DaysRates.reduce(
            (cur, rate) => (rate.status === 'available' ? cur + rate.rate : cur),
            0
          ) / next30DaysAvailableDaysCount
        )
      : 0;

  const avgBookedDailyRateNext30Days =
    next30DaysBookedDaysCount !== 0
      ? Math.round(
          next30DaysRates.reduce(
            (cur, rate) =>
              rate.status === 'booked' || rate.status === 'recentlyBooked' ? cur + rate.rate : cur,
            0
          ) / next30DaysBookedDaysCount
        )
      : 0;

  return {
    avgDailyRateNext30Days,
    occupancyRateNext30Days,
    avgAvailableDailyRateNext30Days,
    avgBookedDailyRateNext30Days,
  };
};

export const getUserSubscriptionStatus = (user: User) => {
  let userSubscriptionStatus: 'activeSubscriber' | 'inactiveSubscriber' | 'trialUser' | 'admin' =
    'trialUser';

  if (user.role === 'admin') {
    userSubscriptionStatus = 'admin';
    return userSubscriptionStatus;
  }

  if (user.isSubscribed) {
    userSubscriptionStatus = 'activeSubscriber';
    return userSubscriptionStatus;
  }

  if (user.customerID) {
    userSubscriptionStatus = 'inactiveSubscriber';
    return userSubscriptionStatus;
  }

  return userSubscriptionStatus;
};

export const getUnlockedMarketLife = (ended_at_dates: string[]): number => {
  const endedAtDate = new Date(ended_at_dates[ended_at_dates.length - 1]);
  // calculate difference in days between endedAtDate and today
  const daysLeft: number = moment(endedAtDate).diff(moment(), 'days');
  return daysLeft;
};

export const getEstimatorRegionUnlockStatus = (
  estimatorRegions: EstimatorRegions[],
  centerCoord: {
    lat: number;
    lng: number;
  },
  sampleEstimatorCenterCoord: { lat: number; lng: number }
) => {
  let isRegionUnlocked = false;

  if (isEqualObject(centerCoord, sampleEstimatorCenterCoord)) {
    isRegionUnlocked = true;
    return isRegionUnlocked;
  }

  const coordString = `(${centerCoord.lat},${centerCoord.lng})`;
  for (let estimatorRegion of estimatorRegions) {
    if (coordString === estimatorRegion.coordinate) {
      if (getUnlockedMarketLife(estimatorRegion.ended_at_dates) >= 0) {
        isRegionUnlocked = true;
        return isRegionUnlocked;
      }
    }
  }

  return isRegionUnlocked;
};

export const calculateRevenuePotentialRange = (
  listings: Listings,
  isCalledFromAdvanceDashboard = false
): number[] => {
  let maxRevPotential: number = 0;

  const allRevPotentialArray: number[] = [];
  const revenuePotentialRange: number[] = [];

  Object.keys(listings).forEach(listingID => {
    const listing = listings[listingID];
    if (listing.revenuePotential) {
      const currentRevPotential: number = listing.revenuePotential;
      if (!isNaN(currentRevPotential)) {
        maxRevPotential = Math.max(maxRevPotential, currentRevPotential);
        allRevPotentialArray.push(currentRevPotential);
      }
    }
  });

  if (isCalledFromAdvanceDashboard) {
    Object.values(listings).forEach(listing => {
      // For advance dashboard we will consider annual_revenue_ltm for revenue filter instead of revenue_Potential
      const annualRevenueLtm = Number(listing['annual_revenue_ltm']) || 0;

      if (!isNaN(annualRevenueLtm) && annualRevenueLtm > 0) {
        maxRevPotential = Math.max(maxRevPotential, annualRevenueLtm);
        allRevPotentialArray.push(annualRevenueLtm);
      }
    });
  }

  if (allRevPotentialArray.length < 2) {
    return [];
  }

  const percentile25: number = d3.quantile(allRevPotentialArray, 0.25);
  const percentile50: number = d3.quantile(allRevPotentialArray, 0.5);
  const percentile75: number = d3.quantile(allRevPotentialArray, 0.75);

  revenuePotentialRange.push(percentile25);
  revenuePotentialRange.push(percentile50);
  revenuePotentialRange.push(percentile75);

  revenuePotentialRange.push(maxRevPotential);

  return revenuePotentialRange;
};

export const getCountryDataFromCountryCode = (countryCode: string) => {
  let desiredData;
  countryListWithCode.map(countryData => {
    if (countryData.code === countryCode) {
      desiredData = countryData;
    }
  });
  return desiredData;
};

export const abbreviateNumber = (value: number, putDecimal: boolean = true): string => {
  if (value == null || value === undefined) {
    return '';
  }

  let newValue: number | string = value;

  // thousands, millions, billions
  const suffixes = ['', 'K', 'M', 'B', 'T'];
  let suffixNum: number = 0;

  while (Number(newValue) >= 1000) {
    newValue /= 1000;
    suffixNum++;
  }

  if (putDecimal) {
    // Check if the value is an integer before adding decimal
    newValue = Number.isInteger(newValue) ? newValue.toString() : newValue.toFixed(1);
  } else {
    newValue = newValue.toFixed(0);
  }

  newValue += suffixes[suffixNum];

  return newValue;
};

export const checkIfGooglePlacesSessionValid = (
  googleAutocompleteSessionTokenTimeStamp: null | number
) => {
  if (googleAutocompleteSessionTokenTimeStamp) {
    const timeSpent = (Date.now() - googleAutocompleteSessionTokenTimeStamp) / 1000;
    // console.log("===Time Spent: ", timeSpent)
    return timeSpent < 60 * 2.5;
  }
  return false;
};

export const getClusterGeoJSONObject = (listingID: string, lat: number, lng: number) => {
  return {
    type: 'Feature',
    properties: { cluster: true, crimeId: listingID, category: 'listing' },
    geometry: {
      type: 'Point',
      coordinates: [lng, lat],
    },
  };
};

export const convertListingsIntoGeoJSONArray = (listings: Listing[]) => {
  const listingsAsGeoJSON: any = [];
  listings.forEach(listing => {
    listingsAsGeoJSON.push(
      getClusterGeoJSONObject(listing.listingID, listing.latitude, listing.longitude)
    );
  });
  return listingsAsGeoJSON;
};

export const getCentroid = (points: { lat: number; lng: number }[]) => {
  const lats = points.map(point => point.lat);
  let lngs = points.map(point => point.lng);
  const minLat = Math.min(...lats);
  const maxLat = Math.max(...lats);
  let minLng = Math.min(...lngs);
  let maxLng = Math.max(...lngs);
  if (maxLng - minLng > 180) {
    lngs = points.map(point => (point.lng < maxLng - 180 ? point.lng + 360 : point.lng));
    minLng = Math.min(...lngs);
    maxLng = Math.max(...lngs);
  }
  return {
    lat: (minLat + maxLat) / 2,
    lng: (minLng + maxLng) / 2 > 180 ? (minLng + maxLng) / 2 - 360 : (minLng + maxLng) / 2,
  };
};

export const extractVisibleListings = (listings: ListingsProp) => {
  if (listings.loading || !listings.data) {
    return { data: [] as Listing[], loading: false } as VisibleListingsProp;
  }
  const visibleListings = Object.keys(listings.data)
    .filter(listingID => listings.data[listingID].visible)
    .map(listingID => ({ listingID, ...listings.data[listingID] } as Listing));
  return { data: visibleListings, loading: false } as VisibleListingsProp;
};

export const extractStaticListings = (listings: ListingsProp) => {
  if (listings.loading || !listings.data) {
    return { data: [] as Listing[], loading: false } as VisibleListingsProp;
  }
  const staticListings = Object.keys(listings.data).map(
    listingID => ({ listingID, ...listings.data[listingID] } as Listing)
  );
  return { data: staticListings, loading: false } as VisibleListingsProp;
};

export const convertListingsDictToArray = (listings: Listings | ListingsLegacy) => {
  const listingsArray = Object.entries(listings).map(
    ([listingID, listingVal]: [string, ListingVal | ListingValLegacy]) =>
      ({
        listingID,
        ...listingVal,
      } as Listing | ListingLegacy)
  );
  return listingsArray;
};

export const getMarketingTrackers = () => {
  let [lang, page, type, region] = ['', '', '', ''];
  const data = localStorage.getItem('marketing-trackers');
  if (data) {
    const marketingTrackers = JSON.parse(data);
    [lang, page, type, region] = [
      marketingTrackers.lang,
      marketingTrackers.page,
      marketingTrackers.type,
      marketingTrackers.region,
    ];
  }
  return [lang, page, type, region];
};

export const mapOptions = (
  map,
  showZoomButton: boolean = true,
  zoomButtonPosition: string = 'LEFT_BOTTOM'
) => {
  return {
    styles: mapStyles,
    fullscreenControl: false,
    zoomControlOptions: {
      position: map.ControlPosition[zoomButtonPosition],
    },
    zoomControl: showZoomButton ? true : false,
    clickableIcons: false,
    contextMenu: false,
  };
};

export const areArraysEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) {
    return false;
  }

  return arr1.every((obj, index) => {
    return JSON.stringify(obj) === JSON.stringify(arr2[index]);
  });
};

export const getKeyMetricsValByPercentile = (
  listings: Listing[],
  metricsKey: string,
  percentile: number = 0.5
) => {
  let median = -1;
  let values: number[] = [];
  listings.forEach(listing => {
    listing[`${metricsKey}`] &&
      !isNaN(listing['activeDaysCount']) &&
      listing['activeDaysCount'] >= 90 &&
      values.push(listing[`${metricsKey}`]);
  });
  if (values.length > 0) {
    median = Math.round(d3.quantile(values, percentile));
  }
  return median;
};

export const getSupplyByPropertyRevenue = (
  listings: Listing[],
  currency: string,
  cachedData: { [key: string]: number } | null = null
) => {
  let bedroomDistro = {
    '0': [],
    '1': [],
    '2': [],
    '3': [],
    '4': [],
    '5': [],
    '6+': [],
    rooms: [],
  } as { [key: string]: Listing[] };

  if (!cachedData) {
    listings.forEach((listing: Listing) => {
      if (
        !isNaN(Number(listing.activeDaysCount)) &&
        listing.activeDaysCount >= 90 &&
        ((listing.room_type && listing.room_type === 'entire_home') ||
          (listing.property_type && listing.property_type === 'condo')) &&
        (listing.bedrooms == 'Studio' || !isNaN(Number(listing.bedrooms)))
      ) {
        if (listing.bedrooms == 'Studio') {
          bedroomDistro['0'].push(listing);
        } else if (Number(listing.bedrooms) >= 6) {
          bedroomDistro['6+'].push(listing);
        } else {
          bedroomDistro[listing.bedrooms].push(listing);
        }
      } else if (
        listing.room_type &&
        (listing.room_type === 'private_room' ||
          listing.room_type === 'hotel_room' ||
          listing.room_type === 'shared_room')
      ) {
        bedroomDistro['rooms'].push(listing);
      }
    });
  }

  const calculateMedianRevenue = (listings: Listing[]) => {
    const medianAdrLTM = getKeyMetricsValByPercentile(listings, 'adrLTM');
    const medianOccupancyRateLTM = getKeyMetricsValByPercentile(listings, 'occupancyRateLTM');
    const medianRevenueFromCleaningFeeLTM = getKeyMetricsValByPercentile(
      listings,
      'revenueFromCleaningFeeLTM'
    );
    const revenue = Math.round(
      medianAdrLTM * (medianOccupancyRateLTM / 100) * 365 + medianRevenueFromCleaningFeeLTM
    );
    return revenue;
  };

  const result = Object.keys(cachedData ? cachedData : bedroomDistro).map(key => {
    return {
      keyShort: getUserFriendlyPropertySizeName(key, true),
      keyLong: getUserFriendlyPropertySizeName(key),
      value: convertCurrency(
        currency,
        cachedData ? cachedData[key] : calculateMedianRevenue(bedroomDistro[key])
      ),
    };
  });

  return result;
};

export const isLeapYear = (year: number) => {
  if (year % 400 === 0) {
    return true;
  } else if (year % 100 === 0) {
    return false;
  } else if (year % 4 === 0) {
    return true;
  }
  return false;
};

export const fetchMonthlyHistoricalData = async (url: string, auth: boolean = true) => {
  try {
    const data = await callApi(url, {}, auth);
    return data;
  } catch (err) {
    console.log('Error while calling getPastPricings: ', err);
    return null;
  }
};

export const processMonthlyHistoricalData = data => {
  const resultObj = {
    daily_past_pricings: {},
    monthly_past_pricings: {},
    weekly_past_pricings: {},
  };

  data.forEach(({ message }) => {
    resultObj['daily_past_pricings'] = {
      ...resultObj['daily_past_pricings'],
      ...message['daily_past_pricings'],
    };
    resultObj['monthly_past_pricings'] = {
      ...resultObj['monthly_past_pricings'],
      ...message['monthly_past_pricings'],
    };
    resultObj['weekly_past_pricings'] = {
      ...resultObj['weekly_past_pricings'],
      ...message['weekly_past_pricings'],
    };
  });

  return resultObj;
};

export const getQueryHistoryFilterParams = filterVal => {
  let queryString = '';

  const checkBoxOptions = {
    roomType: { name: 'propertyTypeFilter', size: 5 },
    bedrooms: { name: 'bedroomsFilter', size: 7 },
    bathrooms: { name: 'bathroomsFilter', size: 5 },
  };
  const rangeOptions = {
    accommodates: { name: 'sleepsFilter', range: [1, 16] },
    minimum_nights: { name: 'minimumStayFilter', range: [1, 30] },
    number_of_reviews: { name: 'numberOfReviewsFilter', range: [0, 1000] },
    rating: { name: 'ratingFilter', range: [3.9, 5] },
  };

  const processCheckbox = () => {
    Object.keys(checkBoxOptions).forEach((data, i) => {
      if (
        !(filterVal[data].includes(100) || filterVal[data].includes('all')) &&
        filterVal[data].length < checkBoxOptions[data].size
      ) {
        queryString += `${checkBoxOptions[data].name}=` + filterVal[data].join(',') + '&';
      }
    });
  };

  const processRange = () => {
    Object.keys(rangeOptions).forEach((data, i) => {
      if (!(filterVal[data].join('-') == rangeOptions[data].range.join('-'))) {
        queryString += `${rangeOptions[data].name}=` + filterVal[data].join('-') + '&';
      }
    });
  };

  processCheckbox();
  processRange();

  const amenitiesString = Object.keys(filterVal.amenities).reduce(
    (acc, key) => (filterVal.amenities[key] ? key + ',' : '' + acc),
    ''
  );
  if (amenitiesString !== '') {
    queryString += 'amenitiesFilter=' + amenitiesString + '&';
  }

  if (filterVal.hostType !== 'both') {
    queryString += 'professionallyManagedFilter=' + filterVal.hostType;
  }

  return queryString;
};

export const isListingLegacy = (listing: Listing | ListingLegacy): listing is ListingLegacy => {
  try {
    return listing.hasOwnProperty('isLegacy');
  } catch (err) {
    return false;
  }
};

export const getMiddlePoint = (lat1, lon1, lat2, lon2) => {
  const dLon = toRad(lon2 - lon1);

  // convert to radians
  lat1 = toRad(lat1);
  lat2 = toRad(lat2);
  lon1 = toRad(lon1);

  const Bx = Math.cos(lat2) * Math.cos(dLon);
  const By = Math.cos(lat2) * Math.sin(dLon);
  const lat3 = Math.atan2(
    Math.sin(lat1) + Math.sin(lat2),
    Math.sqrt((Math.cos(lat1) + Bx) * (Math.cos(lat1) + Bx) + By * By)
  );
  const lon3 = lon1 + Math.atan2(By, Math.cos(lat1) + Bx);

  // convert back to degrees
  const middleLat = toDegrees(lat3);
  const middleLon = toDegrees(lon3);

  return [middleLat, middleLon];
};

export const getMoMYoYChangeColor = (change: number) => {
  if (change >= 0) return COLOR_GREEN;
  else return COLOR_RED_LIGHT;
};

export const getStartingEndingDate = (date: any, full: boolean = false): string => {
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  if (!date) return '';

  const yearMonthArray = date.split('-');
  const year = yearMonthArray[0];
  const fullMonth = monthNames[~~yearMonthArray[1] - 1]; //~~ -> converts into an integer
  const shortMonth = fullMonth.substring(0, 3);
  return full ? fullMonth + ', ' + year : shortMonth + ', ' + year;
};

export const calculateMoMChange = (
  data: ADR[] | OccupancyRate[] | Revenue[] | TempObject[] | RechartsDataFormat[],
  metricsKey: string
) => {
  let momChange: null | number = null;

  if (data.length === 0) return momChange;

  if (
    data[data.length - 1][metricsKey] !== 'missing' &&
    data[data.length - 1][metricsKey] !== 'inactive' &&
    data[data.length - 2][metricsKey] !== 'missing' &&
    data[data.length - 2][metricsKey] !== 'inactive'
  ) {
    momChange = data[data.length - 1][metricsKey] - data[data.length - 2][metricsKey];
  }

  if (data[data.length - 2][metricsKey] > 0 && momChange !== null) {
    momChange = Math.round((momChange / data[data.length - 2][metricsKey]) * 100);
  }

  return momChange;
};

export const findExtremePointsOverPolygon = (coordinates: Coordinates[]) => {
  let north = coordinates[0];
  let west = coordinates[0];
  let south = coordinates[0];
  let east = coordinates[0];

  for (let i = 1; i < coordinates.length; i++) {
    const { lat, lng } = coordinates[i];

    if (lat > north.lat) {
      north = { lat, lng };
    }
    if (lng < west.lng) {
      west = { lat, lng };
    }
    if (lat < south.lat) {
      south = { lat, lng };
    }
    if (lng > east.lng) {
      east = { lat, lng };
    }
  }

  return {
    north,
    west,
    south,
    east,
  };
};

export const checkIfTopBannerShouldOpen = () => {
  const isBannerShown = window.localStorage.getItem(AIRBTICS_PRO_BANNER_LOCALSTORAGE_VARIABLE);
  return isBannerShown === 'true' ? false : true;
};

export const getBannerHeight = (isMobile: boolean) => {
  if (isMobile) {
    return TOP_BANNER_PADDING_MOBILE;
  }
  return TOP_BANNER_PADDING;
};

export const csvToDataGridObjectArray = (csvData: string) => {
  const rows = csvData.split('\n');
  let header: string[] = [];
  const result: { [key: string]: number | string }[] = [];

  rows.forEach((row, idx) => {
    const tempResultObj: { [key: string]: number | string } = {};
    // Split the row into individual values, accounting for quoted values with commas
    const cols = row.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);

    if (idx == 0) {
      // Removes if a column is ending with a specia char \r
      header = cols.map(item => item.replace(/\r/g, ''));
    } else {
      cols.forEach((col, colIdx) => {
        // Removing any "", it any vale have it
        tempResultObj[header[colIdx]] = col.replace(/"/g, '');
      });
      // Adding an id for each row
      tempResultObj.id = idx;
      result.push(tempResultObj);
    }
  });

  return result;
};

export const sortFormattedStringByNumber = (a, b, field) => {
  const sortDirection = field.api.getSortModel().sort;

  const numericValueA = extractNumericValue(a, -Infinity);
  const numericValueB = extractNumericValue(b, -Infinity);

  return sortDirection === 'asc' ? numericValueA - numericValueB : numericValueB - numericValueA;
};

export const extractNumericValue = (formattedValue: string, notNumberReturnValue: any = NaN) => {
  // Remove any non-digit characters (like commas, currency symbols, etc.)
  if (!formattedValue) return notNumberReturnValue;

  const numericValue = formattedValue.replace(/[^\d.-]/g, '');
  // Convert the extracted string to a number
  const numericValueAsNumber = parseFloat(numericValue);

  return isNaN(numericValueAsNumber) ? notNumberReturnValue : numericValueAsNumber;
};

export const getColorFromSizeLevel = (level: number | null) => {
  if (level === null) {
    return LIGHT_GREY;
  }
  if (level === 0) {
    return '#6100FF';
  } else if (level === 1) {
    return '#01CF2E';
  } else {
    return '#FC4141';
  }
};

export const getDistance = (fromLatitude, fromLongitude, toLatitude, toLongitude) => {
  const earthRadiusMiles = 3958.8; // Earth's radius in miles

  // Convert latitude and longitude from degrees to radians
  const fromLatRad = (fromLatitude * Math.PI) / 180;
  const fromLongRad = (fromLongitude * Math.PI) / 180;
  const toLatRad = (toLatitude * Math.PI) / 180;
  const toLongRad = (toLongitude * Math.PI) / 180;

  // Calculate the differences between coordinates
  const latDiff = toLatRad - fromLatRad;
  const longDiff = toLongRad - fromLongRad;

  // Calculate the distance using Haversine formula
  const a =
    Math.sin(latDiff / 2) ** 2 +
    Math.cos(fromLatRad) * Math.cos(toLatRad) * Math.sin(longDiff / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  // Calculate the distance in miles
  const distance = earthRadiusMiles * c;

  return distance;
};

export const getRateStatus = (rate: string) => {
  if (rate?.includes(':b')) {
    return 'booked';
  } else if (rate?.includes(':rb')) {
    return 'recentlyBooked';
  } else if (rate?.includes(':a')) {
    return 'available';
  } else {
    return 'inactive';
  }
};

export const getCompsDataRows = (compsets, listingPricingRecommendation) => {
  let rows: any = [];
  Object.keys(compsets).forEach(listingId => {
    if (listingPricingRecommendation.listing_details.listingID != listingId) {
      let listing = compsets[listingId].metadata;
      const {
        avgDailyRateNext30Days,
        occupancyRateNext30Days,
        avgAvailableDailyRateNext30Days,
        avgBookedDailyRateNext30Days,
      } = getFuture30DaysKeyMetrics(compsets[listingId].rates);
      let rowObj = {
        id: listingId,
        link: 'Airbnb',
        distance: getDistance(
          listingPricingRecommendation.listing_details.latitude,
          listingPricingRecommendation.listing_details.longitude,
          listing.latitude,
          listing.longitude
        ),
        bedrooms: listing.bedrooms,
        starRating: listing.review_scores_rating,
        adr: avgDailyRateNext30Days,
        occupancyRate: occupancyRateNext30Days,
      };
      rows.push(rowObj);
    }
  });
  rows.sort((a, b) => b.occupancyRate - a.occupancyRate);
  rows = rows.slice(0, 50);
  return rows;
};

export const formatCompetitorRatesForRecharts = (
  compsets: Compsets,
  dateList: string[],
  selectedComps: string[],
  userListingId?: string
) => {
  let competitorRatesRecharts: RechartsDataFormat[] = [];
  let competitormedianRatesRecharts: RechartsDataFormat[] = [];
  let noOfBookedDays = 0;
  let noOfAvailiableDays = 0;
  let medianBookedRatesForListView: any[] = [];
  Object.keys(compsets).forEach(listingID => {
    if (selectedComps.includes(listingID) || listingID == userListingId) {
      dateList.forEach((date: string) => {
        const rate =
          compsets[listingID].rates[date].rate + '-' + compsets[listingID].rates[date].status;
        const dateIndex = competitorRatesRecharts.findIndex(
          rechartsData => rechartsData.date === date
        );
        if (dateIndex !== -1) {
          competitorRatesRecharts[dateIndex][listingID] = rate;
        } else {
          competitorRatesRecharts.push({
            date: date,
            [listingID]: rate,
          });
        }
      });
    }
  });
  competitorRatesRecharts.forEach(data => {
    let comp_rate: any[] = [];
    let booked_rate: any[] = [];
    let temp_date: string | Number = '';
    let userListingRate: any;

    Object.keys(data).forEach(key => {
      if (key != 'date' && key !== userListingId) {
        let status = (data[key] + '').split('-')[1];
        comp_rate.push((data[key] + '').split('-')[0]);
        if (status == 'booked' || status == 'recentlyBooked') {
          booked_rate.push((data[key] + '').split('-')[0]);
          medianBookedRatesForListView.push((data[key] + '').split('-')[0]);
          noOfBookedDays += 1;
        }
        if (status !== 'blocked' && status !== 'inactive') {
          noOfAvailiableDays += 1;
        }
      } else if (key === userListingId) {
        userListingRate = (data[key] + '').split('-')[0];
      } else {
        temp_date = data[key];
      }
    });
    competitormedianRatesRecharts.push({
      90: Math.round(d3.quantile(comp_rate, 0.9)),
      75: Math.round(d3.quantile(comp_rate, 0.75)),
      50: Math.round(d3.quantile(comp_rate, 0.5)),
      25: Math.round(d3.quantile(comp_rate, 0.25)),
      median_booked_rate: Math.round(d3.quantile(booked_rate, 0.5)) || 0,
      user_listing_rate: userListingRate,
      date: temp_date,
    });
  });

  let marketLevelmedianOccupancyRate = Number(
    ((noOfBookedDays / noOfAvailiableDays) * 100).toFixed(2)
  );
  let marketLevelmedianBookedRate = Math.round(d3.quantile(medianBookedRatesForListView, 0.5));
  let marketLevelAvailibiltyRate = noOfAvailiableDays / selectedComps.length;
  return {
    competitormedianRatesRecharts,
    marketLevelmedianOccupancyRate,
    marketLevelmedianBookedRate,
    marketLevelAvailibiltyRate,
  };
};

export const getnextNDates = noOfDates => {
  const today = new Date();
  const nextNDays: any[] = [];

  for (let i = 1; i <= noOfDates; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    nextNDays.push(`${year}-${month}-${day}`);
  }

  return nextNDays;
};

export const getLastNDates = noOfDates => {
  const today = new Date();
  const lastNDates: any[] = [];

  for (let i = 0; i <= noOfDates + 1; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() - i);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    lastNDates.push(`${year}-${month}-${day}`);
  }

  return lastNDates;
};

export const getCompMetaData = rawMetadata => {
  const rawListings = rawMetadata.comps;
  const processedListings: Listings = processListing(rawListings);
  return processedListings;
};

export const getCompetitorRates = (
  listings: RateAndAvailChanges[],
  dateList: string[],
  compMetadata: Listings
) => {
  let compsets: Compsets = {};
  dateList.forEach(date => {
    listings.forEach((listing, index) => {
      let rate = listing[date] as string;
      const status: 'booked' | 'recentlyBooked' | 'available' | 'inactive' = getRateStatus(rate);
      let prevRate = '';
      rate = rate?.replace(/:b|:rb|:a|:na/g, '');
      if (rate?.includes('->')) {
        const ratesArr = rate?.split(' -> ');
        rate = ratesArr[1];
        prevRate = ratesArr[0];
      }
      rate = rate?.replace('$', '');
      prevRate = prevRate?.replace('$', '');
      const rateObj = {
        rate: parseInt(rate),
        prevRate: prevRate ? parseInt(prevRate) : 0,
        status: status,
      };
      const listingID = listing.listingID;
      if (compsets[listingID]) {
        compsets[listingID].rates[date] = rateObj;
      } else {
        compsets[listingID] = {
          name: listing.title,
          color: COMPETITOR_RATES_COLORS[index],
          rates: {
            [date]: rateObj,
          },
          metadata: compMetadata[listingID],
        };
      }
    });
  });

  return compsets;
};

export const splitStringToList = inputString => {
  if (inputString) {
    const stringList = inputString.split(',');
    return stringList;
  } else {
    return [];
  }
};

export const processListingLevelData = (rate_and_avail_changes, listingId, nextNDates) => {
  let listingfutureRates: any[] = [];
  let listingfutureBookingCount = 0;
  let listingAvailiableCount = 0;
  rate_and_avail_changes.forEach(individualData => {
    if (individualData.listingID === listingId) {
      nextNDates.forEach(date => {
        let rate = individualData[date];
        const status: 'booked' | 'recentlyBooked' | 'available' | 'inactive' = getRateStatus(rate);
        rate = rate?.replace(/:b|:rb|:a|:na/g, '');
        if (rate?.includes('->')) {
          const ratesArr = rate?.split(' -> ');
          rate = ratesArr[1];
        }
        rate = rate?.replace('$', '');
        // console.log("status>>",status ,"rate>>", rate);
        if (status === 'booked' || status === 'recentlyBooked') {
          listingfutureRates.push(rate);
          listingfutureBookingCount += 1;
        }
        if (status !== 'inactive') {
          listingAvailiableCount += 1;
        }
      });
    }
  });

  let listingMedianFutureRate: number = Math.round(d3.quantile(listingfutureRates, 0.5)) || 0;
  let listingOccupancyRate: number =
    Number(((listingfutureBookingCount / listingAvailiableCount) * 100).toFixed(2)) || 0 || 0;
  return { listingOccupancyRate, listingMedianFutureRate, listingAvailiableCount };
};

export const processMarketLevelData = (listingPricingRecommendation, nextNDates, saved_comps) => {
  const compRatesObj = listingPricingRecommendation.comp_dict.rate_and_avail_changes;
  const compMetadata: Listings = getCompMetaData(
    listingPricingRecommendation.comp_listings_metadata
  );
  const compsets: Compsets = getCompetitorRates(compRatesObj, nextNDates, compMetadata);

  const DataRows = getCompsDataRows(compsets, listingPricingRecommendation);
  const top10CompsAsPerOccupancyRate = DataRows.slice(0, 10).map(row => row.id);
  // console.log("top10CompsAsPerOccupancyRate", top10CompsAsPerOccupancyRate, typeof(top10CompsAsPerOccupancyRate))

  const selectedComps = saved_comps.length > 0 ? saved_comps : top10CompsAsPerOccupancyRate;

  const {
    competitormedianRatesRecharts,
    marketLevelmedianOccupancyRate,
    marketLevelmedianBookedRate,
    marketLevelAvailibiltyRate,
  } = formatCompetitorRatesForRecharts(
    compsets,
    nextNDates,
    selectedComps,
    listingPricingRecommendation.listing_details.listingID
  );
  return {
    marketLevelmedianOccupancyRate,
    marketLevelmedianBookedRate,
    marketLevelAvailibiltyRate,
  };
};

export const calculateValueDifference = (value1, value2) => {
  if (value1 !== 'N/A' && value2 !== 'N/A') {
    return Number(value1) - Number(value2);
  }
  return 0;
};

export const getProcessedDataForDynamicPricing = (
  data,
  noOfFutureDates,
  sortBy,
  compsSelectedFromManageListingModal,
  searchId = ''
) => {
  let processData: any = [];
  let nextNDates = getnextNDates(noOfFutureDates);
  data.map(item => {
    if (item.comp_listings_metadata !== 'insufficient_listings') {
      const unprocessed_saved_comps = item.saved_comps;
      let saved_comps = splitStringToList(unprocessed_saved_comps);

      //the below if condition will only execute for comparison table in Manage listing modal not for user listings
      if (compsSelectedFromManageListingModal.length > 0) {
        saved_comps = compsSelectedFromManageListingModal;
      }

      const {
        listingOccupancyRate,
        listingMedianFutureRate,
        listingAvailiableCount,
      } = processListingLevelData(
        item.comp_dict.rate_and_avail_changes,
        item.listing_details.listingID,
        nextNDates
      );
      const {
        marketLevelmedianOccupancyRate,
        marketLevelmedianBookedRate,
        marketLevelAvailibiltyRate,
      } = processMarketLevelData(item, nextNDates, saved_comps);

      let listingAvailiableCountValue = (
        (listingAvailiableCount / Number(noOfFutureDates)) *
        100
      ).toFixed(2);
      let compsAvailiableCountValue = (
        (marketLevelAvailibiltyRate / Number(noOfFutureDates)) *
        100
      ).toFixed(2);

      let listingRevPARValue =
        ((listingOccupancyRate / 100) * listingMedianFutureRate).toFixed(2) == '0.00'
          ? 'N/A'
          : ((listingOccupancyRate / 100) * listingMedianFutureRate).toFixed(2);

      let compsMedianRevPARValue =
        ((marketLevelmedianOccupancyRate / 100) * marketLevelmedianBookedRate).toFixed(2) == '0.00'
          ? 'N/A'
          : ((marketLevelmedianOccupancyRate / 100) * marketLevelmedianBookedRate).toFixed(2);

      let revPARDiffValue = calculateValueDifference(listingRevPARValue, compsMedianRevPARValue);
      let occupancyDiffValue = calculateValueDifference(
        listingOccupancyRate,
        marketLevelmedianOccupancyRate
      );
      let bookedRateDiffValue = calculateValueDifference(
        listingMedianFutureRate,
        marketLevelmedianBookedRate
      );

      let usefullData = {
        listingId: item.listing_details.listingID,
        name: item.listing_details.name,
        bedrooms: item.listing_details.bedrooms,
        bathrooms: item.listing_details.bathrooms,
        thumbnail_url: item.listing_details.thumbnail_url,
        listingOccupancy: listingOccupancyRate || 0,
        listingBookingRate: listingMedianFutureRate || 'N/A',
        listingRevPAR: listingRevPARValue,
        listingAvailiableCountPercentage: listingAvailiableCountValue,
        compsAvailiableCountPercentage: compsAvailiableCountValue,
        compsMedianOccupancy: marketLevelmedianOccupancyRate || 0,
        compsMedianBookingRate: marketLevelmedianBookedRate || 'N/A',
        compsMedianRevPAR: compsMedianRevPARValue,
        revPARDiff: revPARDiffValue,
        occupancyDiff: occupancyDiffValue,
        bookedRateDiff: bookedRateDiffValue,
        listingPricingRecommendation: item,
      };
      processData.push(usefullData);
    } else {
      const {
        listingOccupancyRate,
        listingMedianFutureRate,
        listingAvailiableCount,
      } = processListingLevelData(
        item.comp_dict.rate_and_avail_changes,
        item.listing_details.listingID,
        nextNDates
      );

      let listingRevPARValue =
        ((listingOccupancyRate / 100) * listingMedianFutureRate).toFixed(2) == '0.00'
          ? 'N/A'
          : ((listingOccupancyRate / 100) * listingMedianFutureRate).toFixed(2);

      let listingAvailiableCountValue = (
        (listingAvailiableCount / Number(noOfFutureDates)) *
        100
      ).toFixed(2);

      let usefullData = {
        listingId: item.listing_details.listingID,
        name: item.listing_details.name,
        bedrooms: item.listing_details.bedrooms,
        bathrooms: item.listing_details.bathrooms,
        thumbnail_url: item.listing_details.thumbnail_url,
        listingOccupancy: listingOccupancyRate || 0,
        listingBookingRate: listingMedianFutureRate || 'N/A',
        listingRevPAR: listingRevPARValue || 'N/A',
        listingAvailiableCountPercentage: listingAvailiableCountValue || 'N/A',
        compsAvailiableCountPercentage: 'N/A',
        compsMedianOccupancy: 'N/A',
        compsMedianBookingRate: 'N/A',
        compsMedianRevPAR: 'N/A',
        revPARDiff: 0,
        occupancyDiff: 0,
        bookedRateDiff: 0,
        listingPricingRecommendation: item,
      };
      processData.push(usefullData);
    }
  });
  processData = processData.sort((a, b) => a[sortBy] - b[sortBy]);

  if (searchId) {
    processData = processData.filter(item => item.listingId.includes(searchId));
  }
  return processData;
};
export const calculateBounds = (path: Coordinates[][]) => {
  let minLat = Infinity;
  let maxLat = -Infinity;
  let minLng = Infinity;
  let maxLng = -Infinity;

  path[0].forEach(point => {
    if (!isNaN(point.lat)) {
      minLat = Math.min(minLat, point.lat);
      maxLat = Math.max(maxLat, point.lat);
    }
    if (!isNaN(point.lng)) {
      minLng = Math.min(minLng, point.lng);
      maxLng = Math.max(maxLng, point.lng);
    }
  });

  return { minLat, maxLat, minLng, maxLng };
};

export const normalizeLongitude = (longitude: number) => {
  longitude = longitude % 360; // Wrap around the world
  if (longitude <= -180) {
    return longitude + 360;
  } else if (longitude > 180) {
    return longitude - 360;
  } else {
    return longitude;
  }
};

export const isPolygonWithinBounds = (
  polygonPath: Coordinates[][],
  bound: GoogleMapReact.Bounds
) => {
  const isWithinBounds = (point, bounds) => {
    const latInRange =
      (point.lat >= bounds.sw.lat && point.lat <= bounds.ne.lat) ||
      (point.lat <= bounds.sw.lat && point.lat >= bounds.ne.lat);

    const lngInRange =
      bounds.sw.lng <= bounds.ne.lng
        ? // Normal case: Bounds don't cross antimeridian
          point.lng >= bounds.sw.lng && point.lng <= bounds.ne.lng
        : // Bounds cross antimeridian
          point.lng >= bounds.sw.lng || point.lng <= bounds.ne.lng;

    return latInRange && lngInRange;
  };

  // Normalizing the bounds for lng like < -180 and > 180
  Object.keys(bound).map(key => {
    bound[key].lng = normalizeLongitude(bound[key].lng);
  });

  const polygonBound = calculateBounds(polygonPath);
  const polygonCorners = [
    { lat: polygonBound.minLat, lng: polygonBound.minLng }, // SW
    { lat: polygonBound.minLat, lng: polygonBound.maxLng }, // SE
    { lat: polygonBound.maxLat, lng: polygonBound.minLng }, // NW
    { lat: polygonBound.maxLat, lng: polygonBound.maxLng }, // NE
  ];

  for (let i = 0; i < polygonCorners.length; i++) {
    if (!isWithinBounds(polygonCorners[i], bound)) {
      return false;
    }
  }

  return true;
};

export const isPointWithinBounds = (
  point: string | { lat: number; lng: number },
  bounds: GoogleMapReact.Bounds
) => {
  // Function to normalize longitude to range [-180, 180]
  const normalizeLongitude = (lng: number) => {
    while (lng < -180) lng += 360;
    while (lng > 180) lng -= 360;
    return lng;
  };

  // Parse the point string to extract latitude and longitude
  const parsePoint = (point: string) => {
    const [lng, lat] = point
      .replace('POINT(', '')
      .replace(')', '')
      .split(' ')
      .map(parseFloat);
    return { lat, lng: normalizeLongitude(lng) };
  };

  // Normalize bounds' longitudes
  bounds.sw.lng = normalizeLongitude(bounds.sw.lng);
  bounds.ne.lng = normalizeLongitude(bounds.ne.lng);

  // Parse the input point
  let parsedPoint;
  if (point && typeof point === 'string') {
    parsedPoint = parsePoint(point);
  } else if (point && typeof point === 'object') {
    parsedPoint = { lat: point?.lat, lng: point?.lng };
  } else {
    return false;
  }

  // Check if the parsed point is within the bounds
  const latInRange = parsedPoint.lat >= bounds.sw.lat && parsedPoint.lat <= bounds.ne.lat;
  const lngInRange =
    bounds.sw.lng <= bounds.ne.lng
      ? parsedPoint.lng >= bounds.sw.lng && parsedPoint.lng <= bounds.ne.lng
      : parsedPoint.lng >= bounds.sw.lng || parsedPoint.lng <= bounds.ne.lng;

  return latInRange && lngInRange;
};

export const getGoogleMapBoundFormat = (paths: { lat: number; lng: number }[]) => {
  const bounds = new google.maps.LatLngBounds();
  paths.forEach(path => {
    bounds.extend(new google.maps.LatLng(path.lat, path.lng));
  });
  return bounds;
};

export const checkIfDateExpired = (end_date_str: string): boolean => {
  const end_date = new Date(end_date_str);
  const current_date = new Date();
  const time_difference = end_date.getTime() - current_date.getTime();
  const days_difference = Math.floor(time_difference / (1000 * 60 * 60 * 24));
  return days_difference < 0;
};

export const checkUserCountryAccessStatusWithMarket = (user: User, market: Search) => {
  const marketCountryCode = market.countryCode;
  const countryAccessList = user.country_wide_access_list;

  let marketSubscriptionStatus: 'subscribed' | 'not-subscribed' = 'not-subscribed';

  if (!countryAccessList || countryAccessList.length === 0) {
    return 'out-of-range';
  }

  // Check if it has country access
  let isCountryAccessValid = false;
  countryAccessList.forEach(country => {
    if (country.country_code === marketCountryCode) {
      if (!checkIfDateExpired(country.ended_at_date[country.ended_at_date.length - 1])) {
        isCountryAccessValid = true;
      }
    }
  });

  if (!isCountryAccessValid) return 'out-of-range';

  // Check if the region already exists
  user.regions.forEach(region => {
    if (region.region.toLowerCase() === market.name.toLowerCase()) {
      const lastDate = region.ended_at_dates[region.ended_at_dates.length - 1];
      if (!checkIfDateExpired(lastDate)) {
        marketSubscriptionStatus = 'subscribed';
      }
    }
  });

  return marketSubscriptionStatus;
};

export const trackUserDataVerificationAttempt = (market: string): Boolean => {
  const key = DATA_VERIFICATION_ATTEMPT_TRACKER_LS_KEY;
  let trackerArray: string[] = [];
  let tracked = true;

  if (market.toLowerCase() === sampleMarket) return false;

  if (localStorage.getItem(key) == null) {
    tracked = false;
  } else {
    const existingTracker = localStorage.getItem(key) as string;
    trackerArray = JSON.parse(existingTracker);
    tracked = trackerArray.includes(market) ? true : false;
  }

  if (!tracked) {
    trackerArray.push(market);
    localStorage.setItem(key, JSON.stringify(trackerArray));
    const api =
      'https://qdo7trqmn7.execute-api.us-east-2.amazonaws.com/default/trackProductAnalytics';
    const config = { dataVerificationAttemptedMarket: market };
    callApi(api, { queryParams: config }, true);
    return true;
  }

  return false;
};

export const updateDynamoDBForUserVerification = (
  market: string,
  setSubscriptionModalOpen: React.Dispatch<React.SetStateAction<boolean>>,
  user: User
) => {
  // This Function is responsible to track User data verification step and show subscription popup after 20 sec of user verification step
  const isDynamoDBUpdated: Boolean = trackUserDataVerificationAttempt(market);
  let doesUserOpenSubscriptionModalIntentionally = window.localStorage.getItem(
    'userOpenSubscriptionModalIntentionally'
  );

  if (isDynamoDBUpdated && !doesUserOpenSubscriptionModalIntentionally) {
    let credits = user.credits || 0;
    let estimatorCredits = user.estimatorCredits || 0;

    if (credits == 0 || estimatorCredits == 0) {
      setTimeout(() => {
        setSubscriptionModalOpen(true);
      }, 20000);
    }
  }
};

export const trackUserDynamicDataUpdateAttempt = () => {
  const api =
    'https://qdo7trqmn7.execute-api.us-east-2.amazonaws.com/default/trackProductAnalytics';
  const config = { dynamicDataUpdateAttempt: true };
  callApi(api, { queryParams: config }, true);
};

export const updateUserOpenedSubscriptionModalInDynamoDB = () => {
  const api =
    'https://qdo7trqmn7.execute-api.us-east-2.amazonaws.com/default/trackProductAnalytics';
  const config = { subscriptionModalOpened: true };
  callApi(api, { queryParams: config }, true);
};

export const updateUserEstimatorSuggestionClickInDynamoDB = () => {
  const api =
    'https://qdo7trqmn7.execute-api.us-east-2.amazonaws.com/default/trackProductAnalytics';
  const config = { userClickedOnEstimatorSearch: true };
  callApi(api, { queryParams: config }, true);
};

export const trackDiscoveryAIFunnelEvent = event => {
  const api =
    'https://qdo7trqmn7.execute-api.us-east-2.amazonaws.com/default/trackProductAnalytics';
  const config = { [event]: true };
  callApi(api, { queryParams: config }, true);
};

export const trackUserSearchedIndividualListingThroughLink = () => {
  const api =
    'https://qdo7trqmn7.execute-api.us-east-2.amazonaws.com/default/trackProductAnalytics';
  const config = { UserSearchedIndividualListingThroughLink: true };
  callApi(api, { queryParams: config }, true);
};

export const trackFilterActivation = () => {
  const api =
    'https://qdo7trqmn7.execute-api.us-east-2.amazonaws.com/default/trackProductAnalytics';
  const config = { filterActivated: true };
  callApi(api, { queryParams: config }, true);
};

export const trackConfigurableOverviewGraphActivation = () => {
  const api =
    'https://qdo7trqmn7.execute-api.us-east-2.amazonaws.com/default/trackProductAnalytics';
  const config = { overviewGraphConfigured: true };
  callApi(api, { queryParams: config }, true);
};

export const trackLast3YearsDataInterest = () => {
  const api =
    'https://qdo7trqmn7.execute-api.us-east-2.amazonaws.com/default/trackProductAnalytics';
  const config = { last3YearsDataInterest: true };
  callApi(api, { queryParams: config }, true);
};

export const trackDistributionDataActivation = () => {
  const api =
    'https://qdo7trqmn7.execute-api.us-east-2.amazonaws.com/default/trackProductAnalytics';
  const config = { distirbutionDataChecked: true };
  callApi(api, { queryParams: config }, true);
};

export const parseGuest = (input: string): ParsedGuest => {
  if (!input || Object.keys(input).length <= 0) {
    return {} as ParsedGuest;
  }
  return JSON.parse(input);
};

export const brightConsole = () => {
  return {
    log: (...data) =>
      console.log(
        '\n\n%cSEARCH: ',
        'color: cyan; font-weight: bold; font-size: 20px;',
        ...data,
        '\n\n\n'
      ),
    error: (...data) =>
      console.log(
        '\n\n%cERROR: ',
        'color: red; font-weight: bold; font-size: 20px;',
        ...data,
        '\n\n\n'
      ),
  };
};

const convertKeys = (obj: Record<string, any>): Record<string, any> => {
  const newObj: Record<string, any> = {};
  for (const [key, value] of Object.entries(obj)) {
    const keyReversed = key.split('').reverse();
    const underscoreIndex = keyReversed.indexOf('_');
    underscoreIndex > -1 && keyReversed.splice(underscoreIndex, 1);
    let newKey = keyReversed.reverse().join('');
    if (newKey.startsWith('adr')) {
      newKey = 'daily_rate' + newKey.split('adr')[1];
    }
    if (newKey == 'supply') {
      newKey = 'active_listings_count';
    }
    newObj[newKey] = value;
  }
  return newObj;
};

export const parseMessageHistoricalData = (message: CachedMarketDataTypes) => {
  const newHistoricalDataObj: any = {};
  if (message && message.historical_monthly_performance) {
    for (const key in message.historical_monthly_performance) {
      newHistoricalDataObj[key] = convertKeys(message.historical_monthly_performance[key]);
    }
  }
  message.historical_monthly_performance = newHistoricalDataObj;

  const formatSupplyBreakdown = (breakdown: any) => {
    const formattedBreakdown: any = {};
    for (const key in breakdown) {
      formattedBreakdown[key] = { supply: breakdown[key] };
    }
    return formattedBreakdown;
  };

  if (message && message.supply_breakdown.accommodates) {
    message.supply_breakdown.accommodates = formatSupplyBreakdown(
      message.supply_breakdown.accommodates
    );
  }

  if (message && message.supply_breakdown.active_days_count) {
    message.supply_breakdown.active_days_count = formatSupplyBreakdown(
      message.supply_breakdown.active_days_count
    );
  }

  return message;
};

export const findKeyByValue = (obj: any, value: any) => {
  for (const key in obj) {
    if (obj[key] === value) {
      return key;
    }
  }

  return null;
};

export const getUniqueUserId = (user: User) => {
  let uniqueUserId: string | null = null;

  try {
    uniqueUserId =
      String(user.email.split('@')[0]).replace(/[+]/g, '_') + '__' + user.userSignUpDay.toString();
  } catch (err) {
    console.log('Error while setting an unique user id: ', err);
  }
  return uniqueUserId;
};

export const calculateKeyMetrices = (
  metrics: string[],
  listing: ListingVal,
  type: string,
  metricsKpiObjects: { [key: string]: { [key: string]: number[] } }
) => {
  const inputOutMetricsNameMap = {
    occupancyRateLTM: 'occupancyRate',
    revenuePotential: 'revenue',
    adrLTM: 'adr',
    revPAN: 'revPAN',
    revenueFromCleaningFeeLTM: 'revenueFromCleaningFeeLTM',
  };

  metrics.forEach(metric => {
    if (!metricsKpiObjects[type][inputOutMetricsNameMap[metric]]) {
      metricsKpiObjects[type][inputOutMetricsNameMap[metric]] = [listing[metric]] as number[];
    } else {
      metricsKpiObjects[type][inputOutMetricsNameMap[metric]].push(listing[metric]);
    }
  });
};

export const calculatePercentile = (data, percentile = 0.5) => {
  let median = -1;
  let values: number[] = [];
  data.forEach(item => {
    item && values.push(item);
  });
  if (values.length > 0) {
    median = Math.round(d3.quantile(values, percentile));
  }
  return median;
};

export const getMeanFromMetricsObject = (propertyTypeObjects: {
  [key: string]: { [key: string]: number[] };
}) => {
  const meanKpiObj: { [key: string]: { [key: string]: number } } = {};
  Object.keys(propertyTypeObjects).forEach(propertyType => {
    meanKpiObj[propertyType] = {};
    Object.keys(propertyTypeObjects[propertyType]).forEach(metric => {
      if (metric == 'revenue') {
        const medianAdrLTM = calculatePercentile(propertyTypeObjects[propertyType]['adr']);
        const medianOccupancyRateLTM = calculatePercentile(
          propertyTypeObjects[propertyType]['occupancyRate']
        );
        const medianRevenueFromCleaningFeeLTM = calculatePercentile(
          propertyTypeObjects[propertyType]['revenueFromCleaningFeeLTM']
        );
        const revenue = Math.round(
          medianAdrLTM * (medianOccupancyRateLTM / 100) * 365 + medianRevenueFromCleaningFeeLTM
        );
        meanKpiObj[propertyType][metric] = revenue;
      } else {
        meanKpiObj[propertyType][metric] = calculatePercentile(
          propertyTypeObjects[propertyType][metric]
        );
      }
    });
  });
  return meanKpiObj;
};

export const calculatePropertyTypeMetrics = (
  listingID: string,
  listings: { [key: string]: ListingVal },
  propertyTypeObjects: { [key: string]: { [key: string]: any } }
) => {
  //Entire Home
  const listing = listings[listingID];
  if (
    listing.room_type &&
    listing.room_type === 'entire_home' &&
    listing.property_type &&
    listing.property_type !== 'condo'
  ) {
    calculateKeyMetrices(
      ['occupancyRateLTM', 'adrLTM', 'revenuePotential', 'revenueFromCleaningFeeLTM'],
      listings[listingID],
      'entire_home',
      propertyTypeObjects
    );
  } else if (listing.property_type && listing.property_type === 'condo') {
    calculateKeyMetrices(
      ['occupancyRateLTM', 'adrLTM', 'revenuePotential', 'revenueFromCleaningFeeLTM'],
      listings[listingID],
      'condo',
      propertyTypeObjects
    );
  } else {
    calculateKeyMetrices(
      ['occupancyRateLTM', 'adrLTM', 'revenuePotential', 'revenueFromCleaningFeeLTM'],
      listings[listingID],
      listing.room_type,
      propertyTypeObjects
    );
  }
};

export const calculatePropertySizeMetrics = (
  listingID: string,
  listings: { [key: string]: ListingVal },
  propertySizeObjects: { [key: string]: { [key: string]: number[] } }
) => {
  try {
    const listing = listings[listingID];
    const bedrooms = listing.bedrooms;
    if (
      (listing.room_type && listing.room_type === 'entire_home') ||
      (listing.property_type && listing.property_type === 'condo')
    ) {
      if (bedrooms == '0' || bedrooms == 'Studio') {
        calculateKeyMetrices(
          ['occupancyRateLTM', 'adrLTM', 'revenuePotential', 'revenueFromCleaningFeeLTM'],
          listing,
          'studio',
          propertySizeObjects
        );
      } else if (Number(bedrooms) >= 6) {
        calculateKeyMetrices(
          ['occupancyRateLTM', 'adrLTM', 'revenuePotential', 'revenueFromCleaningFeeLTM'],
          listing,
          '6+',
          propertySizeObjects
        );
      } else {
        calculateKeyMetrices(
          ['occupancyRateLTM', 'adrLTM', 'revenuePotential', 'revenueFromCleaningFeeLTM'],
          listing,
          bedrooms,
          propertySizeObjects
        );
      }
    }
  } catch (e) {
    console.error('Ignore', e);
  }
};

export const intializeAmenityObject = () => {
  return {
    kitchen: {
      type: 'basic',
    },
    parking: {
      type: 'basic',
    },
    wifi: {
      type: 'basic',
    },
    heating: {
      type: 'basic',
    },
    dryer: {
      type: 'basic',
    },
    tv: {
      type: 'basic',
    },
    washer: {
      type: 'basic',
    },
    bbq_grill: {
      type: 'basic',
    },
    breakfast: {
      type: 'basic',
    },
    fireplace: {
      type: 'advanced',
    },
    pool: {
      type: 'advanced',
    },
    hot_tub: {
      type: 'advanced',
    },
    gym: {
      type: 'advanced',
    },
    ac: {
      type: 'advanced',
    },
  };
};

export const initializeAmenityDistributionByPropertySize = () => {
  return {
    studio: {
      present: [],
      absent: [],
      total: 0,
    },
    1: {
      present: [],
      absent: [],
      total: 0,
    },
    2: {
      present: [],
      absent: [],
      total: 0,
    },
    3: {
      present: [],
      absent: [],
      total: 0,
    },
    4: {
      present: [],
      absent: [],
      total: 0,
    },
    5: {
      present: [],
      absent: [],
      total: 0,
    },
    '6+': {
      present: [],
      absent: [],
      total: 0,
    },
  };
};

export const calculateAmenitySupplyByPropertySize = (
  listings: { [key: string]: ListingVal },
  amenityObject
) => {
  const distributeAmenityByPropertySize = (listingID, listingVal, bedroomCategory) => {
    Object.keys(amenityObject).forEach(amenity => {
      if (!amenityObject[amenity].hasOwnProperty('supply')) {
        amenityObject[amenity]['supply'] = initializeAmenityDistributionByPropertySize();
      }

      const presentOrAbsent = listingVal.amenities[amenity] ? 'present' : 'absent';
      amenityObject[amenity]['supply'][bedroomCategory][presentOrAbsent].push(listingID);

      amenityObject[amenity]['supply'][bedroomCategory]['total']++;
    });
  };

  Object.keys(listings).forEach(listingID => {
    const listingVal = listings[listingID];
    const roomType = listingVal.room_type;
    const bedrooms = listingVal.bedrooms;
    try {
      if (roomType === 'entire_home') {
        if (bedrooms === '0' || bedrooms === 'Studio') {
          distributeAmenityByPropertySize(listingID, listingVal, 'studio');
        } else if (Number(bedrooms) >= 6) {
          distributeAmenityByPropertySize(listingID, listingVal, '6+');
        } else {
          distributeAmenityByPropertySize(listingID, listingVal, bedrooms);
        }
      }
    } catch (e) {
      console.error('Ignore', e);
    }
  });
};

export const setPropertySizeToUseForRevPanChange = (amenityObject, proportionThreshold = 0.05) => {
  /*
    The following code represents a core business logic
    to choose the size of bedrooms to use for calculating revPAN impact of each amenity.

    Why are we choosing a single property size (bedroom)?
    To remove biases that can skew the revPAN impact of each amenity based on property type and size.

    Bedroom Selection Algorithm ordered by Priority:
    1. Bedroom with the highest amenity_absent proportion
      - Skip bedroom if either all listings have the amenity or non have it.
    2. Bedroom with the highest absolute supply of the amenity when absence proportions are within a threshold of 5%
      - To increase the number of samples for calculating median

    Proportion Threshold:
      - A threshold to determine when absence proportions are considered close.
      - If the difference in absence proportions is within this threshold, consider supply.

  */

  Object.keys(amenityObject).forEach(amenity => {
    const bedroomCategories = Object.keys(amenityObject[amenity].supply);

    let chosenBedroom = bedroomCategories[0];
    let highestAbsenceProportion = 0;

    // TODO: reduce the complexity of the follwoing loop from O(n^2) to O(n)
    bedroomCategories.forEach(bedroomCategory => {
      const absentCount = amenityObject[amenity].supply[bedroomCategory].absent.length;
      const totalCount = amenityObject[amenity].supply[bedroomCategory].total;
      const currentAbsenceProportion = absentCount / totalCount || 0;
      amenityObject[amenity].supply[bedroomCategory]['absentProportion'] = currentAbsenceProportion;

      // Skip bedrooms with absence proportion 1 or 0
      if (currentAbsenceProportion === 1 || currentAbsenceProportion === 0) {
        return;
      }

      if (currentAbsenceProportion > highestAbsenceProportion) {
        highestAbsenceProportion = currentAbsenceProportion;
        chosenBedroom = bedroomCategory;

        bedroomCategories.forEach(bedroom => {
          const absentCount = amenityObject[amenity].supply[bedroom].absent.length;
          const totalCount = amenityObject[amenity].supply[bedroom].total;
          const absenceProportion = absentCount / totalCount || 0;

          if (
            Math.abs(absenceProportion - highestAbsenceProportion) <= proportionThreshold &&
            amenityObject[amenity].supply[bedroom].present.length >
              amenityObject[amenity].supply[chosenBedroom].present.length
          ) {
            chosenBedroom = bedroom;
          }
        });
      }
    });

    amenityObject[amenity]['chosenBedroom'] = chosenBedroom;
  });
};

export const calculateRevPanChange = (listings: { [key: string]: ListingVal }, amenityObject) => {
  const returnObj = Object.keys(amenitiesObject).reduce((result, key) => {
    result[key] = {};
    return result;
  }, {});

  Object.keys(amenityObject).forEach(amenity => {
    const bedroomToUse = amenityObject[amenity].chosenBedroom;
    const revPanForListingsWithAmenity: number[] = [];
    const revPanForListingsWithoutAmenity: number[] = [];

    amenityObject[amenity].supply[bedroomToUse].present.forEach(listingID => {
      const listing = listings[listingID];
      const revPAN = listing.revPAN;
      revPanForListingsWithAmenity.push(revPAN);
    });

    amenityObject[amenity].supply[bedroomToUse].absent.forEach(listingID => {
      const listing = listings[listingID];
      const revPAN = listing.revPAN;
      revPanForListingsWithoutAmenity.push(revPAN);
    });

    const medianRevPanForListingsWithAmenity = d3.median(revPanForListingsWithAmenity);
    const medianRevPanForListingsWithoutAmenity = d3.median(revPanForListingsWithoutAmenity);
    let revPanChange = Math.round(
      ((medianRevPanForListingsWithAmenity - medianRevPanForListingsWithoutAmenity) /
        medianRevPanForListingsWithoutAmenity) *
        100
    );

    /*
   Moderations
   - If RevPAN change is negative, it's capped at 0
   - for Advanced amenities RevPAN change is > 100%, it's capped at 100%
   - for Basic amenities RevPAN change is > 50%, it's capped at 50%
   
   */

    revPanChange = revPanChange < 0 ? 0 : revPanChange;

    if (amenityObject[amenity].type == 'basic') {
      revPanChange = revPanChange > 50 ? 50 : revPanChange;
    } else {
      revPanChange = revPanChange > 100 ? 100 : revPanChange;
    }

    returnObj[amenity]['revPanChange'] = revPanChange;
  });

  return returnObj;
};

export const getAmenityRevPanChange = (listings: { [key: string]: ListingVal }) => {
  const amenityObject = intializeAmenityObject();
  calculateAmenitySupplyByPropertySize(listings, amenityObject);
  setPropertySizeToUseForRevPanChange(amenityObject);
  const amenityRevPanChange = calculateRevPanChange(listings, amenityObject);
  return amenityRevPanChange;
};

export const caculateBathroomNumberMetrics = (
  listingID: string,
  listings: { [key: string]: ListingVal },
  bathroomNumberObject: { [key: string]: { [key: string]: number[] } }
) => {
  const listing = listings[listingID];
  const bathrooms: number = listing.bathrooms;

  if (bathrooms >= 6) {
    calculateKeyMetrices(['occupancyRateLTM'], listing, '6+', bathroomNumberObject);
  } else {
    calculateKeyMetrices(['occupancyRateLTM'], listing, String(bathrooms), bathroomNumberObject);
  }
};

export const getDataPercentileRange = (
  listings: { [key: string]: ListingVal },
  metrics: string[]
) => {
  const metricsDataObj: { [key: string]: number[] } = {};
  const metricsPercentileObj: { [key: string]: number[] } = {};

  Object.keys(listings).forEach(listingID => {
    metrics.forEach(metric => {
      if (metricsDataObj[metric]) {
        if (listings[listingID][metric] !== 'N/A') {
          metricsDataObj[metric].push(listings[listingID][metric]);
        }
      } else {
        if (listings[listingID][metric] !== 'N/A') {
          metricsDataObj[metric] = [listings[listingID][metric]];
        }
      }
    });
  });

  const quantiles = [0, 0.2, 0.4, 0.6, 0.8, 1];
  Object.keys(metricsDataObj).forEach(metric => {
    // Calculate the values for each quantile
    const quantileValues = quantiles.map(quantile => {
      return d3.quantile(metricsDataObj[metric], quantile);
    });

    metricsPercentileObj[metric] = quantileValues;
  });

  return metricsPercentileObj;
};

export const calculateAdrRangeMetrics = (
  listingID: string,
  listings: { [key: string]: ListingVal },
  adrRanngeObject: { [key: string]: { [key: string]: number[] } }
) => {
  const listing = listings[listingID];
  const adr: number = listing.adrLTM;
  let selectedRange: string | null = null;

  for (const range in adrRanngeObject) {
    const [start, end] = range.split('-').map(Number);
    if (adr >= start && adr < end) {
      selectedRange = range;
      break;
    }
  }

  if (selectedRange == null) {
    const keys = Object.keys(adrRanngeObject);
    selectedRange = keys[keys.length - 1];
  }

  selectedRange &&
    calculateKeyMetrices(['occupancyRateLTM'], listing, selectedRange, adrRanngeObject);
};

export const calculateMinNightRangeMetrics = (
  listingID: string,
  listings: { [key: string]: ListingVal },
  minNightRangeObject: { [key: string]: { [key: string]: number[] } }
) => {
  const listing = listings[listingID];
  const adr: number = listing.minimum_nights;
  let selectedRange: string | null = null;

  for (const range in minNightRangeObject) {
    const [start, end] = range.split('-').map(Number);
    if (adr >= start && adr <= end) {
      selectedRange = range;
      break;
    }
  }

  selectedRange &&
    calculateKeyMetrices(['occupancyRateLTM'], listing, selectedRange, minNightRangeObject);
};

export const calculateRatingRangeMetrics = (
  listingID: string,
  listings: { [key: string]: ListingVal },
  ratingRangeObject: { [key: string]: { [key: string]: number[] } }
) => {
  const listing = listings[listingID];
  const adr: number = listing.review_scores_rating;
  let selectedRange: string | null = null;

  for (const range in ratingRangeObject) {
    const [start, end] = range.split('-').map(Number);
    if (adr >= start && adr < end) {
      selectedRange = range;
      break;
    }
  }

  selectedRange &&
    calculateKeyMetrices(['occupancyRateLTM'], listing, selectedRange, ratingRangeObject);
};

export const calculateCapacityWiseTotalListings = (
  listingID: string,
  listings: { [key: string]: ListingVal },
  capacityObject: { [key: string]: { [key: string]: number } }
) => {
  const listing = listings[listingID];
  const capacity: number = listing.accommodates;

  const capacityStr = capacity >= 16 ? '16+' : String(capacity);

  if (capacityObject[capacityStr]['supply']) {
    capacityObject[capacityStr]['supply'] = capacityObject[capacityStr]['supply'] + 1;
  } else {
    capacityObject[capacityStr]['supply'] = 1;
  }
};

export const calculateAvailabilityWiseTotalListings = (
  listingID: string,
  listings: { [key: string]: ListingVal },
  calculateAvailabilityWiseTotalListings: { [key: string]: { [key: string]: number } }
) => {
  const listing = listings[listingID];
  const activeDays: any = listing.activeDaysCount;
  let selectedRange: string | null = '-';

  for (const range in calculateAvailabilityWiseTotalListings) {
    const [start, end] = range.split('-').map(Number);
    if (activeDays >= start && activeDays <= end) {
      selectedRange = range;
      break;
    }
  }

  if (selectedRange != '-') {
    if (calculateAvailabilityWiseTotalListings[selectedRange]['supply']) {
      calculateAvailabilityWiseTotalListings[selectedRange]['supply'] =
        calculateAvailabilityWiseTotalListings[selectedRange]['supply'] + 1;
    } else {
      calculateAvailabilityWiseTotalListings[selectedRange]['supply'] = 1;
    }
  }
};

export const calculateListingsPerHostsMetrics = (
  hostIdListingGrouped: { [key: string]: { [key: string]: number[] } },
  metrics: string[],
  listingsPerHostObject: { [key: string]: { [key: string]: number[] } }
) => {
  const inputOutMetricsNameMap = {
    occupancyRateLTM: 'occupancyRate',
    revenuePotential: 'revenue',
    adrLTM: 'adr',
  };

  const updateListingsPerHostCount = (key: string, data: number[], metric: string) => {
    if (listingsPerHostObject[key] && listingsPerHostObject[key][metric]) {
      listingsPerHostObject[key][inputOutMetricsNameMap[metric]] = [
        ...listingsPerHostObject[key][inputOutMetricsNameMap[metric]],
        ...data,
      ];
    } else {
      listingsPerHostObject[key] = {};
      listingsPerHostObject[key][inputOutMetricsNameMap[metric]] = [...data];
    }
  };

  Object.keys(hostIdListingGrouped).forEach(hostID => {
    const currentHostListingCount = hostIdListingGrouped[hostID][metrics[0]].length;
    metrics.map(metric => {
      if (currentHostListingCount === 1) {
        updateListingsPerHostCount('1', hostIdListingGrouped[hostID][metric], metric);
      } else if (currentHostListingCount >= 2 && currentHostListingCount <= 5) {
        updateListingsPerHostCount('2-5', hostIdListingGrouped[hostID][metric], metric);
      } else if (currentHostListingCount >= 6 && currentHostListingCount <= 20) {
        updateListingsPerHostCount('6-20', hostIdListingGrouped[hostID][metric], metric);
      } else {
        updateListingsPerHostCount('21+', hostIdListingGrouped[hostID][metric], metric);
      }
    });
  });
};

export const getHostIdListingGroupedWithMetrics = (
  listings: { [key: string]: ListingVal },
  metrics: string[]
) => {
  const hostIdListingMap: { [key: string]: { [key: string]: number[] } } = {};

  Object.keys(listings).forEach(listingID => {
    const currentHostID: string = String(listings[listingID].hostId);

    metrics.forEach(metric => {
      let currentMetricValue = listings[listingID][metric];
      if (currentMetricValue !== 'N/A' && !isNaN(Number(currentMetricValue))) {
        currentMetricValue = Number(currentMetricValue);
        if (!hostIdListingMap[currentHostID]) {
          hostIdListingMap[currentHostID] = {};
        }
        if (!hostIdListingMap[currentHostID][metric]) {
          hostIdListingMap[currentHostID][metric] = [];
        }
        hostIdListingMap[currentHostID][metric].push(currentMetricValue);
      }
    });
  });

  return hostIdListingMap;
};

export const initilizeFilterObject = (keys: string[], isDynamicRange: boolean = false) => {
  const resultObj: { [key: string]: { [key: string]: number[] } } = {};
  if (!isDynamicRange) {
    keys.forEach(key => {
      resultObj[key] = {};
    });
  } else {
    for (let i = 0; i < keys.length - 1; i++) {
      resultObj[keys[i] + '-' + keys[i + 1]] = {};
    }
  }
  return resultObj;
};

const createDistributionObject = data => {
  const createSlabs = (arr, numSlabs, isDiscrete) => {
    const filteredArr = arr.filter(value => !isNaN(value));
    if (filteredArr.length === 0) return {};

    const max = Math.max(...filteredArr);
    const min = Math.min(...filteredArr);
    const logMin = Math.log(min);
    const logMax = Math.log(max);
    const interval = isDiscrete ? 10 : (logMax - logMin) / numSlabs;

    let slabs = {};
    for (let i = 0; i < numSlabs; i++) {
      let start = isDiscrete ? i * interval : Math.exp(logMin + i * interval);
      let end = isDiscrete ? start + interval : Math.exp(logMin + (i + 1) * interval);
      slabs[`${Math.round(start)} - ${Math.round(end)}`] = 0;
    }

    filteredArr.forEach(value => {
      for (let i = 0; i < numSlabs; i++) {
        let start = isDiscrete ? i * interval : Math.exp(logMin + i * interval);
        let end = isDiscrete ? start + interval : Math.exp(logMin + (i + 1) * interval);
        if (value >= start && value < end) {
          slabs[`${Math.round(start)} - ${Math.round(end)}`]++;
          break;
        }
      }
    });

    return slabs;
  };

  const numSlabsForDiscrete = 10;
  const numSlabsForContinuous = 5;

  const result = {};

  Object.keys(data).forEach(key => {
    const categoryData = data[key];
    result[key] = {};

    if (categoryData.occupancyRate) {
      result[key].occupancyRate = createSlabs(
        categoryData.occupancyRate,
        numSlabsForDiscrete,
        true
      );
    }

    if (categoryData.adr) {
      result[key].adr = createSlabs(categoryData.adr, numSlabsForContinuous, false);
    }

    if (categoryData.revenue) {
      result[key].revenue = createSlabs(categoryData.revenue, numSlabsForContinuous, false);
    }
  });

  return result;
};

export const calculateDashboardFilters = (
  listings: { [key: string]: ListingVal },
  isUserAllowed: boolean
) => {
  const { adrLTM: adrPercentiled } = getDataPercentileRange(listings, ['adrLTM']);
  const hostIdListingGrouped = getHostIdListingGroupedWithMetrics(listings, ['occupancyRateLTM']);

  const propertyTypeObjects = initilizeFilterObject([
    'entire_home',
    'private_room',
    'condo',
    'hotel_room',
    'shared_room',
  ]);
  const propertySizeObjects = initilizeFilterObject(['studio', '1', '2', '3', '4', '5', '6+']);
  const bathroomNumberObject = initilizeFilterObject(['0', '1', '2', '3', '4', '5', '6+']);
  const adrRangeObject = initilizeFilterObject(adrPercentiled.map(String), true);
  const ratingRangeObject = initilizeFilterObject([
    '0-4',
    '4-4.3',
    '4.3-4.6',
    '4.6-4.8',
    '4.8-5.1',
  ]);
  const minNightRangeObject = initilizeFilterObject(['1-6', '7-29', '30-999']);
  const capacityListingNumObject = (initilizeFilterObject([
    ...Array.from({ length: 15 }, (_, index) => index + 1).map(String),
    '16+',
  ]) as unknown) as { [key: string]: { [key: string]: number } };
  const daysAvailableListingNumObject = (initilizeFilterObject([
    '90-180',
    '181-270',
    '271-367',
  ]) as unknown) as { [key: string]: { [key: string]: number } };
  const listingsPerHostObject = initilizeFilterObject(['1', '2-5', '6-20', '21+']);

  Object.keys(listings).forEach(listingID => {
    if (
      listings[listingID]['activeDaysCount'] &&
      Number(listings[listingID]['activeDaysCount'] >= 90)
    ) {
      //Property Type Filter
      calculatePropertyTypeMetrics(listingID, listings, propertyTypeObjects);
      calculatePropertySizeMetrics(listingID, listings, propertySizeObjects);
      caculateBathroomNumberMetrics(listingID, listings, bathroomNumberObject);
      calculateAdrRangeMetrics(listingID, listings, adrRangeObject);
      calculateRatingRangeMetrics(listingID, listings, ratingRangeObject);
      calculateMinNightRangeMetrics(listingID, listings, minNightRangeObject);
      calculateCapacityWiseTotalListings(listingID, listings, capacityListingNumObject);
      // the below func is bugged @arnav-dev-git
      calculateAvailabilityWiseTotalListings(listingID, listings, daysAvailableListingNumObject);
    }
  });
  calculateListingsPerHostsMetrics(
    hostIdListingGrouped,
    ['occupancyRateLTM'],
    listingsPerHostObject
  );

  // calculte the distributions here
  const propertyTypeMetricsDistributionObject = createDistributionObject(propertyTypeObjects);
  const propertySizeMetricsDistributionObject = createDistributionObject(propertySizeObjects);
  const bathroomNumberMetricsDistributionObject = createDistributionObject(bathroomNumberObject);
  const adrRangeMetricsDistributionObject = createDistributionObject(adrRangeObject);
  const ratingRangeMetricsDistributionObject = createDistributionObject(ratingRangeObject);
  const minNightsRangeMetricsDistributionObject = createDistributionObject(minNightRangeObject);
  const listingPerHostMetricsDistributionObject = createDistributionObject(listingsPerHostObject);

  const meanMetricsPropertyType = getMeanFromMetricsObject(propertyTypeObjects);
  const meanMetricsPropertySize = getMeanFromMetricsObject(propertySizeObjects);
  const meanMetricsBathroomNumber = getMeanFromMetricsObject(bathroomNumberObject);
  const meanMetricsAdrRange = getMeanFromMetricsObject(adrRangeObject);
  const meanMetricsRatingRange = getMeanFromMetricsObject(ratingRangeObject);
  const meanMetricsMinNightRange = getMeanFromMetricsObject(minNightRangeObject);
  const meanMetricsListingPerHost = getMeanFromMetricsObject(listingsPerHostObject);

  const resultObj = isUserAllowed
    ? {
        propertyType: meanMetricsPropertyType,
        propertySize: meanMetricsPropertySize,
        bathroomNumber: meanMetricsBathroomNumber,
        adrRange: meanMetricsAdrRange,
        ratingRange: meanMetricsRatingRange,
        minNightRange: meanMetricsMinNightRange,
        capacity: capacityListingNumObject,
        daysAvailable: daysAvailableListingNumObject,
        listingsPerHost: meanMetricsListingPerHost,
        // distributions
        propertyTypeMetricsDistribution: propertyTypeMetricsDistributionObject,
        propertySizeMetricsDistribution: propertySizeMetricsDistributionObject,
        bathroomNumberMetricsDistribution: bathroomNumberMetricsDistributionObject,
        adrRangeMetricsDitribution: adrRangeMetricsDistributionObject,
        ratingRangeMetricsDistribution: ratingRangeMetricsDistributionObject,
        minNightRangeMetricsDistribution: minNightsRangeMetricsDistributionObject,
        listingsPerHostMetricsDistribution: listingPerHostMetricsDistributionObject,
      }
    : {
        propertyType: meanMetricsPropertyType,
        propertySize: OVERVIEW_DASHBOARD_FILTER_DEMO_DATA.propertySize,
        bathroomNumber: OVERVIEW_DASHBOARD_FILTER_DEMO_DATA.bathroomNumber,
        adrRange: OVERVIEW_DASHBOARD_FILTER_DEMO_DATA.adrRange,
        ratingRange: OVERVIEW_DASHBOARD_FILTER_DEMO_DATA.ratingRange,
        minNightRange: OVERVIEW_DASHBOARD_FILTER_DEMO_DATA.minNightRange,
        capacity: capacityListingNumObject,
        daysAvailable: daysAvailableListingNumObject,
        listingsPerHost: OVERVIEW_DASHBOARD_FILTER_DEMO_DATA.listingsPerHost,
        // TODO: add demo data for distribution
        propertyTypeMetricsDistribution: propertyTypeMetricsDistributionObject,
      };

  return resultObj;
};

export const getDiscoveryMarketsURLCountryWise = (countryCode: string, type: 'top' | 'all') => {
  if (!countryCode || !Object.keys(AVAILABLE_COUNTRY).includes(countryCode)) {
    countryCode = 'US';
  }
  // return `https://c29g22isti.execute-api.us-east-2.amazonaws.com/default/discoveryMarketTest?countryCode=${countryCode}&filter=${type}`;
  return `https://v7fpw5xbb8.execute-api.us-east-2.amazonaws.com/default/discoverMarkets?countryCode=${countryCode}&filter=${type}`;
};

export const getDiscoveryMapViewParamsCountryWise = (countryCode: string) => {
  // let redirect_to_us: boolean = false;

  if (!countryCode || !Object.keys(AVAILABLE_COUNTRY).includes(countryCode)) {
    countryCode = 'US';
    // redirect_to_us = true;
  }

  const mapViewOptionsCountryWise = {
    US: {
      polygon_to_use: US_POLYGON,
      isPolyToUseMultiPolygon: false,
      center_to_use: US_CENTER,
      fixed_center_in_mobile_view: FIXED_CENTER_FOR_US_IN_MOBILE_VIEW,
      discovery_default_zoom_level: 3,
    },
    GB: {
      polygon_to_use: UK_POLYGON,
      isPolyToUseMultiPolygon: true,
      center_to_use: UK_CENTER,
      fixed_center_in_mobile_view: FIXED_CENTER_FOR_UK_IN_MOBILE_VIEW,
      discovery_default_zoom_level: 5,
    },
    AU: {
      polygon_to_use: AU_POLYGON,
      center_to_use: AU_CENTER,
      fixed_center_in_mobile_view: FIXED_CENTER_FOR_AU_IN_MOBILE_VIEW,
      discovery_default_zoom_level: 3,
      isPolyToUseMultiPolygon: true,
    },
    CA: {
      polygon_to_use: CA_POLYGON,
      center_to_use: CA_CENTER,
      fixed_center_in_mobile_view: FIXED_CENTER_FOR_CA_IN_MOBILE_VIEW,
      discovery_default_zoom_level: 3,
      isPolyToUseMultiPolygon: true,
    },
  };

  return { ...mapViewOptionsCountryWise[countryCode] };
};

export const getRedirectedDiscoveryMarketCountryCode = (userCountryCode: string) => {
  if (Object.keys(AVAILABLE_COUNTRY).includes(userCountryCode)) {
    return userCountryCode;
  }
  return 'US';
};

export const deepCopyObject = (obj: any) => {
  return JSON.parse(JSON.stringify(obj));
};

export const cacheApiCall = async (url: string, data: any) => {
  try {
    const cacheName = 'api_cache';
    const cache = await caches.open(cacheName);

    // Check if cached response exists and not expired
    if (cache) {
      const cacheData = {
        timestamp: new Date().getTime(),
        data: data,
      };
      const newResponse = new Response(JSON.stringify(cacheData));
      await cache.put(url, newResponse);
    }
  } catch (err) {
    console.log('Error while caching API call: ', err);
  }
};

export const getCachedApiCall = async (url: string) => {
  try {
    const cacheName = 'api_cache';
    const cache = await caches.open(cacheName);
    const cachedResponse = await cache.match(url);

    if (cachedResponse) {
      const cachedData = await cachedResponse.json();
      const cachedDate = new Date(cachedData.timestamp);

      if (new Date().getTime() - cachedDate.getTime() > DISCOVERY_API_CACHE_DURATION) {
        // The timestamp is expired
        await cache.delete(url);
        return null;
      }

      return cachedData;
    }
    return null;
  } catch (err) {
    return null;
  }
};

export const clearApiCache = async () => {
  const cacheName = 'api_cache';
  try {
    await caches.delete(cacheName);
    console.log(`[DEV-LOG] Cache '${cacheName}' has been cleared.`);
  } catch (error) {
    console.error(`Failed to clear cache '${cacheName}':`, error);
  }
};

export const isMarketBeachfront = (listings: ListingsProp) => {
  const totalListingsCount = Object.keys(listings.data).length;

  const beachfrontListingsCount = Object.values(listings.data).reduce((count, listing) => {
    if (listing.amenities && listing.amenities.beachfront === true) {
      return count + 1;
    } else {
      return count;
    }
  }, 0);

  const beachfrontListingsShare = (beachfrontListingsCount / totalListingsCount) * 100;
  return beachfrontListingsShare >= 5;
};

export const calculatePriceTiers = (listings: Listings | Listing[], isFromAdvanceTab = false) => {
  let adrLTMList = Object.values(listings)
    .map(listing => listing.adrLTM)
    .filter(adr => typeof adr === 'number' && !isNaN(adr));

  if (Array.isArray(listings)) {
    adrLTMList = listings
      .map(listing => (isFromAdvanceTab ? listing['adr_ltm'] : listing.adrLTM))
      .filter(adr => typeof adr === 'number' && !isNaN(adr));
  }
  adrLTMList.sort((a, b) => a - b);

  const numProperties = adrLTMList.length;
  const groupSize = Math.floor(numProperties / 5); // Each group contains 20% of the data
  const breaks = [
    adrLTMList[groupSize - 1],
    adrLTMList[groupSize * 2 - 1],
    adrLTMList[groupSize * 3 - 1],
    adrLTMList[groupSize * 4 - 1],
  ];

  return breaks;
};

export const sendFormSubmissionEmail = async (receiverEmail, content1, title) => {
  let URL =
    'https://y7kp4qpcfh.execute-api.us-east-2.amazonaws.com/default/sendFormSubmissionEmail';
  const config = {
    receiverEmail: encodeURIComponent(receiverEmail),
    content: content1,
    title: title,
  };
  await callApi(URL, { queryParams: config }, false);
};

export const updateEnterpriseLeadsInGoogleSheet = async (sheet_name, data) => {
  let URL =
    'https://7q8vk5fb3g.execute-api.us-east-2.amazonaws.com/default/updateEnterpriseLeadsInGoogleSheet';
  const config = { sheet_name: sheet_name, data: encodeURIComponent(data) };
  await callApi(URL, { queryParams: config }, false);
};

export const getTodayDateTimeUTC = () => {
  const now = new Date();

  // Get UTC versions of year, month, date, hours, minutes, and seconds
  const year = now.getUTCFullYear();
  const month = String(now.getUTCMonth() + 1).padStart(2, '0'); // Adding 1 to month since it is zero-based
  const date = String(now.getUTCDate()).padStart(2, '0');
  const hours = String(now.getUTCHours()).padStart(2, '0');
  const minutes = String(now.getUTCMinutes()).padStart(2, '0');
  const seconds = String(now.getUTCSeconds()).padStart(2, '0');

  // Format date and time in UTC
  const formattedDateTimeUTC = `${year}/${month}/${date} ${hours}:${minutes}:${seconds}`;

  return formattedDateTimeUTC;
};

export const getMalaysianDateTime = () => {
  const malaysianTimeZone = 'Asia/Kuala_Lumpur';
  const date = new Date();

  // Format date to get month and day
  const options: Intl.DateTimeFormatOptions = {
    month: 'long',
    day: 'numeric',
    timeZone: malaysianTimeZone,
  };

  const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);

  // Get the hour and minute in Malaysian time
  const timeOptions: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    hour12: true,
    timeZone: malaysianTimeZone,
  };

  const formattedTime = new Intl.DateTimeFormat('en-US', timeOptions).format(date);

  return `${formattedDate} - ${formattedTime}`;
};

export const generateDateList = (startDate, days) => {
  const dateList: any = [];
  const currentDate = new Date(startDate);

  for (let i = 0; i < days; i++) {
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(currentDate.getDate()).padStart(2, '0');

    dateList.push(`${year}-${month}-${day}`);

    // Move to the next day
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dateList;
};

export const aggregateToMarketLevel = (listing, globalFilteredListingIds, filterActive) => {
  const marketData = {};
  const months = [
    '2021-01',
    '2021-02',
    '2021-03',
    '2021-04',
    '2021-05',
    '2021-06',
    '2021-07',
    '2021-08',
    '2021-09',
    '2021-10',
    '2021-11',
    '2021-12',
    '2022-01',
    '2022-02',
    '2022-03',
    '2022-04',
    '2022-05',
    '2022-06',
    '2022-07',
    '2022-08',
    '2022-09',
    '2022-10',
    '2022-11',
    '2022-12',
    '2023-01',
    '2023-02',
    '2023-03',
    '2023-04',
    '2023-05',
    '2023-06',
    '2023-07',
    '2023-08',
    '2023-09',
    '2023-10',
    '2023-11',
    '2023-12',
    '2024-01',
    '2024-02',
    '2024-03',
    '2024-04',
  ];

  listing.forEach(listing => {
    if (
      !filterActive ||
      (filterActive && globalFilteredListingIds.includes(String(listing['listingID'])))
    ) {
      for (let month of months) {
        if (!marketData[month]) {
          marketData[month] = {
            availiableListingsCount: 0,
            bookedListingsCount: 0,
            availiableListingNights: 0,
            bookedNightsCount: 0,
            revenue: [],
            occupancyRates: [],
            adrRates: [],
          };
        }

        let performanceData = listing[month];
        if (!performanceData) continue;

        performanceData = JSON.parse(performanceData);
        const adr = performanceData[0];
        const activeDaysCount = performanceData[1];
        const bookedDaysCount = performanceData[2];
        const numberOfBookings = performanceData[3];
        const cleaningFee = listing['cleaning_fee'];

        if (activeDaysCount > 0) {
          marketData[month].availiableListingsCount = marketData[month].availiableListingsCount + 1;
          marketData[month].availiableListingNights =
            marketData[month].availiableListingNights + activeDaysCount;
        }

        if (bookedDaysCount > 0) {
          marketData[month].bookedListingsCount = marketData[month].bookedListingsCount + 1;
          marketData[month].bookedNightsCount =
            marketData[month].bookedNightsCount + bookedDaysCount;
        }

        if (adr) {
          marketData[month].adrRates.push(adr);
        }

        if (activeDaysCount > 0) {
          const occupancyRate = Math.round(
            Math.min((bookedDaysCount / activeDaysCount) * 100 * 1.2, 100)
          );
          const revenue = Math.round(
            adr * (occupancyRate / 100) * activeDaysCount + numberOfBookings * cleaningFee
          );
          marketData[month].occupancyRates.push(occupancyRate);
          marketData[month].revenue.push(revenue);
        }
      }
    }
  });

  for (let month in marketData) {
    const monthData = marketData[month];
    monthData.adrRates =
      monthData.adrRates.length > 0 ? Math.round(d3.mean(monthData.adrRates)) : null;
    monthData.occupancyRates =
      monthData.occupancyRates.length > 0 ? Math.round(d3.mean(monthData.occupancyRates)) : null;
    monthData.revenue =
      monthData.revenue.length > 0 ? Math.round(d3.mean(monthData.revenue)) : null;
  }

  return marketData;
};

export const findGreatestDate = obj => {
  // Extract the keys and filter out the non-date keys
  const dateKeys = Object.keys(obj).filter(key => !isNaN(Date.parse(key)));

  // Convert the date keys to Date objects and then to timestamps
  const timestamps = dateKeys.map(date => new Date(date).getTime());

  // Find the maximum timestamp
  const maxTimestamp = Math.max(...timestamps);

  // Convert the maximum timestamp back to a Date object
  const maxDate = new Date(maxTimestamp);

  const formattedDate = maxDate.toISOString().split('T')[0];

  return formattedDate;
};

export const convertAdvancedMarkersToMarkers = (advancedListings, batchSize = 50) => {
  const convertBatch = batchListings => {
    const retBatch = {};
    for (const listing of batchListings) {
      try {
        const listingID = listing.listingID;
        const revPAN = Math.round(listing.annual_revenue_ltm / listing.active_days_ltm);
        const revenuePotential = revPAN * 365;

        const retListing = {
          name: listing.name,
          thumbnail_url: `https://a0.muscache.com/im/pictures/${listing.thumbnail_url}`,
          latitude: listing.latitude,
          longitude: listing.longitude,
          room_type: listing.room_type,
          property_type: listing.property_type,
          bedrooms: listing.bedrooms,
          bathrooms: listing.bathrooms,
          accommodates: listing.accommodates,
          host_name: listing.host_name,
          minimum_nights: listing.minimum_nights,
          hostListingCount: listing.hostListingCount,
          cleaningFee: listing.cleaning_fee,
          extraGuestFee: listing.extra_fee_person_estimate,
          review_scores_rating: listing.reveiw_scores_rating,
          amenities: listing.amenities,
          visible_review_count: listing.visible_review_count,
          last_seen: listing.last_seen,
          cancellation_policy: listing.cancellation_policy,
          hostId: listing.host_id,
          adrLTM: listing.adr_ltm,
          occupancyRateLTM: listing.avg_occupancy_rate_ltm,
          annualRevenueLTM: listing.annual_revenue_ltm,
          activeDaysCount: listing.active_days_ltm,
          revenuePotential,
          hasLicense: listing.license ? true : false,
          numberOfBookingsLTM: null,
          revPAN,
          revenueFromCleaningFeeLTM: null,
          visible: true,
        };

        retBatch[listingID] = retListing;
      } catch (error) {
        console.log('Error while loading marker:', error);
      }
    }
    return retBatch;
  };

  const retVals = {};
  if (!advancedListings || advancedListings.length === 0) {
    return retVals;
  }

  for (let i = 0; i < advancedListings.length; i += batchSize) {
    const batchListings = advancedListings.slice(i, i + batchSize);
    const processedBatch = convertBatch(batchListings);
    Object.assign(retVals, processedBatch);
  }

  return {
    data: retVals,
    loading: false,
  };
};

export const checkPromocodeValidity = async (
  promocode: string,
  promoCodeDiscountsDict: any,
  returnValidPromoCode: boolean = false
) => {
  if (!promocode || !(promocode in promoCodeDiscountsDict)) {
    return returnValidPromoCode ? '' : false;
  }

  let isPromoCodeValid = false;

  const url = 'https://61psikryqf.execute-api.us-east-2.amazonaws.com/default/activateCouponCode';
  const couponValidationConfig = {
    queryParams: {
      promoCode: promoCodeDiscountsDict[promocode].id,
      operation: 'validate',
    },
  };
  const res = await callApi(url, couponValidationConfig, false);

  if (res.message) {
    isPromoCodeValid = res.message.valid;
  }
  if (res.error) {
    isPromoCodeValid = false;
  }

  if (!returnValidPromoCode) {
    return isPromoCodeValid;
  }

  return isPromoCodeValid ? promocode : '';
};

export const calculateCouponChange = (
  currentPromoCode: string,
  promoCodeDiscountsDict: any,
  subscriptionPriceAccordingToUserLocalCurrency: any,
  duration: string,
  setDiscountedPrice: any,
  productName = 'expert'
) => {
  if (!currentPromoCode) {
    return 0;
  }
  currentPromoCode = currentPromoCode.toUpperCase();
  let newDiscountedPricing = 0;
  const currentPromoCodeObj = promoCodeDiscountsDict[currentPromoCode] || {};

  if (!currentPromoCodeObj) {
    return 0;
  }

  const currentPrice = Number(subscriptionPriceAccordingToUserLocalCurrency[productName][duration]);

  if (currentPromoCodeObj.type === 'percent') {
    newDiscountedPricing =
      currentPrice - currentPrice * (Number(promoCodeDiscountsDict[currentPromoCode].amount) / 100);
  } else if (currentPromoCodeObj.type === 'fixed-off') {
    newDiscountedPricing = currentPrice - Number(currentPromoCodeObj.amount);
  } else if (currentPromoCodeObj.type === 'fixed-price') {
    newDiscountedPricing = Number(currentPromoCodeObj.amount);
  }
  setDiscountedPrice && setDiscountedPrice(_ => Number(newDiscountedPricing.toFixed(2)));
  return Number(newDiscountedPricing.toFixed(2));
};

export const getDummyMarketURL = dummyMarket => {
  let path = `/airbnb-data/${dummyMarket['country'].replaceAll(' ', '%20')}/${dummyMarket[
    'city'
  ].replaceAll(' ', '%20')}/${dummyMarket['district'].replaceAll(' ', '%20')}`;
  return path.toLowerCase();
};

export const checkUserTailorMarketAccess = (user, search) => {
  if (user?.email == search?.data?.created_by) {
    if (user.subscriptionPlan == 'expert' || user.subscriptionPlan == 'scale') {
      return true;
    } else {
      return false;
    }
  } else {
    if (
      user.userName == 'Trial' &&
      search.data.created_by == '' &&
      search.data.visibility == 'private'
    ) {
      // User is not logged in and created a tailor region
      return false;
    } else {
      //not a tailor region
      return true;
    }
  }
};

export const changePercentageToDecimal = perc => {
  let percentage = parseInt(perc);
  return percentage / 100;
};

export const getPreviousTimePeriod = timePeriod => {
  if (timePeriod == 'ltm') return '2023';
  else if (timePeriod == '2023') return '2022';
  else if (timePeriod == '2022') return '2021';
  else return null;
};

export const getExampleListingsWhichMatchesSpecificCriteria = (
  listings,
  metricsKey,
  value,
  noOfListingsToBeReturned,
  filterType,
  filterTypeValue
) => {
  let tooltipTitleValueStart: Number = 0;
  let tooltipTitleValueEnd: Number = 0;
  const TOOLTIP_TITLE_MAPPING = {
    Bedrooms: 'bedrooms',
    'Property Type': 'room_type',
    Bathrooms: 'bathrooms',
    'Minimum Nights': 'minimum_nights',
    'Average Daily Rate': 'adrLTM',
    'Listings per host': 'hostListingCount',
    Ratings: 'review_scores_rating',
    property_type: 'property_type',
  };

  if (filterTypeValue.includes('-')) {
    [tooltipTitleValueStart, tooltipTitleValueEnd] = filterTypeValue.split('-');
  } else if (filterTypeValue.includes('+')) {
    tooltipTitleValueStart = Number(filterTypeValue.slice('+')[0]);
    tooltipTitleValueEnd = 9999999;
  } else {
    filterTypeValue = !isNaN(Number(filterTypeValue))
      ? Number(filterTypeValue)
      : filterTypeValue == 'studio'
      ? 'Studio'
      : filterTypeValue;
  }

  if (filterTypeValue == 'condo') {
    filterType = 'property_type';
  }

  // metricKey can be occupancyrate / revenue / Daily rate
  // filterType can be Bedrooms / property types/ bathrooms / minimum stay / price tier / host portfolio / start rating

  let formattedKey = metricsKey === 'revenue' ? 'annualRevenueLTM' : metricsKey + 'LTM';
  let matchedListings: any = [];
  let nearestListings: any = [];
  let listingMatchesTheExactValue = true;

  for (let listingID in listings) {
    const listing = listings[listingID];
    const formattedValue = listing[formattedKey];
    const activeDaysCount = listing['activeDaysCount'];
    if (
      !tooltipTitleValueStart
        ? listing[TOOLTIP_TITLE_MAPPING[filterType]] == filterTypeValue
        : listing[TOOLTIP_TITLE_MAPPING[filterType]] >= tooltipTitleValueStart &&
          listing[TOOLTIP_TITLE_MAPPING[filterType]] <= tooltipTitleValueEnd
    ) {
      if (formattedValue == value && activeDaysCount && Number(activeDaysCount) >= 90) {
        let matchListingDict = { ...listing, listingID };
        matchedListings.push(matchListingDict);
      } else if (formattedValue !== undefined && activeDaysCount && Number(activeDaysCount) >= 90) {
        const difference = Math.abs(formattedValue - value);
        nearestListings.push({ ...listing, listingID, difference });
      }
    }
  }

  if (matchedListings.length < noOfListingsToBeReturned) {
    nearestListings.sort((a, b) => a.difference - b.difference);

    while (matchedListings.length < noOfListingsToBeReturned && nearestListings.length > 0) {
      matchedListings.push(nearestListings.shift());
      listingMatchesTheExactValue = false;
    }
  }
  return [matchedListings.slice(0, noOfListingsToBeReturned), listingMatchesTheExactValue];
};

export const dateDeforeNDays = noOfDaysBefore => {
  const currentDate = new Date();
  const dateBeforeNDays = new Date();
  dateBeforeNDays.setDate(currentDate.getDate() - noOfDaysBefore);
  return dateBeforeNDays;
};

export const convertDateToString = (date: Date): string => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date
    .getDate()
    .toString()
    .padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const checkListingRecentlyAdded = (listing: Listing) => {
  const dateBefore90Days = convertDateToString(dateDeforeNDays(90));
  if (listing.added_on && listing.added_on > dateBefore90Days) {
    return true;
  }
  return false;
};

export const checkListingInactive = (listing: Listing) => {
  const isListingRecentlyAdded = checkListingRecentlyAdded(listing);
  if (isListingRecentlyAdded) {
    return false;
  }
  if (!listing.activeDaysCount || listing.activeDaysCount < 90) {
    return true;
  }
  return false;
};

export const checkListingUnlisted = (listing: Listing) => {
  const isListingRecentlyAdded = checkListingRecentlyAdded(listing);
  if (isListingRecentlyAdded) {
    return false;
  }

  const isListingInactive = checkListingInactive(listing);
  if (isListingInactive) {
    return false;
  }

  if (listing.last_seen && listing.last_seen < '2024-10-14') {
    return true;
  }

  return false;
};

export const checkAdrAnomaly = (listingADR: number | null, referenceADR: number | null) => {
  if (!listingADR || !referenceADR) {
    return false;
  }
  return listingADR >= referenceADR * 5;
};

export const filterActiveListings = (listings: Listing[] | VisibleListingsProp, type = 'list') => {
  if (type === 'list') {
    return (listings as Listing[]).filter(
      listing => listing.activeDaysCount && listing.activeDaysCount >= 90
    );
  } else {
    return {
      data: (listings as VisibleListingsProp).data.filter(
        listing => listing.activeDaysCount && listing.activeDaysCount >= 90
      ),
      loading: (listings as VisibleListingsProp).loading,
    } as VisibleListingsProp;
  }
};

export const getDaysInMonth = dateString => {
  const [year, month] = dateString.split('-').map(Number);
  return new Date(year, month, 0).getDate();
};

export const isYearMonthKey = key => {
  return /^\d{4}-\d{2}$/.test(key);
};

export const programaticallyClickButton = buttonRef => {
  if (buttonRef.current) {
    buttonRef.current.click();
  }
};

export const scrollToElement = elementRef => {
  if (elementRef.current) {
    elementRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
};

export const getPolygonPaths = (polygonRaw: string, multiPolygonRaw: string) => {
  const polygonArr: Coordinates[][] = processPolygon(polygonRaw, multiPolygonRaw);
  let paths: Coordinates[][] = [];
  if (polygonArr.length > 0) {
    polygonArr.forEach((polygon: Coordinates[], _: number) => paths.push(polygon));
  }
  return paths;
};

export const isUserFromAmericanContinent = () => {
  const americanTimeZones = [
    'America/New_York',
    'America/Chicago',
    'America/Denver',
    'America/Los_Angeles', // North America
    'America/Sao_Paulo',
    'America/Buenos_Aires',
    'America/Bogota', // South America
    'America/Havana',
    'America/Santo_Domingo', // Caribbean
    'America/Mexico_City',
    'America/Guatemala',
    'America/Panama', // Central America
  ];

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return americanTimeZones.includes(timeZone);
};

export const removeQueryParamsFromURL = () => {
  let url = new URL(window.location.href);
  url.search = '';
  window.history.replaceState({}, document.title, url.toString());
};

export const getPercentage = (newValue: number, oldValue: number) => {
  if (oldValue === 0) {
    return 0;
  }
  return ((newValue - oldValue) / oldValue) * 100;
};

export const countDigitsAfterDecimal = (num: number): number => {
  const strNum = num.toString(); // Convert number to string
  const decimalIndex = strNum.indexOf('.'); // Find the index of decimal point
  if (decimalIndex === -1) {
    return 0; // If no decimal point found, return 0
  } else {
    return strNum.length - decimalIndex - 1; // Calculate number of digits after decimal
  }
};

export const calculateMonthlyMortgage = (
  propertyPrice: number,
  downPayment: number,
  annualInterestPercent: number,
  loanTermInYears: number
) => {
  const monthlyInterestPercent = annualInterestPercent / 12; // 0.5%
  const monthlyInterestRate = monthlyInterestPercent / 100; // 0.005
  const principalAmount = propertyPrice - downPayment;
  const numberOfMonthlyPayments = loanTermInYears * 12;

  const compoundingFactor = Math.pow(1 + monthlyInterestRate, numberOfMonthlyPayments);
  // formula from https://en.wikipedia.org/wiki/Mortgage_calculator
  const mortgageMonthly =
    (monthlyInterestRate * principalAmount * compoundingFactor) / (compoundingFactor - 1);

  return Math.round(mortgageMonthly);
};

export const isCurrentPlanSubscribed = (plan, currentActivePlan) => {
  return plan == currentActivePlan;
};

export const checkIfUserLoggedIn = (userEmail: string) => {
  return userEmail !== 'Trial';
};

export const storeVisitedMarketInLocalStorage = newSearchObj => {
  const newMarket = {
    district: newSearchObj.name,
    city: newSearchObj.city,
    country: newSearchObj.country,
    displayName: newSearchObj.displayName,
  };

  const existingMarketsString = localStorage.getItem('visited-markets');
  const existingMarkets = existingMarketsString ? JSON.parse(existingMarketsString) : [];

  const isMarketPresent = existingMarkets.some(
    market =>
      market.district === newMarket.district &&
      market.city === newMarket.city &&
      market.country === newMarket.country
  );

  if (!isMarketPresent) {
    existingMarkets.push(newMarket);
    localStorage.setItem('visited-markets', JSON.stringify(existingMarkets));
  }
};

export const getVisitedMarketsFromLocalStorage = () => {
  const existingMarketsString = localStorage.getItem('visited-markets');
  return existingMarketsString ? JSON.parse(existingMarketsString) : [];
};

export const getRedirectionLink = (
  countryParam: string = '',
  cityParam: string = '',
  districtParam: string = ''
) => {
  const paramStr = `${countryParam}/${cityParam}/${districtParam}`;
  return `/airbnb-data/${paramStr}`;
};

export const getDynamicMarkers = async (
  bounds: Bounds,
  search,
  isUserAllowed,
  bedroomFilter: (string | number)[] | null = [],
  page = 1
) => {
  const url = 'https://k6wf64h501.execute-api.us-east-2.amazonaws.com/default/getDynamicMarkers';

  let markerParam = {
    neLat: bounds.northEast.lat,
    neLng: bounds.northEast.lng,
    swLat: bounds.southWest.lat,
    swLng: bounds.southWest.lng,
    marketPolygon: search.data.polygon || search.data.multiPolygon,
    page: page,
  };

  if (isUserAllowed) {
    markerParam['limit'] = 9;
  }

  if (bedroomFilter && bedroomFilter?.length > 0) {
    markerParam['bedrooms'] = (bedroomFilter as (string | number)[]).join(',');
  }

  let listings = [] as Listing[];

  try {
    const response = await callApi(url, { body: markerParam }, true, false, '', 'POST', true);

    if (response && response.message) {
      listings = processListingData(response.message);
    }
  } catch (error) {
    console.error('Error fetching dynamic markers:', error);
  }

  return listings;
};

export const getClusterListingsCoords = async (clusterCoordinates: number[][]) => {
  const wktBoundaryString = generateWKTPolygon(clusterCoordinates);
  const url =
    'https://vadp0opbrl.execute-api.us-east-2.amazonaws.com/default/getClusterListingCoords';
  const config = {
    queryParams: {
      boundary: wktBoundaryString,
    },
  };
  const response = await callApi(url, config, false);
  if (response && response.message && Array.isArray(response.message)) {
    const listingsCoords = response.message;
    return listingsCoords;
  }
  return [];
};

export const processListingData = listings => {
  const processedListings: any[] = [];
  for (const listing of listings) {
    try {
      const revPAN = listing['active_days_count_ltm']
        ? Math.round(listing['annual_revenue_ltm'] / listing['active_days_count_ltm'])
        : 0;
      const revenueFromCleaningFeeLTM = listing['cleaning_fee']
        ? Math.round(listing['cleaning_fee'] * listing['no_of_bookings_ltm'])
        : 0;

      const retListing = {
        accommodates: listing['accommodates'],
        activeDaysCount: listing['active_days_count_ltm'],
        adrLTM: listing['avg_booked_daily_rate_ltm'],
        amenities: listing['amenities'],
        annualRevenueLTM: listing['annual_revenue_ltm'] ? listing['annual_revenue_ltm'] : 'N/A',
        bathrooms: listing['bathrooms'],
        bedrooms: listing['bedrooms'],
        cancellation_policy: listing['cancellation_policy'],
        cleaningFee: listing['cleaning_fee'],
        extraGuestFee: listing['extra_fee_person_estimate'],
        hasLicense: listing['license'] === 't' ? true : false,
        hostId: listing['host_id'],
        hostListingCount: listing['hostListingCount'],
        host_name: listing['host_name'],
        last_seen: listing['last_seen'],
        latitude: listing['latitude'],
        listingID: listing['listingID'],
        longitude: listing['longitude'],
        minimum_nights: listing['minimum_nights'],
        name: listing['name'],
        numberOfBookingsLTM: listing['no_of_bookings_ltm'],
        occupancyRateLTM: Math.min(listing['avg_occupancy_rate_ltm'], 95),
        property_type: listing['room_and_property_type'],
        revPAN: revPAN,
        revenueFromCleaningFeeLTM: revenueFromCleaningFeeLTM,
        revenuePotential: listing['revenue_potential'],
        review_scores_rating: Math.round(listing['reveiw_scores_rating'] / 20),
        room_type: listing['room_and_property_type'],
        thumbnail_url: listing['thumbnail_url'],
        visible_review_count: listing['visible_review_count'],
        rest_thumbnails: listing['thumbnail_url_extended'],
        added_on: listing['added_on'],
        bookingComURL: listing['booking_com_url'],
        vrboURL: listing['vrbo_url'],
      };

      processedListings.push(retListing);
    } catch (error) {
      console.log('Error while loading marker:', error);
    }
  }
  return processedListings;
};

export const isMiddleEastTimezone = timezone => {
  const middleEastTimezones = [
    'Asia/Dubai',
    'Asia/Beirut',
    'Asia/Amman',
    'Asia/Jerusalem',
    'Asia/Kuwait',
    'Asia/Riyadh',
    'Asia/Baghdad',
    'Asia/Bahrain',
    'Asia/Qatar',
    'Asia/Damascus',
    'Asia/Muscat',
    'Asia/Aden',
    'Asia/Tehran',
  ];

  return middleEastTimezones.includes(timezone);
};

export const getTailoredRegionByTimezone = () => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (timeZoneCoordinatesMap[timezone]) {
    return timeZoneCoordinatesMap[timezone];
  }

  const regionLocationMap = {
    Europe: { lat: 45.4642, lng: 9.19 }, // Milan, Europe
    UK: { lat: 51.5074, lng: -0.1278 }, // London, UK
    Africa: { lat: -33.9249, lng: 18.4241 }, // Cape Town, Africa
    Oceania: { lat: -33.8688, lng: 151.2093 }, // Sydney, Oceania
    Asia: { lat: -8.3405, lng: 115.092 }, // Bali, Asia (Exclude Middle East)
    'Middle East': { lat: 25.276987, lng: 55.296249 }, // Dubai, Middle East
  };

  // Check for common regions in timezone string and map to the appropriate region
  if (timezone.startsWith('Europe')) return regionLocationMap['Europe'];
  if (timezone.startsWith('Africa')) return regionLocationMap['Africa'];
  if (timezone === 'Europe/London') return regionLocationMap['UK'];
  if (timezone.startsWith('Australia')) return regionLocationMap['Oceania'];
  if (timezone.startsWith('Asia') && !isMiddleEastTimezone(timezone))
    return regionLocationMap['Asia'];
  if (isMiddleEastTimezone(timezone)) return regionLocationMap['Middle East'];

  // Default case if no region match
  return null;
};

export const roundFloat = (num: number, points: number = 2) => {
  let multiplier = 1;

  for (let i = 0; i < points; i++) {
    multiplier *= 10;
  }

  return Math.floor(num * multiplier) / multiplier;
};

export const beautifyDate = (dateStr: string) => {
  const date = new Date(dateStr);
  const day = date.toLocaleDateString('en-GB', { day: 'numeric' });
  const month = date.toLocaleDateString('en-GB', { month: 'long' });
  const year = date.toLocaleDateString('en-GB', { year: 'numeric' });
  return `${day} ${month}, ${year}`;
};

export const isValidUrl = url => {
  const regex = /^(https?:\/\/)?([a-zA-Z0-9.-]+)\.([a-zA-Z]{2,6})(\/\S*)?$/;
  return regex.test(url);
};

export const handleImageInput = (fileInput, maxSizeInMb: number = 10) => {
  return new Promise((resolve, reject) => {
    try {
      fileInput = Array.from(fileInput);
      const file = fileInput[0];

      // Check if the selected file is an image
      if (!file || !file.type.startsWith('image/')) {
        reject('File is not an image');
        return;
      }

      // Check if the image size is more than 10MB (10 * 1024 * 1024 bytes)
      const maxSize = maxSizeInMb * 1024 * 1024;
      if (file.size > maxSize) {
        reject('File size exceeds 10MB');
        return;
      }

      const reader = new FileReader();
      reader.onload = function(event) {
        const img = new Image();
        img.onload = function() {
          const maxDimension = 600;
          let width = img.width;
          let height = img.height;

          // Calculate aspect ratio
          if (width > height) {
            // Landscape image
            if (width > maxDimension) {
              height = Math.floor((height / width) * maxDimension);
              width = maxDimension;
            }
          } else {
            // Portrait or square image
            if (height > maxDimension) {
              width = Math.floor((width / height) * maxDimension);
              height = maxDimension;
            }
          }

          // Create a canvas to resize the image
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          // Set canvas size to new dimensions
          canvas.width = width;
          canvas.height = height;

          // Draw the image onto the canvas with the new dimensions
          ctx && ctx.drawImage(img, 0, 0, width, height);

          // Get the resized image as a base64 string (jpeg with quality 0.8)
          const base64String = canvas.toDataURL('image/webp', 0.8);
          resolve(base64String);
        };

        img.src = event.target?.result as any;
      };

      reader.onerror = function() {
        reject('Error reading file');
      };

      reader.readAsDataURL(file);
    } catch (err) {
      console.log('Error in image processing: ', err);
      reject('Processing Error!');
    }
  });
};

export const setPolygon = (
  map,
  maps,
  paths: Coordinates[][],
  strokeColor: string,
  fillColor: string,
  strokeOpacity = 0.8,
  strokeWeight = 2,
  fillOpacity = 0.12
) => {
  const polygon = new maps.Polygon({
    paths: paths,
    strokeColor: strokeColor,
    strokeOpacity: strokeOpacity,
    strokeWeight: strokeWeight,
    fillColor: fillColor,
    fillOpacity: fillOpacity,
  });
  polygon.setMap(map);

  return polygon;
};

export const calculateHistoricalTrends = (metricsHistoricalData, metric, percentile) => {
  try {
    if (!metricsHistoricalData) {
      return { yearlyYoYChange: {}, nextYearPredcition: 0 };
    }

    const key = `${metric}${percentile}`;
    const currentYear = metricsHistoricalData[metricsHistoricalData.length - 1].latestYear;
    const startYear = 2021; // Starting year as per requirement

    const parseData = () => {
      const result = {};

      // Loop over the data and transform it
      metricsHistoricalData.forEach(data => {
        // Dynamically generate years from startYear to the latest year (max of current year or data year)
        for (let year = startYear; year <= currentYear; year++) {
          const yearStr = year.toString();
          if (data[yearStr]) {
            if (!result[yearStr]) {
              result[yearStr] = {};
            }

            // Assign the monthly data to the respective year
            result[yearStr][data.month] = {
              revenue25: data[yearStr][`${metric}25`],
              revenue50: data[yearStr][`${metric}50`],
              revenue75: data[yearStr][`${metric}75`],
              revenue90: data[yearStr][`${metric}90`],
            };
          }
        }
      });

      return result;
    };

    const calculateYoYYearlyChange = parsedData => {
      const result = {};
      const years = Object.keys(parsedData).sort(); // Sort years in ascending order

      for (let i = 1; i < years.length; i++) {
        const currentYear = years[i];
        const previousYear = years[i - 1];

        // Find common months between consecutive years
        const commonMonths = Object.keys(parsedData[currentYear]).filter(month =>
          parsedData[previousYear].hasOwnProperty(month)
        );

        let totalYoYChange = 0;
        let monthCount = 0;

        commonMonths.forEach(month => {
          const currentRevenue = parsedData[currentYear][month][key];
          const previousRevenue = parsedData[previousYear][month][key];

          if (currentRevenue !== null && previousRevenue !== null) {
            // Avoid division by zero
            // Calculate YoY change for revenue50
            const yoyChange =
              ((currentRevenue - previousRevenue) / Math.max(previousRevenue, 1)) * 100;
            totalYoYChange += yoyChange;
            monthCount++;
          }
        });

        // Calculate average YoY change for the year
        const avgYoYChange = monthCount > 0 ? totalYoYChange / monthCount : 0;

        // Store the average YoY change for the year
        result[currentYear] = avgYoYChange;
      }

      return result;
    };

    // Usage
    const parsedData = parseData();
    const yearlyYoYChange = calculateYoYYearlyChange(parsedData);
    const currentYearYoYChange = yearlyYoYChange[currentYear];
    const previousYearYoYChange = yearlyYoYChange[currentYear - 1];
    const nextYearPredcition = Number(
      ((currentYearYoYChange + previousYearYoYChange) / 2).toFixed(2)
    );
    yearlyYoYChange[currentYear + 1] = nextYearPredcition;

    return { yearlyYoYChange, nextYearPredcition };
  } catch (err) {
    return { yearlyYoYChange: {}, nextYearPredcition: 0 };
  }
};
export const waitForPaymentProcessing = async (stripe, clientSecret) => {
  let isPaymentSuccess = false;
  setTimeout(async () => {
    const paymentIntentResult = await stripe.retrievePaymentIntent(clientSecret);
    const paymentIntentStatus = paymentIntentResult.status;
    if (paymentIntentStatus === 'succeeded') {
      isPaymentSuccess = true;
    } else {
      isPaymentSuccess = false;
    }
  }, 3000);
  return isPaymentSuccess;
};

export const confirmCardPaymentRecursively = async (stripe, clientSecret) => {
  const confirmCardPaymentResp = await stripe.confirmCardPayment(clientSecret);
  const confirmStatus =
    confirmCardPaymentResp &&
    confirmCardPaymentResp.paymentIntent &&
    confirmCardPaymentResp.paymentIntent.status;

  if (confirmStatus === 'requires_action') {
    return confirmCardPaymentRecursively(stripe, clientSecret);
  }

  if (confirmStatus === 'processing') {
    return waitForPaymentProcessing(stripe, clientSecret);
  }

  if (confirmStatus === 'succeeded') {
    return true;
  }

  return false;
};

export const checkIfOverviewMarketIsSaved = (targetMarket: SearchProp, userSavedMarkets: any) => {
  if (!userSavedMarkets || userSavedMarkets.length === 0) return false;
  if (targetMarket.loading || !targetMarket.data) return false;

  for (const savedMarket of userSavedMarkets) {
    const currentMarketId = savedMarket.id;
    const targetMarketId = targetMarket.data.id;

    if (!currentMarketId) continue;

    if (currentMarketId == targetMarketId) return true;
  }

  return false;
};

export const sortUserMarkets = (
  markets,
  sortKey: string,
  sortType: 'alpha-a-z' | 'alpha-z-a' | 'date-a-z' | 'date-z-a'
) => {
  if (!markets || markets.length === 0) return markets;

  markets = markets.filter(markets => markets[sortKey]);

  const sortTypesDateWise = ['date-a-z', 'date-z-a'];

  const sortAlphaWise = () => {
    markets = markets.sort((a: string, b: string) => a[sortKey].localeCompare(b[sortKey]));
    return sortType === 'alpha-z-a' ? markets.reverse() : markets;
  };

  const sortDateWise = () => {
    markets = markets.sort(
      (a: string, b: string) => new Date(a[sortKey]).getTime() - new Date(b[sortKey]).getTime()
    );
    return sortType === 'date-z-a' ? markets : markets.reverse();
  };

  return sortTypesDateWise.includes(sortType) ? sortDateWise() : sortAlphaWise();
};

export const reverseTransformFilterVals = transformedVals => {
  const reverseArrayTypeFilters = (filter, defaultValue) => {
    if (!filter) {
      return defaultValue;
    }

    return filter.map(value => {
      const numberValue = Number(value);
      return isNaN(numberValue) ? value : numberValue;
    });
  };

  const reverseMinMaxFilters = (minValue, maxValue, defaultRange) => {
    if (minValue === null && maxValue === null) {
      return defaultRange;
    }

    return [minValue ?? defaultRange[0], maxValue ?? defaultRange[1]];
  };

  const reverseSingleValueFilter = (filter, defaultValue) => {
    return filter === null ? defaultValue : filter;
  };

  return {
    roomType: reverseArrayTypeFilters(transformedVals.property_type, ['all']),
    bedrooms: reverseArrayTypeFilters(transformedVals.bedrooms, [100]),
    bathrooms: reverseArrayTypeFilters(transformedVals.bathrooms, [100]),
    accommodates: reverseMinMaxFilters(
      transformedVals.accommodates_min,
      transformedVals.accommodates_max,
      [1, 16]
    ),
    minimum_nights: reverseMinMaxFilters(
      transformedVals.min_nights_min,
      transformedVals.min_nights_max,
      [1, 30]
    ),
    number_of_reviews: reverseSingleValueFilter(transformedVals.review_count_min, 'all'),
    rating: reverseMinMaxFilters(transformedVals.rating_min, transformedVals.rating_max, [3.9, 5]),
    hostType:
      transformedVals.professionally_managed === null
        ? 'both'
        : transformedVals.professionally_managed === 1
        ? 'professional'
        : 'individual',
    amenities: transformedVals.amenities || {
      pool: null,
      parking: null,
      hot_tub: null,
      gym: null,
      pets: null,
      dryer: null,
      washer: null,
      kitchen: null,
      ac: null,
      heating: null,
      wifi: null,
      tv: null,
      bbq_grill: null,
      fireplace: null,
      breakfast: null,
      beachfront: null,
      amazing_views: null,
    },
    revenueFilter:
      transformedVals.revenue_filter && transformedVals.revenue_filter !== 'all'
        ? [transformedVals.revenue_filter]
        : ['all'],
    priceTierFilter:
      transformedVals.price_tier && transformedVals.price_tier !== 'all'
        ? [transformedVals.price_tier]
        : ['all'],
    showAllBookingComListings: transformedVals.showAllBookingComListings ?? false,
  } as FilterVal;
};

export const filterListingsData = (listings, filteredListings) => {
  const filteredSet = new Set(filteredListings);
  return Object.keys(listings).reduce((filteredObj, key) => {
    if (filteredSet.has(key)) {
      filteredObj[key] = listings[key];
    }
    return filteredObj;
  }, {} as Listings);
};

export const isDemoMarket = () => {
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const loginCountryCode = timeZoneCCMap[userTimeZone] || 'US';
  const dummyMarket =
    DUMMY_MARKET_AS_PER_SIGNUP_COUNTRY_CODE[loginCountryCode]?.overview ||
    DUMMY_MARKET_AS_PER_SIGNUP_COUNTRY_CODE['US']?.overview;
  const currentPath = window.location.pathname.toLowerCase();
  const dummyMarketURL = getDummyMarketURL(dummyMarket);

  return currentPath.includes(dummyMarketURL);
};

export const isMoreThanNDaysAgo = (dateString: string, N: number) => {
  const inputDate = moment(dateString, 'YYYY-MM-DD');
  const currentDate = moment().startOf('day');

  const targetDate = currentDate.subtract(N, 'days');

  return inputDate.isBefore(targetDate, 'day');
};

export const handleSaveDeleteAdvancedMarket = async (
  id,
  name,
  city,
  countryCode,
  country,
  userSubscriptionPlan,
  operation: 'save' | 'delete' = 'save'
) => {
  if (userSubscriptionPlan != 'scale' && operation === 'save') {
    return;
  }
  try {
    console.log('Operation: ', operation);
    const URL = 'https://iknejeg0yj.execute-api.us-east-2.amazonaws.com/default/saveAdvancedMarket';

    const res = await callApi(
      URL,
      {
        queryParams: Object.fromEntries(
          Object.entries({ id, name, city, countryCode, country }).filter(
            ([_, val]) => val !== undefined
          )
        ),
      },
      true,
      false,
      '',
      operation === 'delete' ? 'DELETE' : 'GET',
      true
    );
    if (res.message == 'success') {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    console.log(`Error while performing ${operation} :`, err);
    return false;
  }
};

export const getSubscriptionPlanToUpgrade = (currentPlan: string) => {
  const planOrder: string[] = ['starter', 'expert', 'scale'];
  if (!planOrder.includes(currentPlan)) return 'expert';

  if (currentPlan === 'scale') {
    return 'scale';
  }
  const nextPlanToUpgrade = planOrder[planOrder.indexOf(currentPlan) + 1];

  return nextPlanToUpgrade as SubscriptionPlan;
};

export const getMlaMonthName = (monthName: string) => {
  try {
    const monthIndex: number = shortMonthNames
      .map(month => month.toLowerCase())
      .indexOf(monthName.toLowerCase());
    if (monthIndex === -1) {
      return monthName;
    }
    return mlaMonthsShort[monthIndex];
  } catch (err) {
    return monthName;
  }
};

// This function handles the tooltip click detection.
// As the tooltip is rendered from outside of the root, the clickaway don't detect the click by default
export const handleOutsideTooltipClick = (
  event: MouseEvent | TouchEvent,
  tooltipOpen: boolean,
  action: (open: boolean) => void
) => {
  const target = event.target as HTMLElement;
  const isTooltip = target.closest && target.closest('.MuiTooltip-tooltip');

  if (tooltipOpen && !isTooltip) {
    action(false);
  }
};

export const processIndividualListingData = listingData => {
  const revPAN = listingData['active_days_count_ltm']
    ? Math.round(listingData['annual_revenue_ltm'] / listingData['active_days_count_ltm'])
    : 0;
  const revenueFromCleaningFeeLTM = listingData['cleaning_fee']
    ? Math.round(listingData['cleaning_fee'] * listingData['no_of_bookings_ltm'])
    : 0;

  return {
    accommodates: listingData['accommodates'],
    activeDaysCount: listingData['active_days_count_ltm'],
    adrLTM: listingData['avg_booked_daily_rate_ltm'],
    amenities: listingData['amenities'],
    annualRevenueLTM: listingData['annual_revenue_ltm'] ? listingData['annual_revenue_ltm'] : 'N/A',
    bathrooms: listingData['bathrooms'],
    bedrooms: listingData['bedrooms'],
    cancellation_policy: listingData['cancellation_policy'],
    cleaningFee: listingData['cleaning_fee'],
    extraGuestFee: listingData['extra_fee_person_estimate'],
    hasLicense: listingData['license'] === 't' ? true : false,
    hostId: listingData['host_id'],
    hostListingCount: listingData['hostListingCount'],
    host_name: listingData['host_name'],
    last_seen: listingData['last_seen'],
    latitude: listingData['latitude'],
    listingID: listingData['listingID'],
    longitude: listingData['longitude'],
    minimum_nights: listingData['minimum_nights'],
    name: listingData['name'],
    numberOfBookingsLTM: listingData['no_of_bookings_ltm'],
    occupancyRateLTM: Math.min(listingData['avg_occupancy_rate_ltm'], 95),
    property_type: listingData['room_and_property_type'],
    revPAN: revPAN,
    revenueFromCleaningFeeLTM: revenueFromCleaningFeeLTM,
    revenuePotential: listingData['revenue_potential'],
    review_scores_rating: round(listingData['reveiw_scores_rating'] / 20),
    room_type: listingData['room_and_property_type'],
    thumbnail_url: listingData['thumbnail_url'],
    visible_review_count: listingData['visible_review_count'],
    rest_thumbnails: listingData['thumbnail_url_extended'],
    markerType: 'full',
    visible: true,
    bookings: [],
    historicalMonthlyPerformance: {} as any,
    added_on: '',
    bookingComURL: listingData['booking_com_url'] || null,
    vrboURL: listingData['vrbo_url'] || null,
  } as Listing;
};

export function formatDate(dateStr: string): string {
  const dateObj = new Date(dateStr);

  if (isNaN(dateObj.getTime())) {
    throw new Error('Invalid date format');
  }

  // Get day and determine suffix
  const day: number = dateObj.getDate();
  const suffix: string =
    day >= 11 && day <= 13
      ? 'th'
      : day % 10 === 1
      ? 'st'
      : day % 10 === 2
      ? 'nd'
      : day % 10 === 3
      ? 'rd'
      : 'th';

  // Get full month name
  const options: Intl.DateTimeFormatOptions = { month: 'long', year: 'numeric' };
  const formattedMonthYear: string = dateObj
    .toLocaleDateString('en-US', options)
    .split(' ')
    .join(',');

  return `${day}${suffix} ${formattedMonthYear}`;
}

export const getUserPreferredCurrency = (defaultCurrency: string) => {
  const userSavedCurrency = localStorage.getItem('user-preferred-currency');

  if (userSavedCurrency && exchangeRates[userSavedCurrency]) {
    return userSavedCurrency;
  }

  return defaultCurrency;
};

export const checkIfSettingPage = () => {
  return window.location.pathname.includes('/user/settings');
};

export const setCookie = (name: string, value: string): void => {
  try {
    const hostname = window.location.hostname;
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
    const isProduction = hostname.endsWith('airbtics.com'); // Covers airbtics.com & app.airbtics.com

    // Expiration time = 10 years
    const maxAge = 60 * 60 * 24 * 365 * 10; // 10 years in seconds

    let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(
      value
    )}; max-age=${maxAge}; path=/`;

    // Set domain for cross-subdomain access only in production
    if (isProduction) {
      cookieString += '; domain=.airbtics.com';
    }

    // Set SameSite policy based on environment
    if (isLocalhost) {
      cookieString += '; SameSite=Lax'; // Avoid restrictions on localhost
    } else {
      cookieString += '; SameSite=None'; // Required for cross-domain access
    }

    // Secure flag only for production (HTTPS required)
    if (!isLocalhost) {
      cookieString += '; Secure';
    }

    // Set the cookie
    document.cookie = cookieString;
  } catch (err) {
    console.error('Error while setting up cookie: ', err);
  }
};

export const closeKeyboard = () => {
  try {
    const activeElement = document.activeElement as HTMLElement | null;

    if (activeElement?.tagName === 'INPUT') {
      (activeElement as HTMLInputElement).blur();
    }
  } catch (err) {
    console.log('Error from closing the keyboard: ', err);
  }
};

export const formatUrl = (url: string) => {
  if (!url) return '';
  return url.startsWith('http') ? url : `https://${url}`;
};

const getCreditUsedThisMonth = (monthlyDict: Record<string, string[]>): number => {
  const now = new Date();
  const currentMonthKey = `${String(now.getMonth() + 1).padStart(2, '0')}-${now.getFullYear()}`; // Format: 'MM-YYYY'
  const marketsThisMonth = monthlyDict[currentMonthKey] || [];
  return marketsThisMonth.length;
};

export const getUserRemainingTopHostUnlockCredits = (user: User): number => {
  const userRemainingTopHostUnlockCredits = user.user_subscribed_market_wise_top_host_monthly;
  if (!userRemainingTopHostUnlockCredits) return 0;

  const creditUsedThisMonth = getCreditUsedThisMonth(userRemainingTopHostUnlockCredits);
  const usageLimit = MONTHLY_TOP_HOST_LIMIT[user.subscriptionPlan];
  if (!usageLimit) {
    return 0;
  }

  const remainingCredits = usageLimit - creditUsedThisMonth;
  return remainingCredits;
};

export const getCoordinatesFromWKT = (wktBoundaryString: string) => {
  const coordinates = wktBoundaryString
    .replace('POLYGON ((', '')
    .replace('))', '')
    .split(',')
    .map(coord =>
      coord
        .trim()
        .split(' ')
        .map(Number)
    );
  return coordinates;
};

export const generateWKTPolygon = (coordinates: number[][]) => {
  return `POLYGON ((${coordinates.map(coord => `${coord[0]} ${coord[1]}`).join(',')}))`;
};

export const getBoundsFromCoordinates = (coordinates: number[][]) => {
  const bounds = bbox(turf.polygon([coordinates]));
  const boundsObj = {
    northEast: { lat: bounds[3], lng: bounds[2] },
    southWest: { lat: bounds[1], lng: bounds[0] },
  };
  return boundsObj;
};

export const calculatePercentiles = (data, quantiles = [0.25, 0.5, 0.75, 0.9]) => {
  if (data.length > 0) {
    data = data.filter(d => d !== null);
    return quantiles.map(q => d3.quantile(data.sort(d3.ascending), q));
  } else {
    // Return an array of zeros if the input array is empty
    return Array(quantiles.length).fill(0);
  }
};

export const removeAccent = (str: string): string => {
  if (!str) return '';
  return str
    .normalize('NFD') // decompose combined letters
    .replace(/[\u0300-\u036f]/g, ''); // remove diacritical marks
};

export const getLicenseStatus = (licensePercentage: number | null | undefined) => {
  if (licensePercentage === null || licensePercentage === undefined) {
    return '-';
  }
  return licensePercentage >= 50 ? 'Strict' : 'Lenient';
};

export const setUserDataToMailChimp = (fields: Array<[string, string | boolean]>) => {
  try {
    const URL =
      'https://fn7crazpf6.execute-api.us-east-2.amazonaws.com/default/handleMailChimpOpertations';
    return callApi(URL, { body: fields }, true, false, '', 'POST', true);
  } catch (err) {
    console.log('Error while setting user data to MailChimp: ', err);
    return (err as any)?.message;
  }
};

export const normalizeCountryKey = (value: string) => value.toLowerCase().replace(/[\s-]/g, '');

export const buildCountryLookupMaps = (countryMap: Record<string, string>) => {
  const lookupByName: Record<string, { name: string; code: string }> = {};
  const lookupByCode: Record<string, { name: string; code: string }> = {};

  for (const code in countryMap) {
    const name = countryMap[code];
    const normalizedName = normalizeCountryKey(name);
    const normalizedCode = normalizeCountryKey(code);
    lookupByName[normalizedName] = { code, name };
    lookupByCode[normalizedCode] = { code, name };
  }

  return { lookupByName, lookupByCode };
};

export const getCountryFromReportData = (
  reportData: any,
  checkBestMarketBlogURLOnly: boolean = false
): string => {
  const address = reportData?.primary_input?.address_full;
  if (!address || typeof address !== 'string') return '';

  const parts = address.split(',').map(part => part.trim());
  const rawCountry = parts[parts.length - 1];
  const key = normalizeCountryKey(rawCountry);

  const primaryLookup = buildCountryLookupMaps(BEST_AIRBNB_MARKET_COUNTRY_CODE_MAP);
  const secondaryLookup = checkBestMarketBlogURLOnly
    ? buildCountryLookupMaps(BEST_AIRBNB_MARKET_COUNTRY_CODE_MAP)
    : buildCountryLookupMaps(ALL_COUNTRY);

  const match =
    primaryLookup.lookupByName[key] ||
    primaryLookup.lookupByCode[key] ||
    secondaryLookup.lookupByName[key] ||
    secondaryLookup.lookupByCode[key];

  if (match) return match.name;

  const alias = COUNTRY_ALIASES[key];
  if (!alias) return '';

  const aliasKey = normalizeCountryKey(alias);

  return (
    primaryLookup.lookupByName[aliasKey]?.name || secondaryLookup.lookupByName[aliasKey]?.name || ''
  );
};

export const getBestMarketBlogURLByCountry = (country: string) => {
  const countrySlug = country.toLowerCase().replace(/ /g, '-');
  if (!countrySlug) return '';
  const prefix = BEST_MARKET_BLOGS_WITH_THE_PREFIX.includes(countrySlug) ? 'the-' : '';
  return `https://airbtics.com/best-airbnb-markets-${prefix}${countrySlug}`;
};

export const handleRedirectAfterSignup = (
  userDescription: string,
  userSubDescription: string,
  history: any,
  defaultRedirectUrl: string
) => {
  // Check for special no-redirection cases
  const isCalculatorPage = /\/airbnb-calculator\/.+/.test(defaultRedirectUrl || '');
  const isDemoMarketPage = defaultRedirectUrl?.includes('/airbnb-data/') && isDemoMarket();
  const shouldSkipRedirect =
    isCalculatorPage || (userSubDescription === 'neighborhood_research' && !isDemoMarketPage);

  // Special handling for new property investors
  if (userDescription === 'new_property_investor') {
    switch (userSubDescription) {
      case 'market_research':
        // Store a flag to show tutorial modal on markets/compare page
        localStorage.setItem('show_market_compare_tutorial', 'true');
        if (!shouldSkipRedirect) {
          history.push('/markets/compare');
        }
        break;

      case 'neighborhood_research':
        // Store a flag to show neighborhood research tutorial
        localStorage.setItem('show_neighborhood_tutorial', 'true');
        if (!shouldSkipRedirect) {
          history.push('/airbnb-data/landing');
        }
        break;

      case 'revenue_estimation':
        if (!shouldSkipRedirect) {
          history.push('/airbnb-calculator');
        }
        break;

      default:
        if (!shouldSkipRedirect) {
          history.push(defaultRedirectUrl || RoutesMap.Home);
        }
    }
  } else {
    // For all other cases, use the existing redirection logic
    if (!shouldSkipRedirect) {
      history.push(
        userDescription === 'property_manager'
          ? RoutesMap.Pricing
          : defaultRedirectUrl || RoutesMap.Home
      );
    }
  }

  if (shouldSkipRedirect) {
    window.location.pathname = defaultRedirectUrl || '/airbnb-data';
  }
};
export const getYearlyUpgradeFinalDueAmount = async (
  userSubscriptionPlan,
  userSubscriptionCurrency,
  setFinalDueAmount
) => {
  setFinalDueAmount(null);

  try {
    const url =
      'https://9s2r54r64l.execute-api.us-east-2.amazonaws.com/default/upgradeStripeSubscription';
    const testProductID = 'price_1RGzX9BVoeq938b5bWvnnJrw';
    const config = {
      queryParams: {
        newProductID: ProductIDOptions[userSubscriptionPlan].productID['yearly'],
        // newProductID: testProductID,
        newProductName: userSubscriptionPlan,
        newDuration: 'yearly',
        operation: 'fetch_yearly_discounted_price_from_cancellation',
        currency: userSubscriptionCurrency,
        cancellation_discount: true,
        // isTest: true,
      },
    };
    const resp = await callApi(url, config, true);
    const dueAmount = resp.yearly_discounted_price_from_cancellation;
    if (dueAmount && !isNaN(Number(dueAmount))) {
      setFinalDueAmount(dueAmount);
    } else {
      setFinalDueAmount(null);
    }
  } catch (err) {
    setFinalDueAmount(null);
  }
};
